import {globalUser} from "./globals.js"
import {
    addSegmentItemSegments,
    getSegmentItemCompany,
    getSegmentItemSegments,
    SegmentItem
} from "../models/segmentItem.js";
import {
    db,
    Superstars,
    TagTeams,
    Brands,
    Factions,
    Feuds,
    Segments,
    SegmentItems,
    FeudParticipantsHash,
    SegmentParticipantsHash,
    FeudSegmentsHash,
    Championships,
    CompanyLogs,
    Companies,
    Relationships, TalentRequests, ChampionshipReigns, loadDb
} from "../models/models.js";
import {
    checkAreObjArraysEqual,
    commaSeparate,
    findNameInString,
    generateName,
    getArrayMaxByProperty,
    getCurrentGame,
    getMatchOrSegmentName,
    getMonthsDifference,
    getRandomChoice,
    getRandomInt,
    getRosterMemberAge,
    getRosterMemberOverness,
    getRosterMemberPopularity,
    getRosterMemberPronoun,
    getRosterMemberRank,
    getTalentAgeMultiplier,
    getMoraleText,
    getUniqueObjects,
    limitValueBetweenRange,
    objectInArray,
    getOvernessText,
    myround,
    getRandomUniform,
    weightedChoice,
    getRandomSample,
    gameLimits,
    captureError, decimalRound
} from "./helpers.js";
import {getGameCurrentUserCompany, getGameMainUserCompany} from "./games.js";
import {
    addCompanyCompanyLogs, addCompanyMessages, addCompanyNewsItems,
    addCompanySegmentItems, getCompanyChampionships, getCompanyCompanyLogs, getCompanyEvents,
    getCompanyFacilities, getCompanyFeudItems,
    getCompanyGame, getCompanyObjectives, getCompanyPowerups, getCompanyRosters,
    getCompanySegmentItems,
    getCompanyStaff, getCompanyTournaments
} from "../models/company.js";
import {getMatchEventTitle} from "./matches.js";
import {
    addSegmentFeuds,
    addSegmentParticipants,
    getSegmentEvent,
    getSegmentFeuds,
    getSegmentParticipants,
    getSegmentSegmentItem, getSegmentTagTeams,
    Segment
} from "../models/segment.js";
import {
    addEventSegments,
    getEventCompany,
    getEventMatches,
    getEventSegments
} from "../models/event.js";
import {
    addFormerCompanyRelationship,
    changeProperty,
    checkFacilityUpgrade,
    checkObjectHot,
    checkObjectStale,
    getActiveCompetitorsForCompany,
    getAvailableStaffMembers,
    getAvailableStaffMembersByRole, getChampionshipPopularityIncrease,
    getCompanyLatestEvent,
    getCompanyParentEvents,
    getCompanyRosterByType, getCompanyUnreadMessages,
    getHighestLevelStaffMemberByRole,
    getRandomStaffMemberByRole,
    getStaffAgeMultiplier,
    getStaffMemberGraphic,
    processChampionshipXpChange,
    processObjectiveCompleted,
    removeStaffTaskData,
    updateStaffMemberXp
} from "./companies.js";
import {
    addRosterFactions,
    addRosterFeuds,
    addRosterSuperstars,
    addRosterTagTeams,
    getRosterBrands,
    getRosterFactions,
    getRosterSuperstars,
    getRosterTagTeams
} from "../models/roster.js";
import {
    generateRandomFeudItemName,
    getFeudCreationBoosts,
    getFeudData, getFeudRating, getMatchesForStaleFeud,
    getParticipantFeuds,
    getRosterMemberFeuds
} from "./feuds.js";
import {
    getEventMatchesAndSegments,
    getEventMaximumMatchesAndSegments,
    getEventTitle, getUpcomingMonthlyEventForWeeklyEvent
} from "./events.js";
import {addTagTeamSuperstars, getTagTeamSuperstars, TagTeam} from "../models/tagTeam.js";
import {
    checkAcquireTrait,
    checkAvailability,
    checkSuperstarBrandAvailability,
    checkSuperstarGraphicMask,
    debutGimmick,
    getGraphicForSuperstar,
    getKayfabePointsChange,
    getRankFromPopularity,
    getRosterMemberSuperstars,
    getSuperstarActiveFactions,
    getSuperstarChampionshipsFromCompanyChampionships,
    getSuperstarChampionshipsToVacate,
    getSuperstarCharisma,
    getSuperstarDisplayData,
    getSuperstarManagerGraphic,
    getSuperstarManagerUsedForMatchOrSegment,
    getSuperstarMatchOrSegmentData,
    getSuperstarMoraleChange,
    updateSuperstarKayfabePoints,
    updateSuperstarMorale,
    updateSuperstarPopularity,
    addKayfabeInjuryToSuperstar,
    changeSuperstarMoraleToUnhappy,
    removeSuperstarTagTeams,
    removeSuperstarFactionRelationships,
    removeSuperstarManagerRelationships,
    changeSuperstarMoraleToHappy,
    vacateChampionships,
    removeSuperstarGraphicMask,
    addNextGimmickBoost,
    removeSuperstarsFromManager,
    addSuperstarsToManager, retireSuperstar
} from "./superstars.js";
import {getTagTeamDisplayData, removeTagTeam} from "./tagTeams.js";
import {segmentItemsOrder, specialSegmentCelebritiesData} from "../data/segments.js";
import {
    checkAreChampionshipsEqual,
    checkChampionshipSegmentItemsToUnlock,
    getChampionshipXpChange,
    getUniqueChampionships,
    getChampionshipMatchData,
    runCustomizeChampionshipAction,
    runSplitChampionshipAction,
    runOptionCAction,
    unifyChampionships
} from "./championships.js";
import {
    addFeudFactions,
    addFeudSuperstars, addFeudTagTeams,
    getFeudFeudItem,
    getFeudParticipants,
    getFeudSegments
} from "../models/feud.js";
import {
    addSuperstarChampionshipReigns,
    addSuperstarChampionships,
    getSuperstarChampionships,
    getSuperstarCurrentGimmick, getSuperstarFactions,
    getSuperstarManagedSuperstars, getSuperstarRelationships,
    getSuperstarTagTeams, getSuperstarTalentRequests
} from "../models/superstar.js";
import {
    getRosterActiveFactions,
    getFactionSuperstarsForSegment,
    processFactionXpChangeForSuperstar, removeFactionLeader, disbandFaction, processFactionXpChangeForFaction,
    getFactionCreationReputationAndXp, createFaction
} from "./factions.js";
import {getManagerManagedTalent, setManagersForMatchOrSegment} from "./managers.js";
import {
    getFactionLeaderSuperstar,
    getFactionSuperstars,
    addFactionSuperstars,
    removeFactionSuperstars,
    setFactionLeaderSuperstar
} from "../models/faction.js";
import {
    addChampionshipChampionshipReigns,
    getChampionshipChampionshipReigns, getChampionshipMatchContract} from "../models/championship.js";
import {
    checkCharacterToUnlock,
    checkFeudHot, checkFeudItemsToUnlock,
    getGimmickEffectivenessChange,
    getParticipantManagersData, progressGimmick,
    unlockSpecialSegment, updateMatchOrSegmentGraphics
} from "./processMatch.js";
import {CompanyLog} from "../models/companyLog.js";
import {checkTalentRequestAction} from "./talentRequests.js";
import {traitsData} from "../data/traits.js";
import {generateNewsItem} from "./news.js";
import {
    createPowerupMessage,
    createPresidentOverSuperstarMessage,
    createSuperstarLevelUpMessage,
    createSuperstarMarkedOutMessage,
    createGimmickChangeBoostMessage, createTalentReleasedMessage, createIntroduceSpecialSegmentsMessage
} from "./messages.js";
import {getRelationshipCompany} from "../models/relationship.js";
import {turnRosterMember} from "./rosters.js";
import {getMatchParticipants} from "../models/match.js";
import {ChampionshipReign} from "../models/championshipReign.js";
import {Feud} from "../models/feud.js";
import {addFeudItemFeuds} from "../models/feudItem.js";
import {draftSuperstarToBrand} from "./brands.js";
import {addTalentMatchContracts} from "../models/matchContract.js";
import {
    generateStaffGraphic,
    generateStaffMember,
    generateStaffName,
    generateTagTeam,
    generateTrio
} from "./generate.js";
import {awardPowerup, getPowerupsToUnlock} from "./powerups.js";
import {loadUser} from "./user.js";
import {processPowSuperstarLeavesCompany} from "./passionOfWrestling.js";
import {checkToGoToNextTutorialState} from "./tutorial.js";


async function getSpecialSegmentsData() {  // Previously get_special_segments
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    if (userCompany.storyName === 'mars') {
        return {'error': 'wom'};
    }

    // Get special segments
    const specialSegments = (await getCompanySegmentItems(userCompany)).filter(x => x.special);

    // Get data
    return Promise.all(specialSegments.map(x => getSegmentItemData(x, true)));
}

async function getSegmentItemData(segmentItem, checkBooked = false) {  // Previously get_segment_item_data
    const baseHypes = {1: 3, 2: 8, 3: 15};
    const basePopularities = {1: 5, 2: 10, 3: 18};

    // Copy data
    let data = JSON.parse(JSON.stringify(segmentItem));
    data['uid'] = segmentItem.$loki;

    data['hypeBoost'] = baseHypes[segmentItem.hypeBoost] || 0;
    data['popularityBoost'] = basePopularities[segmentItem.popularityBoost] || 0;

    // Check if special segment was booked, for viewing history
    if (checkBooked) {
        data['booked'] = (await getSegmentItemSegments(segmentItem)).filter(x => x.rating !== null).length > 0
    }

    return data;
}

async function getSpecialSegmentHistoryData(uid) {  // Previously get_special_segment_history
    let data = {};
    const game = await getCurrentGame();
    const company = await getGameCurrentUserCompany(game);
    const segmentItem = await SegmentItems.get(uid);
    const segment = (await getSegmentItemSegments(segmentItem)).filter(x => x.rating !== null).reverse()[0];
    let participants = await getSegmentParticipants(segment);

    // Get segment data
    data['name'] = segmentItem.name;
    data['segmentType'] = 'segment';
    data['special'] = segmentItem.special;
    data['uid'] = segment.$loki;

    // Get pronouns
    data['pronouns'] = [];
    for (const p of participants) {
        data['pronouns'].push({
            'name': p.name, 'pronoun': getRosterMemberPronoun(p),
            'possessivePronoun': getRosterMemberPronoun(p, 'possessive'),
            'objectivePronoun': getRosterMemberPronoun(p, 'objective')
        });
    }

    // Add graphics for participants
    data['graphics'] = participants.map(x => getGraphicForSuperstar(x));

    // Add special segment data
    const superstarRandom = new Math.seedrandom(participants[0].meta.created);
    if (segmentItem.name === 'Timely Rescue') {
        // Get a staff member's data
        const staffMembers = await getCompanyStaff(company);
        const availableStaffMembers = getAvailableStaffMembers(staffMembers);
        let staffMember;
        if (staffMembers.length > 0) {
            if (availableStaffMembers.length > 0) {
                staffMember = getRandomChoice(availableStaffMembers, superstarRandom())
            }
            else {
                staffMember = getRandomChoice(staffMembers, superstarRandom())
            }
        }
        else {
            // Generate if none found
            const generatedStaffGender = getRandomChoice(['male', 'female', 'non-binary']);
            staffMember = {'name': generateStaffName(null, generatedStaffGender),
                'gender': generatedStaffGender, 'graphic': generateStaffGraphic(generatedStaffGender)};
        }
        data['pronouns'].push({'name': staffMember.name, 'pronoun': getRosterMemberPronoun(staffMember),
            'possessivePronoun': getRosterMemberPronoun(staffMember, 'possessive'),
            'objectivePronoun': getRosterMemberPronoun(staffMember, 'objective')});
        data['graphics'].push(getStaffMemberGraphic(staffMember))
    }
    if (segmentItem.name === 'Celebrity Beatdown') {
        // Get a celebrity's data
        const celebrity = getRandomChoice(specialSegmentCelebritiesData, superstarRandom());
        data['pronouns'].push({'name': celebrity['name'], 'possessivePronoun': celebrity['possessivePronoun']});
    }
    if (segmentItem.name === 'Love Making') {
        // Get partner's pronoun
        const participantPronoun = participants[0].pronoun;
        let partnerPronoun;
        if (getRandomInt(0, 100, superstarRandom()) <= 16) {
            partnerPronoun = participantPronoun
        }
        else {
            if (participantPronoun === 'he') {
                partnerPronoun = 'she'
            }
            else if (participantPronoun === 'she') {
                partnerPronoun = 'he'
            }
            else {
                partnerPronoun = getRandomChoice(['he', 'she'], superstarRandom())
            }
        }
        data['pronouns'].push({'partnerPronoun': partnerPronoun});
    }
    if (segmentItem.name === 'Helicopter Raid') {
        // Get a competitor's name
        const competitors = await getActiveCompetitorsForCompany(company, game);
        let competitorName;
        if (competitors.length > 0) {
            competitorName = getRandomChoice(competitors, superstarRandom()).name
        }
        else {
            competitorName = 'our competitor'
        }
        data['pronouns'].push({'name': competitorName});
    }

    return data;
}

async function getSegmentData({segment, pronouns = false, play = false, history = false, rosterSuperstars = null,
                              producers = null} = {}) {  // get_segment_data
    let data = {};
    const segmentItem = await getSegmentSegmentItem(segment);
    let company = await getSegmentItemCompany(segmentItem);
    const segmentEvent = await getSegmentEvent(segment);
    if (!company) {
        company = await getEventCompany(segmentEvent)
    }
    const game = await getCompanyGame(company);
    let participants = await getSegmentParticipants(segment);
    const segmentFeuds = await getSegmentFeuds(segment);
    const mainRoster = await getCompanyRosterByType(company, 'main');
    if (!rosterSuperstars) {
        rosterSuperstars = await getRosterSuperstars(mainRoster)
    }

    // Get participants type
    if (participants.length > 0) {
        data['participantsType'] = participants[participants.length - 1].objectName === 'superstar' ? 'singles' : 'tag';
    }

    // Get segment data
    data['name'] = segmentItem.name;
    data['rating'] = segment.rating;
    data['feuds'] = await Promise.all(segmentFeuds.map(x => getFeudData(x, true)));
    data['participantsNumber'] = participants.length;
    data['segmentType'] = 'segment';
    data['chooseWinner'] = segmentItem.chooseWinner;
    data['consequence'] = segmentItem.consequence;
    data['productionSegment'] = segmentItem.productionSegment;
    data['startTexts'] = segmentItem.startTexts;
    data['actionTexts'] = segmentItem.actionTexts;
    data['text'] = segmentItem.text;
    data['special'] = segmentItem.special;
    data['order'] = segment.order;
    data['hype'] = segment.hype;
    data['hidden'] = segment.hidden;
    data['uid'] = segment.$loki;
    data['consequenceAppliedTo'] = segment.consequenceAppliedTo;
    data['event'] = getEventTitle(segmentEvent);
    data['played'] = segment.rating !== null;

    // Get producer if assigned
    if (producers) {
        const segmentProducer = getSegmentProducer(segment, producers);
        if (segmentProducer) {
            data['producerName'] = segmentProducer.name
        }
    }

    // Sort superstars for segments
    if (pronouns && !history) {
        data['pronouns'] = [];

        // Sort participants
        await sortSegmentParticipants(segment, participants, segmentItem, company, game);

        // Add pronoun data
        for (const p of participants) {
            data['pronouns'].push({
                'name': p.name, 'pronoun': getRosterMemberPronoun(p),
                'possessivePronoun': getRosterMemberPronoun(p, 'possessive'),
                'objectivePronoun': getRosterMemberPronoun(p, 'objective')
            });
        }

        // Add extra pronouns
        const [extraPronounsData, usePatreonSuperstar] = await addSegmentExtraPronouns(data['pronouns'], segment,
            participants, segmentItem, mainRoster, company, game);
        data['pronouns'] = extraPronounsData;
        data['usePatreonSuperstar'] = usePatreonSuperstar;
    }

    // Get participants data
    data['graphics'] = [];
    data['participants'] = [];
    if (participants.length > 0 || history) {
        if (play) {
            // Get all data when playing
            for (const x of participants) {
                let participantData;
                if (x.objectName === 'superstar') {
                    participantData = await getSuperstarDisplayData({superstar: x, getCurrentAttire: true,
                        managersUsed: segment.managersUsed, rosterSuperstars: rosterSuperstars, game: game});
                    data['graphics'].push(participantData['graphic']);
                }
                else {
                    participantData = await getTagTeamDisplayData({tagTeam: x, getCurrentAttire: true,
                        managersUsed: segment.managersUsed, rosterSuperstars: rosterSuperstars});
                    data['graphics'].push(...participantData['graphics']);
                }
                data['participants'].push(participantData);

                // Add manager graphic
                for (const y of (await getRosterMemberSuperstars(x))) {
                    const superstarManager = await getSuperstarManagerUsedForMatchOrSegment(y, segment.managersUsed,
                        rosterSuperstars);
                    if (superstarManager) {
                        const superstarManagerGraphic = getSuperstarManagerGraphic(superstarManager, y);
                        data['graphics'].push(superstarManagerGraphic);
                    }
                }
            }
        }
        else if (history) {
            // Get history data
            if (segment.participants) {
                data['participants'] = segment.participants;
            }
            else {
                data['participants'] = participants.map(x => x.name);
            }

            // Add manager names for participants in history
            data['participantsDetails'] = [];
            for (const x of participants) {
                const managerNames = [];
                for (const s of (await getRosterMemberSuperstars(x))) {
                    const superstarManager = await getSuperstarManagerUsedForMatchOrSegment(s, segment.managersUsed,
                        rosterSuperstars);
                    if (superstarManager && !managerNames.includes(superstarManager.name)) {
                        managerNames.push(superstarManager.name)
                    }
                }
                data['participantsDetails'].push({'name': x.name, 'managerNames': managerNames})
            }

            // Check for manager segment
            data['managerSegment'] = ['boost-managed-talent', 'add-manager', 'remove-manager', 'remove-managed-talent']
                .includes(segmentItem.consequence);
        }
        else {
            // Get specific data for displaying in event card
            for (const x of participants) {
                let participantData;
                if (x.objectName === 'superstar') {
                    participantData = await getSuperstarMatchOrSegmentData(x, [], segment.managersUsed, rosterSuperstars);
                }
                else {
                    const participantSuperstarsData = await Promise.all((await getTagTeamSuperstars(x))
                        .map(y => getSuperstarMatchOrSegmentData(y, [], segment.managersUsed, rosterSuperstars)));
                    participantData = {'name': x.name, 'members': participantSuperstarsData, 'uid': x.$loki}
                }
                data['participants'].push(participantData);
            }
        }

        // Get team details
        if (!history && participants[0].objectName === 'tagTeam') {
            data['teamType'] = participants[0].trio ? 'trio' : 'tag-team';
            data['largerTag'] = (await getTagTeamSuperstars(participants[0])).length;
        }
    }

    // Add consequence data pronouns
    if (segment.consequenceData && Object.keys(segment.consequenceData).length !== 0 && !history) {
        data = await addSegmentConsequenceDataPronouns(data, segment, participants, segmentItem, mainRoster, pronouns,
            rosterSuperstars);
    }

    // Add pronouns for special segments
    if (segmentItem.special && play && !history) {
        data = await addSpecialSegmentPronouns(data, segment, participants, segmentItem, company, game);
    }

    return data;
}

async function sortSegmentParticipants(segment, participants, segmentItem, company, game) {
    if (['title-feud', 'champion'].includes(segmentItem.requirement)) {
        // Put champion last
        for (const x of participants) {
            let participantChampionships = [];
            for (const s of (await getRosterMemberSuperstars(x))) {
                let superstarChampionships = (await getSuperstarChampionships(s))
                    .filter(y => !y.matchContract && !y.championshipContract);
                if (x.objectName === 'superstar') {
                    superstarChampionships = superstarChampionships.filter(y => !y.trio && !y.tagTeam);
                }
                else {
                    superstarChampionships = superstarChampionships.filter(y => y.trio === x.trio && y.tagTeam === !x.trio);
                }
                participantChampionships.push(...superstarChampionships)
            }
            x.tempChampionships = participantChampionships;
        }
        participants.sort((a, b) => a.tempChampionships.length - b.tempChampionships.length);
        for (const x of participants) {
            delete x.tempChampionships;
        }
    }

    else if (segmentItem.requirement === 'contract-and-champion') {
        // Put contract holder first
        for (const x of participants) {
            let participantChampionships = [];
            for (const s of (await getRosterMemberSuperstars(x))) {
                let superstarChampionships = (await getSuperstarChampionships(s)).filter(y => y.championshipContract);
                if (x.objectName === 'superstar') {
                    superstarChampionships = superstarChampionships.filter(y => !y.trio && !y.tagTeam);
                }
                else {
                    superstarChampionships = superstarChampionships.filter(y => y.trio === x.trio && y.tagTeam === !x.trio);
                }
                participantChampionships.push(...superstarChampionships)
            }
            x.tempChampionships = participantChampionships;
        }
        participants.sort((a, b) => b.tempChampionships.length - a.tempChampionships.length);
        for (const x of participants) {
            delete x.tempChampionships;
        }
    }

    else if (['legend', 'legend-and-heel', 'legend-and-over-superstar'].includes(segmentItem.requirement)) {
        participants.sort((a, b) => a.hallOfFamer - b.hallOfFamer);
    }

    else if (segmentItem.requirement === 'award-winner') {
        const companyAwards = (await getCompanyCompanyLogs(company)).filter(x => x.type === 'award' && x.value > 0);

        function checkAwardWinners(p) {
            for (const awardWon of companyAwards) {
                if (awardWon.text.includes(p.name) && awardWon.realYear !== null) {
                    const monthsPassed = getMonthsDifference(game.monthCount, game.year, awardWon.month, awardWon.realYear);
                    if (monthsPassed < 3) {
                        return awardWon.$loki;
                    }
                }
            }
            return null;
        }

        participants.sort((a, b) => checkAwardWinners(b) - checkAwardWinners(a));
    }

    else if (segmentItem.requirement === 'injured-partner-and-singles-superstar') {
        let participantInTeam;
        for (const x of participants) {
            let t = (await getSuperstarTagTeams(x)).find(y => !y.temporary && !y.trio);
            if (t) {
                participantInTeam = x;
                break;
            }
        }
        participants.sort((a) => a.$loki === participantInTeam.$loki ? -1 : 1);
    }

    else if (segmentItem.requirement === 'heels-vs-face-singles') {
        participants.sort(a => a.alignment === 'face' ? -1 : 1);
    }

    else if (segmentItem.requirement === 'retiring') {
        for (const x of participants) {
            x.tempAge = await getRosterMemberAge(x);
        }
        participants.sort((a, b) => b.tempAge - a.tempAge);
        for (const x of participants) {
            delete x.tempAge;
        }
    }

    else if (segmentItem.requirement === 'masked-talent') {
        // Put masked superstar first
        for (const x of participants) {
            x.tempMasked = (await getRosterMemberSuperstars(x)).every(y => checkSuperstarGraphicMask(y.graphic));
        }
        participants.sort((a, b) => b.tempMasked - a.tempMasked);
        for (const x of participants) {
            delete x.tempMasked;
        }
    }

    else if (segmentItem.requirement === 'new-talent') {
        const newSuperstarLogs = (await getCompanyCompanyLogs(company))
            .filter(x => ['signing', 'callup', 'new-superstar', 'new-trade-superstar'].includes(x.type));

        function checkNewSuperstars(p) {
            for (const newSuperstarLog of newSuperstarLogs) {
                if (newSuperstarLog.text.includes(p.name) && newSuperstarLog.realYear !== null) {
                    const monthsPassed = getMonthsDifference(game.monthCount, game.year, newSuperstarLog.month,
                        newSuperstarLog.realYear);
                    if (monthsPassed < 3) {
                        return newSuperstarLog.$loki;
                    }
                }
            }
            return null;
        }

        participants.sort((a, b) => checkNewSuperstars(b) - checkNewSuperstars(a));
    }

    else if (segmentItem.requirement === 'returning-talent') {
        for (const x of participants) {
            x.tempReadyToReturn = (await getRosterMemberSuperstars(x)).some(y => y.readyToReturn);
        }
        participants.sort((a, b) => b.tempReadyToReturn - a.tempReadyToReturn);
        for (const x of participants) {
            delete x.tempReadyToReturn;
        }
    }

    else if (segment.consequenceAppliedTo) {
        if (segmentItem.requirement === 'face-vs-heel-past-feud') {
            const consequenceAppliedTo = participants.find(x => x.name === segment.consequenceAppliedTo);
            const remainingParticipants = participants.filter(x => x.$loki !== consequenceAppliedTo.$loki);
            const feuds = (await getRosterMemberFeuds(consequenceAppliedTo)).filter(y => y.started && y.ended);

            // Find who saving superstar is feuding with (gets most recent feuds first)
            let feudingWith;
            for (const feud of feuds) {
                const feudParticipants = await getFeudParticipants(feud);
                if (feudParticipants.length > 1 && feudParticipants.every(p => objectInArray(p, participants))) {
                    feudingWith = feudParticipants.find(x => objectInArray(x, remainingParticipants));
                    break;
                }
            }

            participants.sort((a, b) => {
                if (a.name === segment.consequenceAppliedTo) {
                    return -1;
                } else if (b.name === segment.consequenceAppliedTo) {
                    return 1;
                } else if (b.$loki === feudingWith.$loki) {
                    return 1;
                } else if (a.$loki === feudingWith.$loki) {
                    return -1;
                } else {
                    return 0;
                }
            });
        }
        else {
            participants.sort((a) => a.name !== segment.consequenceAppliedTo ? 1 : -1);
        }
    }
}

async function addSegmentExtraPronouns(pronounsData, segment, participants, segmentItem, mainRoster, company, game) {
    let usePatreonSuperstar;

    // Add injured superstar (can't add injured superstars in booking, only can add in this segment)
    if (segmentItem.requirement === 'inflicted-injury') {
        const injuries = (await getCompanyCompanyLogs(company)).filter(x => x.type === 'injury').reverse();
        for (const y of participants) {
            // Find participant name in injury logs
            const injuriesInflicted = injuries.filter(x => x.text.split(' injured ')[0].includes(y.name));
            for (const injury of injuriesInflicted) {
                const monthsPassed = getMonthsDifference(game.monthCount, game.year, injury.month, injury.year);
                if (monthsPassed < 2) {
                    const otherParticipantName = injury.text.split(' injured ')[1];
                    if (otherParticipantName) {
                        pronounsData.push({'name': otherParticipantName});
                        break;
                    }
                }
            }
        }
    }

    // Add participant turned on
    if (segmentItem.requirement === 'shocking-heel-turn') {
        const shockingTurns = (await getCompanyCompanyLogs(company)).filter(x => x.type === 'turn').reverse();
        for (const y of participants) {
            // Find participant name in shocking heel turns
            const shockingTurn = shockingTurns.find(x => x.text.includes('turned on') && x.text.includes(y.name));
            if (shockingTurn) {
                const otherParticipantName = shockingTurn.text.split(' turned on ')[1].split(' in ')[0];
                if (otherParticipantName) {
                    pronounsData.push({'name': otherParticipantName});
                }
            }
        }
    }

    // Add retired feud participant
    if (segmentItem.requirement === 'not-done-yet-potential-feud') {
        for (const y of participants) {
            for (const f of (await getRosterMemberFeuds(y))) {
                if (f.directFeudEvent === 'retirement-feud' && !f.started && !f.ended) {
                    const otherParticipant = (await getFeudParticipants(f)).find(x => !objectInArray(x, participants));
                    if (otherParticipant) {
                        pronounsData.push({'name': otherParticipant.name});
                    }
                }
            }
        }
    }

    // Add random superstar for local squash segment
    if (segmentItem.name === 'Local Squash') {
        usePatreonSuperstar = getRandomInt(0, 100) <= 25;
        let rosterMemberSuperstars = await getRosterMemberSuperstars(participants[0]);
        let randomOpponentsNames = rosterMemberSuperstars.map(x => generateName(x.gender, null, false, usePatreonSuperstar));
        let randomOpponentName = commaSeparate(randomOpponentsNames);
        pronounsData.push({'name': randomOpponentName});
    }

    // Add brand names for brand invasion segment
    if (segmentItem.requirement === 'other-brand-talent') {
        let segmentSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        pronounsData = [{'name': commaSeparate(segmentSuperstars.map(x => x.name))}];

        let currentEvent = await getSegmentEvent(segment);
        let brandName = currentEvent.brandName;
        if (!brandName && currentEvent.weeklyShow) {
            let rosterBrands = await getRosterBrands(mainRoster);
            brandName = rosterBrands.find(x => x.weeklyShowName === currentEvent.name)?.name;
        }
        let secondBrandName = segmentSuperstars.find(x => x.brandName && x.brandName !== brandName)?.brandName;

        if (brandName && secondBrandName) {
            pronounsData.push({'name': brandName});
            pronounsData.push({'name': secondBrandName});
        }
    }

    // Add data for buyout segment
    if (segmentItem.requirement === 'buyout-offer-accepted') {
        let competitor = (await getActiveCompetitorsForCompany(company, game))
            .find(x => x.operatingStatus.includes('Negotiating Buyout'));
        pronounsData = [{'name': company.ownerName ? company.ownerName : 'The Owner'}, {'name': competitor.name}];
    }

    // Combine participant names for promo battle / fight segments
    if (['Promo Battle', 'Fight'].includes(segmentItem.name)) {
        pronounsData = [{'name': commaSeparate(participants.map(x => x.name))}];
    }

    return [pronounsData, usePatreonSuperstar];
}

async function addSegmentConsequenceDataPronouns(data, segment, participants, segmentItem, mainRoster, pronouns, rosterSuperstars) {
    // Add faction segment data
    if (segmentItem.factionSegment) {
        data['factionSegment'] = true;

        // Add faction names
        data['pronouns'] = [{'name': commaSeparate(participants.map(x => x.name))}];

        // Add consequence superstars names and pronouns
        let segmentConsequenceSuperstars = [];
        for (const y of segment.consequenceData['superstarUids']) {
            const segmentConsequenceSuperstar = rosterSuperstars.find(x => x.$loki === y);
            if (segmentConsequenceSuperstar) {
                segmentConsequenceSuperstars.push(segmentConsequenceSuperstar);
            }
        }
        segmentConsequenceSuperstars = getUniqueObjects(segmentConsequenceSuperstars);
        if (segmentConsequenceSuperstars.length) {
            data['pronouns'].push({
                'name': commaSeparate(segmentConsequenceSuperstars.map(x => x.name)),
                'pronoun': segmentConsequenceSuperstars.length > 1 ? 'they' : segmentConsequenceSuperstars[0].pronoun,
                'possessivePronoun': segmentConsequenceSuperstars.length > 1 ? 'their' : segmentConsequenceSuperstars[0].possessivePronoun,
                'objectivePronoun': segmentConsequenceSuperstars.length > 1 ? 'them' : segmentConsequenceSuperstars[0].objectivePronoun
            });
            data['factionSuperstarsMultiple'] = segmentConsequenceSuperstars.length > 1;
        }

        // Add faction leader name and pronouns
        const factionUid = segment.consequenceData['factionUids']?.[0];
        const faction = factionUid ? await Factions.get(factionUid) : null;
        const factionLeader = faction ? await getFactionLeaderSuperstar(faction) : null;
        data['pronouns'].push({
            'name': factionLeader ? factionLeader.name : '',
            'pronoun': factionLeader ? factionLeader.pronoun : '',
            'possessivePronoun': factionLeader ? factionLeader.possessivePronoun : '',
            'objectivePronoun': factionLeader ? factionLeader.objectivePronoun : ''
        });

        // Add consequence faction
        const consequenceFactions = [];
        const rosterFactions = await getRosterFactions(mainRoster);
        for (const y of segment.consequenceData['factionConsequenceUids']) {
            const consequenceFaction = rosterFactions.find(x => x.$loki === y);
            if (consequenceFaction) {
                consequenceFactions.push(consequenceFaction);
            }
        }
        data['pronouns'].push({'name': commaSeparate(consequenceFactions.map(x => x.name))});

        // Add created faction name
        data['pronouns'].push({'name': segment.consequenceData['createdFactionName']});

        // Add graphics if create faction segment (as it has no participants)
        if (segmentItem.consequence === 'create-faction') {
            for (const s of segmentConsequenceSuperstars) {
                let superstarGraphic = getGraphicForSuperstar(s);
                delete superstarGraphic.uid;
                data['graphics'].push(superstarGraphic);
            }
        }
    }

    // Add brand segment data
    if (pronouns && segmentItem.consequence === 'draft-talent-to-brand') {
        let consequenceBrand;
        if (segment.consequenceData['brandUid']) {
            consequenceBrand = await Brands.get(segment.consequenceData['brandUid']);
        }
        if (consequenceBrand) {
            data['pronouns'].push({'name': consequenceBrand.name});
        }
    }

    // Add feud participant
    if (pronouns && segmentItem.requirement === 'feud-present') {
        let selectedFeud;
        if (segment.consequenceData['feudUid']) {
            selectedFeud = await Feuds.get(segment.consequenceData['feudUid']);
        }
        if (selectedFeud) {
            const feudParticipant = (await getFeudParticipants(selectedFeud))
                .find(y => !objectInArray(y, participants));
            if (feudParticipant) {
                data['pronouns'].push({
                    'name': feudParticipant.name,
                    'pronoun': feudParticipant.pronoun,
                    'possessivePronoun': feudParticipant.possessivePronoun,
                    'objectivePronoun': feudParticipant.objectivePronoun
                });
            }
        }
    }

    return data;
}

async function addSpecialSegmentPronouns(data, segment, participants, segmentItem, company, game) {
    let superstarRandom = new Math.seedrandom(participants[0].meta.created);

    if (segmentItem.name === 'Timely Rescue') {
        let staffMembers = await getCompanyStaff(company);
        if (staffMembers.length <= 0) {
            staffMembers.push(await generateStaffMember());
        }
        let availableStaffMembers = getAvailableStaffMembers(staffMembers);
        let staffMember;
        if (availableStaffMembers.length > 0) {
            staffMember = getRandomChoice(availableStaffMembers, superstarRandom());
        } else {
            staffMember = getRandomChoice(staffMembers, superstarRandom());
        }
        data['pronouns'].push({'name': staffMember.name});
        data['graphics'].push(getStaffMemberGraphic(staffMember));
    }

    if (segmentItem.name === 'Celebrity Beatdown') {
        let celebrity = getRandomChoice(specialSegmentCelebritiesData, superstarRandom());
        data['pronouns'].push({
            'name': celebrity.name,
            'possessivePronoun': celebrity.possessivePronoun
        });
    }

    if (segmentItem.name === 'Love Making') {
        // Get partner's gender
        let participantPronoun = participants[0].pronoun;
        let partnerPronoun;
        if (getRandomInt(0, 100, superstarRandom()) <= 16) {
            partnerPronoun = participantPronoun;
        } else {
            if (participantPronoun === 'he') {
                partnerPronoun = 'she';
            } else if (participantPronoun === 'she') {
                partnerPronoun = 'he';
            } else {
                partnerPronoun = getRandomChoice(['he', 'she'], superstarRandom());
            }
        }
        data['pronouns'].push({'partnerPronoun': partnerPronoun});
    }

    if (segmentItem.name === 'Helicopter Raid') {
        let competitors = await getActiveCompetitorsForCompany(company, game);
        let competitorName;
        if (competitors.length > 0) {
            competitorName = getRandomChoice(competitors, superstarRandom()).name
        } else {
            competitorName = 'our competitor';
        }
        data['pronouns'].push({'name': competitorName});
    }

    return data;
}

async function getSegmentHistoryData(segment) {
    let data = {};
    let segmentItem = await getSegmentSegmentItem(segment);

    if (segment.participants) {
        data['participants'] = segment.participants
    }
    else {
        let segmentParticipants = await getSegmentParticipants(segment);
        data['participants'] = segmentParticipants.map(x => x.name);
    }
    data['rating'] = segment.rating;
    data['event'] = await getMatchEventTitle(segment);
    data['name'] = segmentItem?.name;
    data['managerSegment'] = ['boost-managed-talent', 'add-manager', 'remove-manager', 'remove-managed-talent']
                .includes(segmentItem?.consequence);
    data['productionSegment'] = segmentItem?.productionSegment;

    return data;
}

function getSegmentProducer(segment, producers) {  // get_segment_producer
    return producers.find(x => x.taskData && x.taskData['segment_id'] === segment.$loki);
}

async function getAvailableSegmentItems() {  // get_available_segment_items
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const staffMembers = await getCompanyStaff(userCompany);

    // Get segment items, sort
    let segmentItems = await getCompanySegmentItems(userCompany);
    segmentItems.sort((a, b) => segmentItemsOrder.includes(a.name) - segmentItemsOrder.includes(b.name) ||
        segmentItemsOrder.indexOf(b.name) - segmentItemsOrder.indexOf(a.name) || b.$loki - a.$loki).reverse();

    // Get available segment items
    let availableSegmentItems = [];
    for (const x of segmentItems) {
        if (x.unlocked) {
            // Add faction/manager/brand segments only for paid users
            if (x.factionSegment || x.requirement === 'other-brand-talent' ||
                ['boost-managed-talent', 'add-manager', 'remove-manager', 'remove-managed-talent',
                'draft-talent-to-brand'].includes(x.consequence)) {
                if (globalUser.paid) {
                    availableSegmentItems.push(x)
                }
            }
            else {
                availableSegmentItems.push(x)
            }
        }
    }

    // Get unavailable segment items
    let unavailableSegmentItems = segmentItems.filter(x => !objectInArray(x, availableSegmentItems));

    // Get data for segment items
    data['availableSegmentItems'] = await Promise.all(availableSegmentItems.map(x => getSegmentItemData(x)));
    data['unavailableSegmentItems'] = await Promise.all(unavailableSegmentItems.map(x => getSegmentItemData(x)));

    // Check custom package requirement
    const productionFacility = (await getCompanyFacilities(userCompany)).find(x => x.name === 'Production');
    const producer = await getHighestLevelStaffMemberByRole(staffMembers, 'producer');
    if (productionFacility && productionFacility.level >= 3 && producer && producer.level >= 3) {
        data['customPackage'] = true
    }

    // Check tutorial action
    if (userCompany.storyName === 'tutorial') {
        data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['other_features']);
        db.saveDatabase();
    }

    return data;
}

async function createCustomProductionPackage({name, startText, actionTexts} = {}) {  // add_custom_production_package
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const segmentItems = await getCompanySegmentItems(userCompany);
    const staffMembers = await getCompanyStaff(userCompany);
    const cost = 30;

    // Check if enough points
    if (userCompany.points < cost) {
        data['error'] = 'not-enough-points';
        return data;
    }

    // Check if allowed to create custom package
    const productionFacility = (await getCompanyFacilities(userCompany)).find(x => x.name === 'Production');
    const producer = await getHighestLevelStaffMemberByRole(staffMembers, 'producer');
    if (!(productionFacility && productionFacility.level >= 3) || !(producer && producer.level >= 3)) {
        data['error'] = 'level';
        return data;
    }

    // Check if segment item name exists
    if (segmentItems.map(x => x.name).indexOf(name) >= 0) {
        data['error'] = 'name-exists';
        return data;
    }

    // Create segment item and add to company
    let newSegmentItem = createProductionPackageSegmentItem(name, [startText], actionTexts);
    await SegmentItems.insert(newSegmentItem);
    await addCompanySegmentItems(userCompany, [newSegmentItem]);

    // Remove points
    userCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['points'] = userCompany.points;
    data['name'] = newSegmentItem.name;

    return data;
}

function createProductionPackageSegmentItem(name, startTexts, actionTexts) {  // create_production_package_segment_item
    const segmentItem = SegmentItem();
    segmentItem.name = name;
    segmentItem.startTexts = startTexts;
    segmentItem.actionTexts = actionTexts;
    segmentItem.hypeBoost = 0;
    segmentItem.popularityBoost = 2;
    segmentItem.difficulty = 1;
    segmentItem.entertainment = 3;
    segmentItem.action = 0;
    segmentItem.maxParticipants = 1;
    segmentItem.minParticipants = 1;
    segmentItem.oneAtATime = true;
    segmentItem.productionSegment = true;
    segmentItem.custom = true;
    segmentItem.saveToCommunity = true;
    segmentItem.unlocked = true;
    segmentItem.chooseWinner = false;
    segmentItem.feudOnly = false;
    segmentItem.oneWayConsequence = false;
    segmentItem.requirement = 'level-1-producer';
    return segmentItem;
}

async function checkSegmentItemRequirement(segmentItem, participants, companyLogs, month, year, championships,
                                           availableStaffMembers, factions = []) {  // check_segment_item_requirement
    let data = {};

    // Get participants type
    let participantsType;
    if (participants.length > 0) {
        participantsType = participants[0].objectName
    }

    // Check for trio
    if (participantsType === 'tagTeam' && participants[0].trio) {
        participantsType = 'trio'
    }

    // Check for faction (while booking, participantsType is tagTeam for factions)
    if (participantsType === 'tagTeam' && factions.length > 0) {
        participantsType = 'faction'
    }

    // Define check functions
    async function titleFeudCheck() {
        for (const p of participants) {
            let titleFeuds = [];
            for (const feud of (await getRosterMemberFeuds(p))) {
                let feudItem = await getFeudFeudItem(feud);
                if (feud.started && !feud.ended &&
                    ['new-title-challenger', 'champions', 'long-title-reign', 'previous-title-feud',
                        'previous-champion', 'old-and-champion'].includes(feudItem.requirement)) {
                    titleFeuds.push(feud)
                }
            }
            for (const feud of titleFeuds) {
                let feudParticipants = await getFeudParticipants(feud);
                if (participants.every(x => objectInArray(x, feudParticipants))) {
                    return true;
                }
            }
        }
        return false;
    }

    async function vacantTitleCheck() {
        let vacatedChampionships = championships.filter(x => x.vacated && !x.booked);
        if (participantsType === 'superstar') {
            vacatedChampionships = vacatedChampionships.filter(x => !x.tagTeam && !x.trio);
            return vacatedChampionships.length > 0;
        }
        else if (participantsType === 'tagTeam' || participantsType === 'trio') {
            if (participantsType === 'tagTeam') {
                vacatedChampionships = vacatedChampionships.filter(x => x.tagTeam);
            }
            else if (participantsType === 'trio') {
                vacatedChampionships = vacatedChampionships.filter(x => x.tagTeam || x.trio);
            }
            return vacatedChampionships.length > 0;
        }
    }

    async function teamSuperstarsCheck() {
        if (participantsType === 'superstar') {
            let tagTeams = await getSuperstarTagTeams(participants[0]);
            for (const tagTeam of tagTeams) {
                let tagTeamMembers = await getTagTeamSuperstars(tagTeam);
                if (checkAreObjArraysEqual(tagTeamMembers, participants)) {
                    return true;
                }
            }
        }
        return false;
    }

    async function championCheck() {
        if (participantsType === 'superstar') {
            let participantsChampionships = (await Promise.all(participants.map(x => getSuperstarChampionships(x)))).flat();
            participantsChampionships = participantsChampionships.filter(x => !x.tagTeam && !x.trio);
            return participantsChampionships.length > 0;
        }
        else if (participantsType === 'tagTeam' || participantsType === 'trio') {
            let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
            let participantsChampionships = (await Promise.all(participantsSuperstars
                .map(x => getSuperstarChampionships(x)))).flat();
            if (participantsType === 'tagTeam') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam);
            }
            else if (participantsType === 'trio') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam || x.trio);
            }
            return participantsChampionships.length > 0;
        }
    }

    async function newChampionCheck() {
        if (participantsType === 'superstar') {
            let participantsChampionships = (await Promise.all(participants.map(x => getSuperstarChampionships(x)))).flat();
            participantsChampionships = participantsChampionships.filter(x => !x.tagTeam && !x.trio);
            for (const c of participantsChampionships) {
                let reigns = await getChampionshipChampionshipReigns(c);
                for (const r of reigns) {
                    if (r.endMonth === null && getMonthsDifference(month, year, r.startMonth, r.startYear) < 2) {
                        return true;
                    }
                }
            }
        }
        else if (participantsType === 'tagTeam' || participantsType === 'trio') {
            let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
            let participantsChampionships = (await Promise.all(participantsSuperstars
                .map(x => getSuperstarChampionships(x)))).flat();
            if (participantsType === 'tagTeam') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam);
            }
            else if (participantsType === 'trio') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam || x.trio);
            }
            for (const c of participantsChampionships) {
                let reigns = await getChampionshipChampionshipReigns(c);
                for (const r of reigns) {
                    if (r.endMonth === null && getMonthsDifference(month, year, r.startMonth, r.startYear) < 2) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    async function previousFeudsCheck() {
        let previousFeuds = [];
        let checkParticipants = participants;
        if (participantsType === 'faction' && factions.length) {
            checkParticipants = factions
        }
        for (const p of checkParticipants) {
            let feuds = (await getRosterMemberFeuds(p)).filter(x => x.started && x.ended);
            for (const feud of feuds) {
                let feudParticipants = await getFeudParticipants(feud);
                if (checkParticipants.every(x => objectInArray(x, feudParticipants))) {
                    previousFeuds.push(feud);
                }
            }
        }
        previousFeuds = getUniqueObjects(previousFeuds);
        return previousFeuds.length >= 1;
    }

    async function newTalentCheck() {
        let newTalentNames = [];
        for (const companyLog of companyLogs) {
            if (['signing', 'callup', 'new-superstar', 'new-trade-superstar'].includes(companyLog.type) &&
                !(newTalentNames.includes(companyLog.text)) && companyLog.realYear !== null) {
                if (getMonthsDifference(month, year, companyLog.month, companyLog.realYear) < 3) {
                    newTalentNames.push(companyLog.text)
                }
            }
        }
        return participants.some(x => newTalentNames.includes(x.name));
    }

    async function contractAndChampionCheck() {
        if (participantsType === 'superstar') {
            let participantsChampionships = (await Promise.all(participants.map(x => getSuperstarChampionships(x)))).flat();
            participantsChampionships = participantsChampionships.filter(x => !x.tagTeam && !x.trio);
            return participantsChampionships.some(x => !x.championshipContract) &&
                participantsChampionships.some(x => x.championshipContract);
        }
        else if (participantsType === 'tagTeam' || participantsType === 'trio') {
            let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
            let participantsChampionships = (await Promise.all(participantsSuperstars
                .map(x => getSuperstarChampionships(x)))).flat();
            if (participantsType === 'tagTeam') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam);
            }
            else if (participantsType === 'trio') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam || x.trio);
            }
            return participantsChampionships.some(x => !x.championshipContract) &&
                participantsChampionships.some(x => x.championshipContract);
        }
    }

    async function legendCheck() {
        return (participantsType === 'superstar' && participants.some(x => x.hallOfFamer));
    }

    async function alignmentCheck(alignment) {
        let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        return participantsSuperstars.every(x => x.alignment === alignment);
    }

    async function heelCheck() {
        return alignmentCheck('heel');
    }

    async function faceCheck() {
        return alignmentCheck('face');
    }

    async function teamSuperstarsAlignmentCheck(alignment) {
        if (participantsType === 'superstar') {
            let tagTeams = await getSuperstarTagTeams(participants[0]);
            for (const tagTeam of tagTeams) {
                let tagTeamMembers = await getTagTeamSuperstars(tagTeam);
                if (checkAreObjArraysEqual(tagTeamMembers, participants) &&
                    tagTeamMembers.every(x => x.alignment === alignment)) {
                    return true;
                }
            }
        }
        return false;
    }

    async function faceTeamSuperstarsCheck() {
        return teamSuperstarsAlignmentCheck('face');
    }

    async function faceAndHeelPastFeudCheck() {
        for (const p of participants) {
            let feuds = (await getRosterMemberFeuds(p)).filter(x => x.started && x.ended);
            for (const feud of feuds) {
                let feudParticipants = await getFeudParticipants(feud);
                if (feudParticipants.every(x => objectInArray(x, participants))) {
                    // Check if face and heel present
                    if (participantsType === 'superstar') {
                        if (feudParticipants.some(x => x.alignment === 'heel') &&
                            feudParticipants.some(x => x.alignment === 'face')) {
                            return true;
                        }
                    }
                    else {
                        let faces = false;
                        let heels = false;
                        for (const p of feudParticipants) {
                            let participantSuperstars = await getRosterMemberSuperstars(p);
                            if (participantSuperstars.every(x => x.alignment === 'heel')) {
                                heels = true;
                            }
                            else if (participantSuperstars.every(x => x.alignment === 'face')) {
                                faces = true;
                            }
                        }
                        if (heels && faces) {
                            return true
                        }
                    }
                }
            }
        }
        return false;
    }

    async function faceAndFacePastFeudCheck() {
        for (const p of participants) {
            let feuds = (await getRosterMemberFeuds(p)).filter(x => x.started && x.ended);
            for (const feud of feuds) {
                let feudParticipants = await getFeudParticipants(feud);
                if (feudParticipants.every(x => objectInArray(x, participants))) {
                    let feudSuperstars = (await Promise.all(feudParticipants.map(x => getRosterMemberSuperstars(x)))).flat();
                    if (feudSuperstars.every(x => x.alignment === 'face')) {
                        return true
                    }
                }
            }
        }
        return false;
    }

    async function faceAndHeelCheck() {
        if (participantsType === 'superstar') {
            if (participants.some(x => x.alignment === 'heel') && participants.some(x => x.alignment === 'face')) {
                return true;
            }
        }
        else {
            let faces = false;
            let heels = false;
            for (const p of participants) {
                let participantSuperstars = await getRosterMemberSuperstars(p);
                if (participantSuperstars.every(x => x.alignment === 'heel')) {
                    heels = true;
                }
                else if (participantSuperstars.every(x => x.alignment === 'face')) {
                    faces = true;
                }
            }
            return heels && faces;
        }
        return false;
    }

    async function heelTeamSuperstarsCheck() {
        return teamSuperstarsAlignmentCheck('heel');
    }

    async function neutralCheck() {
        let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        return participantsSuperstars.every(x => !x.alignment);
    }

    async function producerLevelCheck(level) {
        let producers = availableStaffMembers.filter(x => x.role === 'producer');
        for (const producer of producers) {
            if (producer.level >= level) {
                return true;
            }
        }
        return false;
    }

    async function producerLevel1Check() {
        return producerLevelCheck(1);
    }

    async function producerLevel2Check() {
        return producerLevelCheck(2);
    }

    async function producerLevel3Check() {
        return producerLevelCheck(3);
    }

    async function newTalentPackageCheck() {
        if (!(await producerLevel2Check())) {
            return false;
        }
        return newTalentCheck();
    }

    async function returningTalentPackageCheck() {
        if (!(await producerLevel2Check())) {
            return false;
        }
        let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        return participantsSuperstars.every(x => x.injured > 0 && x.injured <= 3);
    }

    async function retiringTalentPackageCheck() {
        if (!(await producerLevel3Check())) {
            return false;
        }
        return retiringCheck();
    }

    async function championPackage() {
        if (!(await producerLevel2Check())) {
            return false;
        }
        return championCheck();
    }

    async function newGimmickPackageCheck() {
        if (!(await producerLevel1Check())) {
            return false;
        }
        let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        return participantsSuperstars.every(x => x.debutNewGimmick);
    }

    async function buyoutOfferAcceptedCheck() {
        let company = await getSegmentItemCompany(segmentItem);
        if (company) {
            let game = await getCompanyGame(company);
            let buyoutCompetitor = (await getActiveCompetitorsForCompany(company, game))
                .find(x => x.operatingStatus.includes('Negotiating Buyout'));
            if (buyoutCompetitor) {
                return true;
            }
        }
        return false;
    }
    async function championPrestigeCheck(prestige, checkGraphic = false) {
        let prestigeRanks = {'S': 4, 'A': 3, 'B': 2, 'C': 1};

        let participantsChampionships = [];
        if (participantsType === 'superstar') {
            participantsChampionships = (await Promise.all(participants.map(x => getSuperstarChampionships(x)))).flat();
            participantsChampionships = participantsChampionships.filter(x => !x.tagTeam && !x.trio);
        }
        else if (participantsType === 'tagTeam' || participantsType === 'trio') {
            let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
            participantsChampionships = (await Promise.all(participantsSuperstars
                .map(x => getSuperstarChampionships(x)))).flat();
            if (participantsType === 'tagTeam') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam);
            }
            else if (participantsType === 'trio') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam || x.trio);
            }
        }

        let championship = participantsChampionships
            .find(x => prestigeRanks[x.prestige] >= prestigeRanks[prestige]);
        if (checkGraphic) {
            return championship && championship.graphic && Object.keys(championship.graphic).length !== 0;
        }
        else {
            return !!championship;
        }
    }

    async function championPrestigeCheckAWithGraphic() {
        return championPrestigeCheck('A', true);
    }

    async function championPrestigeCheckS() {
        return championPrestigeCheck('S');
    }

    async function championPrestigeCheckB() {
        return championPrestigeCheck('B');
    }

    async function retirementCheck() {
        let retiredSuperstarsNames = [];
        for (const companyLog of companyLogs) {
            if (companyLog.type === 'retirement' && !(retiredSuperstarsNames.includes(companyLog.text))) {
                if (getMonthsDifference(month, year, companyLog.month, companyLog.year) < 3) {
                    retiredSuperstarsNames.push(companyLog.text)
                }
            }
        }
        return participants.some(x => retiredSuperstarsNames.includes(x.name));
    }

    async function losingStreakCheck() {
        let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        return participantsSuperstars.every(x => x.lossesCounter >= 5);
    }

    async function legendAndOverSuperstarCheck() {
        if (participantsType === 'superstar') {
            if (participants.some(x => x.hot) && participants.some(x => x.hallOfFamer)) {
                return true;
            }
        }
        return false;
    }

    async function legendAndHeelCheck() {
        if (participantsType === 'superstar') {
            if (participants.some(x => x.alignment === 'heel') && participants.some(x => x.hallOfFamer)) {
                return true;
            }
        }
        return false;
    }

    async function faceOfTheCompanyCheck() {
        let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        return participantsSuperstars.every(x => x.faceOfTheCompany);
    }

    async function wrestlerOfTheYearAwardCheck() {
        let companyAwards = companyLogs.filter(x => x.type === 'award' && x.value > 0 &&
            x.text.includes('Wrestler of the Year'));
        for (const awardWon of companyAwards) {
            for (const participant of participants) {
                if (findNameInString(participant.name, awardWon.text) && awardWon.realYear !== null) {
                    if (getMonthsDifference(month, year, awardWon.month, awardWon.realYear) < 3) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    async function awardWinnerCheck() {
        let companyAwards = companyLogs.filter(x => x.type === 'award');
        for (const awardWon of companyAwards) {
            for (const participant of participants) {
                if (findNameInString(participant.name, awardWon.text) && awardWon.realYear !== null) {
                    if (getMonthsDifference(month, year, awardWon.month, awardWon.realYear) < 3) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    async function inflictedInjuryCheck() {
        let injuries = companyLogs.filter(x => x.type === 'injury');
        for (const p of participants) {
            let injured = false;
            if (participantsType === 'superstar') {
                injured = p.injured
            }
            else {
                injured = (await getRosterMemberSuperstars(p)).some(x => x.injured)
            }
            if (!injured) {
                let injuriesInflicted = injuries.filter(x => x.text.split(' injured ')[0].includes(p.name));
                for (const injuryInflicted of injuriesInflicted) {
                    if (getMonthsDifference(month, year, injuryInflicted.month, injuryInflicted.year) < 2) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    async function notDoneYetPotentialFeudCheck() {
        for (const p of participants) {
            let retired = false;
            if (participantsType === 'superstar') {
                retired = p.retired
            }
            else {
                retired = (await getRosterMemberSuperstars(p)).some(x => x.retired)
            }
            if (!retired) {
                for (const f of (await getRosterMemberFeuds(p))) {
                    if (f.directFeudEvent === 'retirement-feud' && !f.started && !f.ended) {
                        if (getMonthsDifference(month, year, f.startMonth, f.startYear) < 3) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }

    async function shockingHeelTurnCheck() {
        let shockingTurns = companyLogs.filter(x => x.type === 'turn' && !(x.text.includes('Face')));
        for (const participant of participants) {
            // Get superstar name by splitting companyLog text and getting word before 'turned'
            let shockingTurn = shockingTurns.find(x => x.text.split(' turned ')[0].includes(participant.name));
            if (shockingTurn && getMonthsDifference(month, year, shockingTurn.month, shockingTurn.year) < 3) {
                return true;
            }
        }
        return false;
    }

    async function shockingFaceTurnCheck() {
        let shockingTurns = companyLogs.filter(x => x.type === 'turn' && x.text.includes('Face'));
        for (const participant of participants) {
            // Get superstar name by splitting companyLog text and getting word before 'turned'
            let shockingTurn = shockingTurns.find(x => x.text.split(' turned ')[0].includes(participant.name));
            if (shockingTurn && getMonthsDifference(month, year, shockingTurn.month, shockingTurn.year) < 3) {
                return true;
            }
        }
        return false;
    }

    async function singlesSuperstarsCheck() {
        if (participantsType === 'superstar') {
            // Check if superstars are already in a team
            for (const p of participants) {
                let currentTeams = (await getSuperstarTagTeams(p)).filter(x => !x.temporary);
                if (currentTeams.length > 0) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    async function companyOfTheYearAward() {
        let companyAwards = companyLogs.filter(x => x.type === 'award' && x.value > 0 &&
            x.text.includes('Company of the Year'));
        for (const awardWon of companyAwards) {
            if (awardWon.realYear !== null) {
                if (getMonthsDifference(month, year, awardWon.month, awardWon.realYear) < 3) {
                    return true;
                }
            }
        }
        return false;
    }

    async function injuredPartnerAndSinglesSuperstar() {
        if (participantsType === 'superstar') {
            // Check if one participant is in team and one is not
            let participantInTeam;
            let participantNotInTeam;
            for (const p of participants) {
                let participantTeams = (await getSuperstarTagTeams(p)).filter(x => !x.temporary && !x.trio);
                if (participantTeams.length > 0) {
                    participantInTeam = p
                }
                else {
                    participantNotInTeam = p
                }
            }
            if (participantInTeam && participantNotInTeam) {
                let participantTeam = (await getSuperstarTagTeams(participantInTeam))
                    .find(x => !x.temporary && !x.trio);
                // Check if other team member in injured
                let otherTeamMembers = (await getTagTeamSuperstars(participantTeam))
                    .filter(x => x.$loki !== participantInTeam.$loki);
                if (otherTeamMembers.some(x => x.injured > 0)) {
                    return true;
                }
            }
        }
        return false;
    }

    async function retiringCheck() {
        if (participantsType === 'superstar') {
            if (participants.some(x => x.age >= 45)) {
                return true;
            }
        }
        else {
            for (const p of participants) {
                let participantSuperstars = await getRosterMemberSuperstars(p);
                if (participantSuperstars.every(x => x.age >= 45)) {
                    return true;
                }
            }
        }
        return false;
    }

    async function heelsAndFaceSinglesCheck() {
        if (participantsType === 'superstar') {
            let faces = participants.filter(x => x.alignment === 'face').length;
            let heels = participants.filter(x => x.alignment === 'heel').length;
            if (faces === 1 && heels === participants.length - 1) {
                // Check if heels are already in a team
                for (const p of participants.filter(x => x.alignment === 'heel')) {
                    let currentTeams = (await getSuperstarTagTeams(p)).filter(x => !x.temporary);
                    if (currentTeams.length > 0) {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
    }

    async function maskedTalentCheck() {
        for (const p of participants) {
            let participantSuperstars = await getRosterMemberSuperstars(p);
            if (participantSuperstars.every(x => checkSuperstarGraphicMask(x.graphic))) {
                return true;
            }
        }
        return false;
    }

    async function noFactionLeaderCheck() {
        if (factions.length > 0) {
            if (!(await getFactionLeaderSuperstar(factions[0]))) {
                return true;
            }
        }
        return false;
    }

    async function factionLeaderPresentCheck() {
        if (factions.length > 0) {
            if ((await getFactionLeaderSuperstar(factions[0]))) {
                return true;
            }
        }
        return false;
    }

    async function otherBrandTalentCheck() {
        let company = await getSegmentItemCompany(segmentItem);
        let currentEvent = await getCompanyLatestEvent(company);
        let brandName = currentEvent.brandName;
        if (!brandName && currentEvent.weeklyShow) {
            let roster = await getCompanyRosterByType(company, 'main');
            let rosterBrands = await getRosterBrands(roster);
            brandName = rosterBrands.find(x => x.weeklyShowName === currentEvent.name)?.name;
        }

        if (brandName) {
            let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
            return participantsSuperstars.every(x => x.brandName && x.brandName !== brandName);
        }
        return false;
    }

    async function returningTalentCheck() {
        let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        return participantsSuperstars.some(x => x.readyToReturn);
    }

    async function doubleChampionCheck() {
        if (participantsType === 'superstar') {
            let participantsChampionships = (await Promise.all(participants.map(x => getSuperstarChampionships(x)))).flat();
            participantsChampionships = participantsChampionships.filter(x => !x.tagTeam && !x.trio);
            return participantsChampionships.length === 2;
        }
        else if (participantsType === 'tagTeam' || participantsType === 'trio') {
            let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
            let participantsChampionships = (await Promise.all(participantsSuperstars
                .map(x => getSuperstarChampionships(x)))).flat();
            if (participantsType === 'tagTeam') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam);
            }
            else if (participantsType === 'trio') {
                participantsChampionships = participantsChampionships.filter(x => x.tagTeam || x.trio);
            }
            return getUniqueChampionships(participantsChampionships).length === 2;
        }
    }

    async function overTalentCheck() {
        let participantsSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        return participantsSuperstars.every(x => x.hot);
    }

    async function feudPresentCheck() {
        let checkParticipants = participants;
        if (participantsType === 'faction' && factions.length) {
            checkParticipants = factions
        }
        for (const p of checkParticipants) {
            let feuds = (await getRosterMemberFeuds(p)).filter(x => (x.started && !x.ended) ||
                (!x.started && x.directFeudEvent && !x.ended));
            if (feuds.length > 0) {
                return true;
            }
        }
        return false;
    }

    async function theGrandInvitationalWinnerCheck() {
        let companyAwards = companyLogs.filter(x => x.type === 'award' && x.value === 3 &&
            x.text.includes('The Grand Invitational'));
        for (const awardWon of companyAwards) {
            for (const participant of participants) {
                if (findNameInString(participant.name, awardWon.text) && awardWon.realYear !== null) {
                    if (getMonthsDifference(month, year, awardWon.month, awardWon.realYear) < 3) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    const checkFunctions = {
        'title-feud': titleFeudCheck,
        'vacant-title': vacantTitleCheck,
        'team-superstars': teamSuperstarsCheck,
        'champion': championCheck,
        'new-champion': newChampionCheck,
        'previous-feuds': previousFeudsCheck,
        'new-talent': newTalentCheck,
        'contract-and-champion': contractAndChampionCheck,
        'legend': legendCheck,
        'heel': heelCheck,
        'face': faceCheck,
        'face-vs-face': faceCheck,
        'face-team-superstars': faceTeamSuperstarsCheck,
        'face-vs-heel-past-feud': faceAndHeelPastFeudCheck,
        'face-vs-face-past-feud': faceAndFacePastFeudCheck,
        'face-vs-heel': faceAndHeelCheck,
        'heel-team-superstars': heelTeamSuperstarsCheck,
        'neutral': neutralCheck,
        'level-1-producer': producerLevel1Check,
        'level-3-producer': producerLevel3Check,
        'new-talent-and-level-2-producer': newTalentPackageCheck,
        'returning-talent-and-level-2-producer': returningTalentPackageCheck,
        'retiring-talent-and-level-3-producer': retiringTalentPackageCheck,
        'champion-and-level-2-producer': championPackage,
        'new-gimmick-and-level-1-producer': newGimmickPackageCheck,
        'buyout-offer-accepted': buyoutOfferAcceptedCheck,
        'silver-champion': championPrestigeCheckB,
        'gold-champion': championPrestigeCheckAWithGraphic,
        'obsidian-champion': championPrestigeCheckS,
        'retirement': retirementCheck,
        'losing-streak': losingStreakCheck,
        'legend-and-over-superstar': legendAndOverSuperstarCheck,
        'legend-and-heel': legendAndHeelCheck,
        'face-of-the-company': faceOfTheCompanyCheck,
        'wrestler-of-the-year-award': wrestlerOfTheYearAwardCheck,
        'award-winner': awardWinnerCheck,
        'inflicted-injury': inflictedInjuryCheck,
        'not-done-yet-potential-feud': notDoneYetPotentialFeudCheck,
        'shocking-heel-turn': shockingHeelTurnCheck,
        'shocking-face-turn': shockingFaceTurnCheck,
        'singles-superstars': singlesSuperstarsCheck,
        'company-of-the-year-award': companyOfTheYearAward,
        'injured-partner-and-singles-superstar': injuredPartnerAndSinglesSuperstar,
        'retiring': retiringCheck,
        'heels-vs-face-singles': heelsAndFaceSinglesCheck,
        'masked-talent': maskedTalentCheck,
        'no-faction-leader': noFactionLeaderCheck,
        'faction-leader-present': factionLeaderPresentCheck,
        'other-brand-talent': otherBrandTalentCheck,
        'heel-vs-heel': heelCheck,
        'returning-talent': returningTalentCheck,
        'double-champion': doubleChampionCheck,
        'over-talent': overTalentCheck,
        'feud-present': feudPresentCheck,
        'the-grand-invitational-winner': theGrandInvitationalWinnerCheck
    };

    // Check segment item's requirement
    const checkFunction = checkFunctions[segmentItem.requirement];
    if (checkFunction && !(await checkFunction())) {
        data['error'] = 'requirement-fail'
    }

    if (participants.length > 0) {
        let segmentSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
        // Only allow retired superstars (who are not managers) in legends, retired and manager segments or as part of a faction
        if (segmentSuperstars.some(x => (x.retired && !x.fullTimeManager)) && factions.length <= 0) {
            if (!segmentItem.requirement || !(['legend', 'retirement', 'no-manager', 'manager-present', 'manager']
                .some(y => segmentItem.requirement.includes(y)))) {
                data['error'] = 'retired';
            }
        }
        // Don't allow managers in segments that create teams
        if (segmentSuperstars.some(x => x.fullTimeManager)) {
            if (['create-trio-of-heels', 'create-tag-team-and-blowoff', 'remove-tag-team-and-create-tag-team',
                'create-team'].includes(segmentItem.consequence)) {
                data['error'] = 'manager';
            }
        }
    }

    return data;
}

async function getSegmentInputsData({participantUid, participantType, inputType} = {}) {  // get_segment_inputs_data
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    if (inputType === 'competitors') {
        const competitors = await getActiveCompetitorsForCompany(userCompany, currentGame);
        data['competitors'] = competitors.map(x => {
            return {'name': x.name, 'uid': x.$loki}
        });
    }
    else if (['vacant-championships', 'participant-championships', 'participant-feuds'].includes(inputType)) {
        // Get participant
        let participant;
        if (participantType === 'superstar') {
            participant = await Superstars.get(participantUid);
        }
        else if (participantType === 'tag-team' || participantType === 'trio') {
            participant = await TagTeams.get(participantUid);
        }
        else if (participantType === 'faction') {
            participant = await Factions.get(participantUid);
        }

        if (participant) {
            // Get vacant championships
            if (inputType === 'vacant-championships') {
                let championships = [];
                let vacatedChampionships = (await getCompanyChampionships(userCompany)).filter(x => x.vacated);
                if (participant.objectName === 'superstar') {
                    championships = vacatedChampionships.filter(x => !x.tagTeam && !x.trio)
                }
                else if (participant.objectName === 'tagTeam') {
                    if (participant.trio) {
                        championships = vacatedChampionships.filter(x => x.tagTeam || x.trio)
                    }
                    else {
                        championships = vacatedChampionships.filter(x => x.tagTeam)
                    }
                }
                data['championships'] = getUniqueChampionships(championships).map(x => {
                    return {'name': x.name, 'uid': x.$loki}
                });
            }

            // Get participant's championships
            if (inputType === 'participant-championships') {
                let championships = [];
                if (participant.objectName === 'superstar') {
                    championships = await getSuperstarChampionshipsToVacate(participant)
                }
                else if (participant.objectName === 'tagTeam') {
                    let participantSuperstars = await getTagTeamSuperstars(participant);
                    championships = (await Promise.all(participantSuperstars.map(x =>
                        getSuperstarChampionshipsToVacate(x, participant)))).flat();
                }
                data['championships'] = getUniqueChampionships(championships).map(x => {
                    return {'name': x.name, 'uid': x.$loki}
                });
            }

            // Get participant's feuds
            if (inputType === 'participant-feuds') {
                let feuds = [];
                let participantFeuds = (await getRosterMemberFeuds(participant)).filter(x => (x.started && !x.ended) ||
                    (!x.started && x.directFeudEvent && !x.ended));
                for (const participantFeud of participantFeuds) {
                    let otherParticipants = (await getFeudParticipants(participantFeud))
                        .filter(x => x.$loki !== participant.$loki).map(x => x.name);
                    feuds.push({'opponents': otherParticipants, 'name': participantFeud.name, 'uid': participantFeud.$loki})
                }
                data['feuds'] = feuds;
            }
        }
    }
    else if (inputType === 'segments-and-matches') {
        // Get matches and segments of last event except production segments
        const companyEvents = (await getCompanyEvents(userCompany)).reverse();
        const previousEvent = companyEvents[1];

        const segments = await getEventSegments(previousEvent);
        let filteredSegments = [];
        for (const segment of segments) {
            const segmentItem = await getSegmentSegmentItem(segment);
            if (!segmentItem.productionSegment) {
                filteredSegments.push(segment)
            }
        }
        const matches = await getEventMatches(previousEvent);
        const segmentsAndMatches = filteredSegments.concat(matches);
        data['segmentsAndMatches'] = await Promise.all(segmentsAndMatches.map(async x => {
            return {'name': await getMatchOrSegmentName(x), 'uid': x.$loki, 'type': x.objectName}
        }));
    }

    return data;
}

async function getSegmentName(segment) {  // get_segment_name
    const participants = await getSegmentParticipants(segment);
    let participantNames = commaSeparate(participants.map(x => x.name));
    let segmentItem = await getSegmentSegmentItem(segment);
    let segmentItemName = segmentItem.name;
    let segmentWord = '';
    if (participantNames) {
        segmentWord = participants.length > 1 ? 'between' : 'with';
    }
    return `${segmentItemName} ${segmentWord} ${participantNames}`
}

async function bookSegment({feudUid, segmentItemUid, selectedParticipants, consequenceData, managedTalentUid,
                            managerUid, producerUid} = {}) {
    let data = {};
    try {
        const currentGame = await getCurrentGame();
        const userCompany = await getGameCurrentUserCompany(currentGame);
        const nextEvent = await getCompanyLatestEvent(userCompany);
        const parentEvents = await getCompanyParentEvents(userCompany);
        const eventMatches = await getEventMatches(nextEvent);
        const eventSegments = await getEventSegments(nextEvent);
        const eventSegmentParticipants = (await Promise.all(eventSegments.map(x => getSegmentParticipants(x)))).flat();
        const productionFacility = (await getCompanyFacilities(userCompany)).find(x => x.name === 'Production');
        const mainRoster = await getCompanyRosterByType(userCompany, 'main');
        const rosterSuperstars = await getRosterSuperstars(mainRoster);
        const companyChampionships = await getCompanyChampionships(userCompany);
        const staffMembers = await getCompanyStaff(userCompany);
        const availableStaffMembers = await getAvailableStaffMembers(staffMembers);
        const producers = await getAvailableStaffMembersByRole(staffMembers, 'producer');
        const companyLogs = await getCompanyCompanyLogs(userCompany);
        const segmentItem = await SegmentItems.get(segmentItemUid);
        const monthlyEventSegmentLimit = 4;
        let factionsSelected = [];

        // Check match/segment limit
        const maximumMatchesAndSegments = getEventMaximumMatchesAndSegments(nextEvent, parentEvents, productionFacility);
        if (eventSegments.concat(eventMatches).length >= maximumMatchesAndSegments) {
            data['error'] = 'match-and-segment-limit';
            data['limit'] = maximumMatchesAndSegments;
            return data;
        }

        // Check for monthly event segment limit
        if (!nextEvent.weeklyShow && nextEvent.name !== 'Weekly Show') {
            if (eventSegments.length >= monthlyEventSegmentLimit) {
                data['error'] = 'monthly-event-segment-limit';
                data['limit'] = monthlyEventSegmentLimit;
                return data;
            }
        }

        // Check if special segment item has been used
        if (segmentItem.special) {
            if (segmentItem.used) {
                data['error'] = 'already-used';
                data['monthsToReuse'] = segmentItem.monthsToReuse;
                return data;
            }
            if (!globalUser.paid) {
                data['error'] = 'special-segments-not-paid';
                return data;
            }
            // Set segment item to used
            if (!currentGame.settings['no_special_items_cooldown']) {
                segmentItem.used = true;
            }
        }

        // Check if segment item is unlocked
        if (!segmentItem.unlocked) {
            data['error'] = 'locked-segment-item';
            return data;
        }

        // Check for production packages only
        if (nextEvent.activeEffect === 'production_packages_only' && !segmentItem.productionSegment) {
            data['error'] = 'production-packages-only';
            return data;
        }

        // Create segment, add to segment item and event
        const newSegment = Segment();
        await Segments.insert(newSegment);
        await addSegmentItemSegments(segmentItem, [newSegment]);
        await addEventSegments(nextEvent, [newSegment]);
        newSegment.order = nextEvent.matchesCount;
        nextEvent.matchesCount += 1;

        // Get participants
        let participants = [];
        if (feudUid) {
            const feud = await Feuds.get(feudUid);
            participants = await getFeudParticipants(feud);

            // Add temporary teams if factions feud
            if (participants[0].objectName === 'faction') {
                let newParticipants = [];
                for (const p of participants) {
                    let factionSuperstars = await getFactionSuperstarsForSegment(p, nextEvent, companyChampionships);
                    // Check if at least one faction superstar is available
                    if (factionSuperstars.length < 2) {
                        data['error'] = 'not-enough-available-faction-superstars';
                        return data;
                    }
                    factionsSelected.push(p);
                    let temporaryFactionTeam = await getFactionTemporaryTagTeam(p, factionSuperstars, mainRoster);
                    newParticipants.push(temporaryFactionTeam);
                }
                participants = newParticipants
            }
        } else {
            for (const x of selectedParticipants) {
                let participant;
                if (x.type === 'superstar') {
                    participant = await Superstars.get(x.uid);
                    participants.push(participant);
                } else if (x.type === 'tag-team' || x.type === 'trio') {
                    participant = await TagTeams.get(x.uid);
                    participants.push(participant);
                } else if (x.type === 'faction') {
                    participant = await Factions.get(x.uid);
                    let factionSuperstars = await getFactionSuperstarsForSegment(participant, nextEvent,
                        companyChampionships);
                    // Check if at least one faction superstar is available
                    if (factionSuperstars.length < 2) {
                        data['error'] = 'not-enough-available-faction-superstars';
                        return data;
                    }
                    factionsSelected.push(participant);
                    let temporaryFactionTeam = await getFactionTemporaryTagTeam(participant, factionSuperstars, mainRoster);
                    participants.push(temporaryFactionTeam);
                }
            }
        }

        // Check segment participants limits
        if (participants.length > segmentItem.maxParticipants) {
            data['error'] = 'max-participants';
            data['maxParticipants'] = segmentItem.maxParticipants;
            return data;
        }
        if (participants.length < segmentItem.minParticipants) {
            data['error'] = 'min-participants';
            data['minParticipants'] = segmentItem.minParticipants;
            return data;
        }

        // Check manager segment consequence
        if (['boost-managed-talent', 'add-manager', 'remove-manager',
            'remove-managed-talent'].includes(segmentItem.consequence)) {
            if (!globalUser.paid) {
                data['error'] = 'managers-paid-only';
                return data;
            }
            let managerSegmentCheck = await checkManagerSegmentAndGetParticipants(segmentItem, [...participants], rosterSuperstars,
                managedTalentUid, managerUid);
            if (managerSegmentCheck[0].error) {
                data = managerSegmentCheck[0];
                return data;
            }
            // Update participants
            participants = managerSegmentCheck[1];
        }

        // Check brand segment consequence
        if (['draft-talent-to-brand'].includes(segmentItem.consequence)) {
            let brandSegmentCheck = await checkBrandSegmentAndGetParticipants(segmentItem, [...participants],
                consequenceData);
            if (brandSegmentCheck[0].error) {
                data = brandSegmentCheck[0];
                return data;
            }
            // Update participants
            participants = brandSegmentCheck[1];
        }

        // Add participants to segment
        for (const p of participants) {
            await addSegmentParticipants(newSegment, [p]);
        }

        // Check for booking restrictions on event
        let activeEffect = nextEvent.activeEffect;
        if (['no_women_bookable', 'no_men_bookable'].includes(activeEffect)) {
            for (const p of participants) {
                for (const s of await getRosterMemberSuperstars(p)) {
                    if (activeEffect === 'no_women_bookable' && s.gender === 'female') {
                        data['error'] = 'no-women-allowed';
                        return data;
                    } else if (activeEffect === 'no_men_bookable' && s.gender === 'male') {
                        data['error'] = 'no-men-allowed';
                        return data;
                    }
                }
            }
        }

        // Check if participant is in more than 2 segments
        for (const p of participants) {
            if (eventSegmentParticipants.filter(x => x.$loki === p.$loki && x.objectName === p.objectName).length >= 2) {
                data['error'] = 'max-segments';
                return data;
            }
        }

        // Get participants type
        let participantsType;
        if (participants.length > 0) {
            participantsType = participants[0].objectName
        }

        // Check if singles participant in special segment
        if (segmentItem.special && participantsType !== 'superstar') {
            data['error'] = 'superstars-only';
            return data;
        }

        // Check if faction participant in factions segment
        if (segmentItem.factionSegment) {
            if (factionsSelected.length <= 0 && segmentItem.minParticipants > 0) {
                data['error'] = 'factions-only';
                return data;
            }
            if (!globalUser.paid) {
                data['error'] = 'factions-paid-only';
                return data;
            }
        }

        // Check if paid for brand segment
        if (segmentItem.consequence === 'draft-talent-to-brand' || segmentItem.requirement === 'other-brand-talent') {
            if (!globalUser.paid) {
                data['error'] = 'brands-paid-only';
                return data;
            }
        }

        // Add feuds if participants present
        let segmentFeuds = [];
        let superstarsPresent;
        if (participants.length > 0) {

            // Get all superstars and teams present
            superstarsPresent = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
            let tagTeamsPresent = [];
            for (const s of superstarsPresent) {
                tagTeamsPresent.push(...(await getSuperstarTagTeams(s)).filter(x => !x.temporary));
            }
            tagTeamsPresent = getUniqueObjects(tagTeamsPresent);

            // Check if superstars available, check brand exclusivity if not brand signing segment
            for (const s of superstarsPresent) {
                let brandCheck = checkSuperstarBrandAvailability(nextEvent, s,
                        getSuperstarChampionshipsFromCompanyChampionships(s, companyChampionships)) ||
                    segmentItem.consequence === 'draft-talent-to-brand';
                if (s.unavailable || s.suspensionMonths > 0 || !brandCheck) {
                    data['error'] = 'superstar-not-available';
                    data['superstarName'] = s.name;
                    return data;
                }
            }

            // Get existing feuds
            segmentFeuds = await getParticipantFeuds(superstarsPresent, tagTeamsPresent);

            // Check feuds for feud only segment
            if (segmentItem.feudOnly && segmentFeuds.length <= 0) {
                data['error'] = 'feud-only';
                return data;
            }

            // Add segment to feuds
            await addSegmentFeuds(newSegment, segmentFeuds);

            // Reset attires
            for (const s of superstarsPresent) {
                if (s.currentAttire > 0) {
                    s.currentAttire = 0
                }
            }

            // Add managers
            if (!segmentItem.special && globalUser.paid) {
                setManagersForMatchOrSegment(newSegment, superstarsPresent, rosterSuperstars, nextEvent)
            }
        }

        // Check segment item requirement
        let requirementCheck = await checkSegmentItemRequirement(segmentItem, participants, companyLogs, currentGame.monthCount,
            currentGame.year, companyChampionships, availableStaffMembers, factionsSelected);
        if (requirementCheck.error) {
            data['error'] = requirementCheck.error;
            data['alreadyHeld'] = requirementCheck.alreadyHeld;
            data['requirement'] = segmentItem.requirement;
            return data;
        }

        // Add consequence data
        if (consequenceData) {
            // Check faction inputs for errors
            if (segmentItem.factionSegment) {
                let factionSegmentCheck = await checkFactionSegmentConsequence(factionsSelected, segmentItem, consequenceData,
                    rosterSuperstars, mainRoster, nextEvent, companyChampionships);
                if (factionSegmentCheck.error) {
                    data = factionSegmentCheck;
                    return data;
                }
            }

            // Check if team/faction or championship name already exists
            if (consequenceData['objectName']) {
                if (['create-team', 'create-trio-of-heels', 'remove-tag-team-and-create-tag-team',
                    'create-tag-team-and-blowoff'].includes(segmentItem.consequence)) {
                    let tagTeamNames = (await getRosterTagTeams(mainRoster)).map(x => x.name);
                    if (tagTeamNames.includes(consequenceData['objectName'])) {
                        data['error'] = 'team-already-present';
                        return data;
                    }
                    let factionNames = (await getRosterActiveFactions(mainRoster)).map(x => x.name);
                    if (factionNames.includes(consequenceData['objectName'])) {
                        data['error'] = 'faction-already-present';
                        return data;
                    }
                } else if (['unify-titles', 'split-title'].includes(segmentItem.consequence)) {
                    let championshipNames = companyChampionships.map(x => x.name);
                    if (championshipNames.includes(consequenceData['objectName'])) {
                        data['error'] = 'championship-already-present';
                        return data;
                    }
                }
            }

            // Add feud to segment feuds
            if (consequenceData['feudUid']) {
                let feudToAdd = await Feuds.get(consequenceData['feudUid']);
                if (feudToAdd) {
                    await addSegmentFeuds(newSegment, [feudToAdd]);
                    segmentFeuds.push(feudToAdd);
                }
            }

            // Set consequence data
            newSegment.consequenceData = consequenceData;
        }

        // Add one way consequence
        if (segmentItem.oneWayConsequence) {
            newSegment.consequenceAppliedTo = await getSegmentConsequenceAppliedTo(segmentItem, participants);
        }

        // Add hype
        newSegment.hype = await getHypeForSegment(participants, segmentFeuds, segmentItem);

        // Add producer task
        let producer;
        if (producerUid) {
            producer = producers.find(x => x.$loki === producerUid);
            if (producer) {
                // Check for current task
                if (producer.currentTask) {
                    data['producer'] = producer.name;
                    data['error'] = 'producer-task-present';
                    return data;
                }
                if (!globalUser.paid) {
                    data['error'] = 'producer-focus-not-paid';
                    return data;
                }
                await addProducerSegmentTask(producer, newSegment, segmentItem)
            }
        }

        // Check tutorial action
        if (userCompany.storyName === 'tutorial') {
            data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['book_feud_segment',
                'book_singles_segment']);
        }

        db.saveDatabase();

        // Get data to return
        data['segment'] = await getSegmentData({
            segment: newSegment,
            rosterSuperstars: rosterSuperstars,
            producers: producers
        });
    }
    finally {
        if (data['error']) {
            await loadDb(db.filename);
        }
    }

    return data;
}

async function getSegmentConsequenceAppliedTo(segmentItem, participants) {  // get_consequence_applied_to
    if (segmentItem.requirement === 'face-vs-heel' && segmentItem.consequence === 'face-turn-and-blowoff') {
        // Get heel
        let heel;
        if (participants[0].objectName === 'superstar') {
            heel = participants.find(x => x.alignment === 'heel');
        }
        else if (participants[0].objectName === 'tagTeam') {
            for (const p of participants) {
                if ((await getTagTeamSuperstars(p)).every(x => x.alignment === 'heel')) {
                    heel = p;
                    break;
                }
            }
        }
        if (heel) {
            return heel.name;
        }
    }
    if (segmentItem.requirement === 'face-vs-heel-past-feud') {

        // Get past feud's participants
        let pastFeud;
        for (const p of participants) {
            let feuds = (await getRosterMemberFeuds(p)).filter(x => x.started && x.ended);
            for (const feud of feuds) {
                let feudParticipants = await getFeudParticipants(feud);
                if (feudParticipants.every(y => objectInArray(y, participants))) {
                    pastFeud = feud;
                    break;
                }
            }
            if (pastFeud) {
                break;
            }
        }
        let pastFeudParticipants = await getFeudParticipants(pastFeud);

        // Get heel or face
        if (segmentItem.consequence === 'heel-turn') {
            let face;
            if (participants[0].objectName === 'superstar') {
                face = pastFeudParticipants.find(x => x.alignment === 'face');
            }
            else if (participants[0].objectName === 'tagTeam') {
                for (const p of pastFeudParticipants) {
                    if ((await getTagTeamSuperstars(p)).every(x => x.alignment === 'face')) {
                        face = p;
                        break;
                    }
                }
            }
            if (face) {
                return face.name;
            }
        }
        if (segmentItem.consequence === 'face-turn') {
            let heel;
            if (participants[0].objectName === 'superstar') {
                heel = pastFeudParticipants.find(x => x.alignment === 'heel');
            }
            else if (participants[0].objectName === 'tagTeam') {
                for (const p of pastFeudParticipants) {
                    if ((await getTagTeamSuperstars(p)).every(x => x.alignment === 'heel')) {
                        heel = p;
                        break;
                    }
                }
            }
            if (heel) {
                return heel.name;
            }
        }
    }
    if (segmentItem.requirement === 'retiring' && segmentItem.consequence === 'heel-turn') {
        if (participants[0].objectName === 'superstar') {
            return getArrayMaxByProperty(participants, 'age').name
        }
        else if (participants[0].objectName === 'tagTeam') {  // test booking
            let tempParticipants = [...participants];
            for (const p of tempParticipants) {
                let s = await getRosterMemberSuperstars(p);
                p.age = Math.round(s.reduce((n, {age}) => n + age, 0) / s.length);
            }
            return getArrayMaxByProperty(tempParticipants, 'age').name
        }
    }

    return null;
}

async function checkBrandSegmentAndGetParticipants(segmentItem, participants, consequenceData) {  // check_brand_segment_and_get_participants
    // Returns array: [data, modified participants]
    let data = {};

    if (segmentItem.consequence === 'draft-talent-to-brand') {
        // Get brand
        let brand = await Brands.get(consequenceData['brandUid']);
        if (!brand) {
            data['error'] = 'brand-not-found';
            return [data, participants];
        }

        // Get talent
        let talent;
        if (consequenceData['talentType'] === 'superstar') {
            talent = await Superstars.get(consequenceData['talentUid']);
        }
        else {
            talent = await TagTeams.get(consequenceData['talentUid']);
        }
        if (!talent) {
            data['error'] = 'talent-not-found';
            return [data, participants];
        }
        if ((await getRosterMemberSuperstars(talent)).some(x => x.brandName === brand.name)) {
            data['error'] = 'already-on-brand';
            return [data, participants];
        }

        participants.push(talent);
    }

    return [data, participants];
}

async function checkManagerSegmentAndGetParticipants(segmentItem, participants, rosterSuperstars, managedTalentUid,
                                                     managerUid) {  // check_manager_segment_and_get_participants
    // Returns array: [data, modified participants]
    let data = {};

    // Add managed talent for manager segments
    if (['boost-managed-talent', 'remove-managed-talent'].includes(segmentItem.consequence)) {
        let managedTalent = await getManagerManagedTalent(participants[0], rosterSuperstars, true);
        if (managedTalent.length <= 0) {
            data['error'] = 'no-managed-talent';
            return [data, participants];
        }

        // Get talent from managed talent
        let talent;
        if (managedTalentUid) {
            talent = managedTalent.find(x => x.$loki === managedTalentUid)
        }
        else {
            talent = managedTalent[0]
        }
        participants.push(talent);
    }

    // Get manager for remove manager segment
    if (segmentItem.consequence === 'remove-manager') {
        let managerId = null;
        let manager = null;

        // Get manager if managing all participant superstars
        let participantSuperstars = await getRosterMemberSuperstars(participants[0]);
        managerId = participantSuperstars.every(y => y.managerId === participantSuperstars[0].managerId) ?
            participantSuperstars[0].managerId : null;
        if (managerId) {
            manager = rosterSuperstars.find(x => x.$loki === managerId)
        }
        if (!manager) {
            data['error'] = 'no-manager-present';
            return [data, participants];
        }

        participants.unshift(manager);
    }

    // Get manager for add manager segment
    if (segmentItem.consequence === 'add-manager') {
        // Get manager
        let manager = await Superstars.get(managerUid);
        if (!manager) {
            data['error'] = 'manager-not-found';
            return [data, participants];
        }

        // Check participant superstars
        let participantSuperstars = await getRosterMemberSuperstars(participants[0]);
        for (const s of participantSuperstars) {
            if (s.managerId) {
                data['error'] = 'manager-present';
                data['superstarName'] = s.name;
                return [data, participants];
            }
            if (s.$loki === manager.$loki) {
                data['error'] = 'managing-self';
                return [data, participants];
            }
            if (s.fullTimeManager) {
                data['error'] = 'managing-full-time-manager';
                return [data, participants];
            }
        }

        // Check for maximum superstars for manager
        let managedSuperstars = [...(await getSuperstarManagedSuperstars(manager))];
        if (participantSuperstars.length + managedSuperstars.length > 15) {
            data['error'] = 'maximum-superstars';
            return [data, participants];
        }

        participants.unshift(manager);
    }

    return [data, participants];
}

async function checkFactionSegmentConsequence(factions, segmentItem, consequenceData, rosterSuperstars, roster, event,
                                              companyChampionships) {  // check_faction_segment_consequence
    let data = {};

    // Don't run consequence for disbanded faction
    if (factions.length > 0 && factions[0].disbanded) {
        data['error'] = 'selected-disbanded-faction';
        return data;
    }

    // Faction superstar availability function
    function checkFactionSuperstarAvailability(superstar) {
        return checkAvailability(superstar, true, true) &&
            checkSuperstarBrandAvailability(event, superstar,
            getSuperstarChampionshipsFromCompanyChampionships(superstar, companyChampionships));
    }

    // Remove faction members
    if (segmentItem.consequence === 'remove-faction-members') {
        let existingFactionSuperstars = await getFactionSuperstars(factions[0]);

        // Get superstars to remove
        let superstarsToRemove = [];
        for (const superstarUid of consequenceData['superstarUids']) {
            let superstar = await Superstars.get(superstarUid);
            // Check if superstar present, is in this faction and is available
            if (!superstar) {
                data['error'] = 'faction-superstar-not-found';
                return data;
            }
            if (!objectInArray(superstar, existingFactionSuperstars)) {
                data['error'] = 'not-member-of-faction';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data['error'] = 'faction-superstar-not-available';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            superstarsToRemove.push(superstar)
        }

        // Remove duplicates
        superstarsToRemove = getUniqueObjects(superstarsToRemove);

        // Check if faction superstars are above 2
        if (existingFactionSuperstars.length - superstarsToRemove.length < 2) {
            data['error'] = 'minimum-faction-superstars';
            return data;
        }
    }

    // Add faction members
    if (segmentItem.consequence === 'add-faction-members') {
        let existingFactionSuperstars = await getFactionSuperstars(factions[0]);

        // Get superstars to add
        let superstarsToAdd = [];
        for (const superstarUid of consequenceData['superstarUids']) {
            let superstar = await Superstars.get(superstarUid);
            // Check if superstar present, not in this or any other faction and is available
            if (!superstar) {
                data['error'] = 'faction-superstar-not-found';
                return data;
            }
            if (objectInArray(superstar, existingFactionSuperstars)) {
                data['error'] = 'already-member-of-faction';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            if ((await getSuperstarActiveFactions(superstar)).length > 0) {
                data['error'] = 'already-in-faction';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data['error'] = 'faction-superstar-not-available';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            superstarsToAdd.push(superstar)
        }

        // Remove duplicates
        superstarsToAdd = getUniqueObjects(superstarsToAdd);

        // Check if faction superstars are below maximum
        if (existingFactionSuperstars.length + superstarsToAdd.length > gameLimits.maxFactionSuperstars) {
            data['error'] = 'maximum-faction-superstars';
            return data;
        }
    }

    // Leader consequences
    if (['change-faction-leader', 'add-faction-leader', 'kick-out-faction-leader-and-change-leader']
        .includes(segmentItem.consequence)) {
        let existingFactionSuperstars = await getFactionSuperstars(factions[0]);
        let leaderSuperstar = await getFactionLeaderSuperstar(factions[0]);

        for (const superstarUid of consequenceData['superstarUids']) {
            let superstar = await Superstars.get(superstarUid);
            // Check if new leader superstar is present, is in this faction, is not already leader and is available
            if (!superstar) {
                data['error'] = 'faction-superstar-not-found';
                return data;
            }
            // Allow any superstar for add-faction-leader, otherwise only allow member of faction
            if (segmentItem.consequence !== 'add-faction-leader' &&
                !objectInArray(superstar, existingFactionSuperstars)) {
                data['error'] = 'leader-superstar-not-present';
                return data;
            }
            if (leaderSuperstar && superstar.$loki === leaderSuperstar.$loki) {
                data['error'] = 'select-non-faction-leader';
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data['error'] = 'faction-superstar-not-available';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
        }

        // Check if faction superstars are above 2 for kicking out leader
        if (segmentItem.consequence === 'kick-out-faction-leader-and-change-leader') {
            if (existingFactionSuperstars.length - 1 < 2) {
                data['error'] = 'minimum-faction-superstars';
                return data;
            }
        }
    }

    // Join other faction
    if (segmentItem.consequence === 'leave-faction-and-join-other-faction') {
        let factionToJoin = await Factions.get(consequenceData['factionConsequenceUids'][0]);
        // Check faction to join is present, is active and not the same as existing faction
        if (!factionToJoin) {
            data['error'] = 'faction-not-found';
            return data;
        }
        if (factionToJoin.disbanded) {
            data['error'] = 'selected-disbanded-faction';
            return data;
        }
        if (factionToJoin.$loki === factions[0].$loki) {
            data['error'] = 'selected-existing-faction';
            return data;
        }

        let existingFactionSuperstars = await getFactionSuperstars(factions[0]);
        let factionToJoinSuperstars = await getFactionSuperstars(factionToJoin);

        // Get superstars to move
        let superstarsToMove = [];
        for (const superstarUid of consequenceData['superstarUids']) {
            let superstar = await Superstars.get(superstarUid);
            // Check if superstar present, in this faction, not in faction to join and is available
            if (!superstar) {
                data['error'] = 'faction-superstar-not-found';
                return data;
            }
            if (!objectInArray(superstar, existingFactionSuperstars)) {
                data['error'] = 'not-member-of-faction';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            if (objectInArray(superstar, factionToJoinSuperstars)) {
                data['error'] = 'already-member-of-faction';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data['error'] = 'faction-superstar-not-available';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            superstarsToMove.push(superstar)
        }

        // Remove duplicates
        superstarsToMove = getUniqueObjects(superstarsToMove);

        // Check if existing faction's superstars are above 2
        if (existingFactionSuperstars.length - superstarsToMove.length < 2) {
            data['error'] = 'minimum-faction-superstars';
            return data;
        }

        // Check if faction to join's superstars are below maximum
        if (factionToJoinSuperstars.length + superstarsToMove.length > gameLimits.maxFactionSuperstars) {
            data['error'] = 'maximum-faction-superstars';
            return data;
        }
    }

    // Merge factions
    if (segmentItem.consequence === 'merge-factions') {
        let factionToMerge = await Factions.get(consequenceData['factionConsequenceUids'][0]);
        // Check faction to merge is present, is active and not the same as existing faction
        if (!factionToMerge) {
            data['error'] = 'faction-not-found';
            return data;
        }
        if (factionToMerge.disbanded) {
            data['error'] = 'selected-disbanded-faction';
            return data;
        }
        if (factionToMerge.$loki === factions[0].$loki) {
            data['error'] = 'selected-existing-faction';
            return data;
        }

        // Check created faction name
        let createdFactionName = consequenceData['createdFactionName'];
        if (!createdFactionName) {
            data['error'] = 'faction-name-not-entered';
            return data;
        }

        // Check if faction already exists
        let otherActiveFactions = (await getRosterActiveFactions(roster))
            .filter(x => x.$loki !== factions[0].$loki && x.$loki !== factionToMerge.$loki);
        if (otherActiveFactions.find(x => x.name === createdFactionName)) {
            data['error'] = 'faction-already-present';
            return data;
        }

        // Check if team already exists
        if ((await getRosterTagTeams(roster)).find(x => x.name === createdFactionName)) {
            data['error'] = 'team-already-present';
            return data;
        }

        let existingFactionSuperstars = await getFactionSuperstars(factions[0]);
        let factionToMergeSuperstars = await getFactionSuperstars(factionToMerge);

        // Check if resulting faction's superstars are below maximum
        if (factionToMergeSuperstars.length + existingFactionSuperstars.length > gameLimits.maxFactionSuperstars) {
            data['error'] = 'maximum-faction-superstars';
            return data;
        }
    }

    // Split faction
    if (segmentItem.consequence === 'split-faction') {
        let existingFactionSuperstars = await getFactionSuperstars(factions[0]);

        // Check created faction name
        let createdFactionName = consequenceData['createdFactionName'];
        if (!createdFactionName) {
            data['error'] = 'faction-name-not-entered';
            return data;
        }

        // Check if faction already exists
        if ((await getRosterActiveFactions(roster)).find(x => x.name === createdFactionName)) {
            data['error'] = 'faction-already-present';
            return data;
        }

        // Check if team already exists
        if ((await getRosterTagTeams(roster)).find(x => x.name === createdFactionName)) {
            data['error'] = 'team-already-present';
            return data;
        }

        // Get superstars to move
        let superstarsToMove = [];
        for (const superstarUid of consequenceData['superstarUids']) {
            let superstar = await Superstars.get(superstarUid);
            // Check if superstar present, in this faction and is available
            if (!superstar) {
                data['error'] = 'faction-superstar-not-found';
                return data;
            }
            if (!objectInArray(superstar, existingFactionSuperstars)) {
                data['error'] = 'not-member-of-faction';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data['error'] = 'faction-superstar-not-available';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            superstarsToMove.push(superstar)
        }

        // Remove duplicates
        superstarsToMove = getUniqueObjects(superstarsToMove);

        // Check if existing faction's superstars are above 2
        if (existingFactionSuperstars.length - superstarsToMove.length < 2) {
            data['error'] = 'minimum-faction-superstars';
            return data;
        }

        // Check if new faction superstars are above 2
        if (superstarsToMove.length < 2) {
            data['error'] = 'minimum-faction-superstars';
            return data;
        }
    }

    // Create faction
    if (segmentItem.consequence === 'create-faction') {

        // Check created faction name
        let createdFactionName = consequenceData['createdFactionName'];
        if (!createdFactionName) {
            data['error'] = 'faction-name-not-entered';
            return data;
        }

        // Check if faction already exists
        if ((await getRosterActiveFactions(roster)).find(x => x.name === createdFactionName)) {
            data['error'] = 'faction-already-present';
            return data;
        }

        // Check if team already exists
        if ((await getRosterTagTeams(roster)).find(x => x.name === createdFactionName)) {
            data['error'] = 'team-already-present';
            return data;
        }

        // Get superstars to add
        let superstarsToAdd = [];
        for (const superstarUid of consequenceData['superstarUids']) {
            let superstar = await Superstars.get(superstarUid);
            // Check if superstar present, not in faction and is available
            if (!superstar) {
                data['error'] = 'faction-superstar-not-found';
                return data;
            }
            if ((await getSuperstarActiveFactions(superstar)).length > 0) {
                data['error'] = 'already-in-faction';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data['error'] = 'faction-superstar-not-available';
                data['errorSuperstarName'] = superstar.name;
                return data;
            }
            superstarsToAdd.push(superstar)
        }

        // Remove duplicates
        superstarsToAdd = getUniqueObjects(superstarsToAdd);

        // Get leader superstar
        if (consequenceData['leaderUid']) {
            let leaderSuperstar = await Superstars.get(consequenceData['leaderUid']);
            // Check if present in faction superstars
            if (leaderSuperstar && !objectInArray(leaderSuperstar, superstarsToAdd)) {
                data['error'] = 'leader-superstar-not-present';
                return data;
            }
        }

        // Check if number of superstars are between 2 and maximum
        if (superstarsToAdd.length < 2) {
            data['error'] = 'minimum-faction-superstars';
            return data;
        }
        if (superstarsToAdd.length > gameLimits.maxFactionSuperstars) {
            data['error'] = 'maximum-faction-superstars';
            return data;
        }
    }

    return data;
}

async function addProducerSegmentTask(producer, segment, segmentItem) {  // add_producer_segment_task
    if (!segmentItem) {
        segmentItem = await getSegmentSegmentItem(segment)
    }
    producer.currentTask = `Producing ${segmentItem.name} Segment`;
    producer.taskData = {'segment_id': segment.$loki};
    return true
}

async function getHypeForSegment(participants, feuds, segmentItem) {  // get_hype_for_segment
    if (segmentItem.productionSegment) {
        return 0
    }
    let feudHype = getHypeForFeuds(feuds, participants);
    let participantsHype = await getHypeForParticipants(participants);
    let segmentItemHype = getHypeForSegmentItem(segmentItem);
    return Math.floor(feudHype + participantsHype + segmentItemHype);
}

function getHypeForFeuds(feuds, participants) {
    let hype = 0;

    for (const feud of feuds) {
        if (feud.started) {
            hype += feud.hype / 4;
            if (feud.hot) {
                hype += 15
            }
            if (feud.stale) {
                hype -= 15
            }
        }
    }

    if (participants.length > 10) {
        hype *= 0.3
    }
    else if (participants.length > 2) {
        hype *= 0.7
    }

    hype = limitValueBetweenRange(hype, hype, 100);

    return hype;
}

async function getHypeForParticipants(participants) {  // get_hype_for_participants
    let hype = 0;

    let brandsPresent = [];
    for (const p of participants) {
        let s = await getRosterMemberSuperstars(p);
        if ((await getRosterMemberRank(p, s)) === 'Main Eventer') {
            hype += 5;
        }
        if (s.some(x => x.hot)) {
            hype += 15
        }
        if (s.some(x => x.stale)) {
            hype -= 15
        }
        for (const x of s) {
            if (x.brandName) {
                brandsPresent.push(x.brandName)
            }
        }
    }

    // Boost hype if more than one brand present
    if ([... new Set(brandsPresent)].length > 1) {
        hype += 15
    }

    hype = limitValueBetweenRange(hype, -80, 80);

    return hype;
}

function getHypeForSegmentItem(segmentItem) {
    let hype = 0;
    let total = segmentItem.action + segmentItem.entertainment;

    if (total <= 3) {
        hype = total * 5
    }
    else if (total <= 4) {
        hype = total * 10
    }
    else {
        hype = total * 20
    }
    if (segmentItem.consequence) {
        hype += 15
    }

    return hype;
}

async function getFactionTemporaryTagTeam(participant, factionSuperstars, mainRoster) {
    let temporaryFactionTeam = (await getRosterTagTeams(mainRoster))
        .find(x => x.name === participant.name && x.temporary);

    // Check if temporary faction team already made
    let temporaryFactionTeamSuperstars = temporaryFactionTeam ?
        await getTagTeamSuperstars(temporaryFactionTeam) : [];
    if (temporaryFactionTeam && temporaryFactionTeamSuperstars.length === factionSuperstars.length &&
        temporaryFactionTeamSuperstars.every(x => objectInArray(x, factionSuperstars))) {
        return temporaryFactionTeam;
    }

    // Otherwise, create temporary team
    else {
        const newTagTeam = TagTeam(participant.name, true);
        newTagTeam.factionTagTeam = true;
        await TagTeams.insert(newTagTeam);
        await addTagTeamSuperstars(newTagTeam, factionSuperstars);
        await addRosterTagTeams(mainRoster, [newTagTeam]);
        return newTagTeam;
    }
}

async function deleteCompanySegment({uid} = {}) {  // delete_segment_view
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const latestEvent = await getCompanyLatestEvent(userCompany);
    let eventSegments = await getEventSegments(latestEvent);
    const eventMatches = await getEventMatches(latestEvent);
    const segment = eventSegments.find(x => x.$loki === uid);
    const staffMembers = await getCompanyStaff(userCompany);
    const producers = await getAvailableStaffMembersByRole(staffMembers, 'producer');

    // Don't allow deleting 'Welcome to POW' promo at premier event in POW
    if (userCompany.storyName === 'passion') {
        const segmentItem = await getSegmentSegmentItem(segment);
        const sponsorGoal = (await getCompanyObjectives(userCompany)).find(x => x.name === 'Get some Sponsors');
        if (!sponsorGoal.completed && !sponsorGoal.failed && segmentItem.name === 'Welcome to POW') {
            data['error'] = 'pow-cannot-delete';
            return data;
        }
    }

    // Delete segment
    await deleteSegment(segment, producers);

    // Subtract from event's matchesCount
    latestEvent.matchesCount -= 1;

    // Reset event's matches and segments order
    eventSegments = eventSegments.filter(x => x.$loki !== segment.$loki);
    let segmentsAndMatches = eventSegments.concat(eventMatches);
    segmentsAndMatches.sort((a, b) => a.order - b.order);
    for (const x of segmentsAndMatches) {
        x.order = segmentsAndMatches.indexOf(x);
    }

    db.saveDatabase();

    return data;
}

async function deleteSegment(segment, producers) {  // delete_segment
    // Remove feuds
    for (const feud of (await getSegmentFeuds(segment))) {
        // Delete potential feuds
        if (!feud.started && !feud.directFeudEvent) {
            await FeudParticipantsHash.findAndRemove({"feudId": feud.$loki});
            await Feuds.remove(feud);
        }
    }

    // Reset special segment item
    const segmentItem = await getSegmentSegmentItem(segment);
    if (segmentItem && segmentItem.special) {
        segmentItem.used = false;
    }

    // Remove producer task
    const segmentProducer = getSegmentProducer(segment, producers);
    if (segmentProducer) {
        removeStaffTaskData(segmentProducer)
    }

    // Delete from db
    await FeudSegmentsHash.findAndRemove({"segmentId": segment.$loki});
    await SegmentParticipantsHash.findAndRemove({"segmentId": segment.$loki});
    await Segments.remove(segment);

    return true;
}

async function addProducerToSegment({segmentUid, producerUid} = {}) {  // add_producer_to_segment
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const staffMembers = await getCompanyStaff(userCompany);
    const producers = await getAvailableStaffMembersByRole(staffMembers, 'producer');

    // Check paid
    if (!globalUser.paid) {
        data['error'] = 'not-paid';
        return data;
    }

    // Get segment
    const segment = await Segments.get(segmentUid);
    if (!segment) {
        data['error'] = 'segment-not-found';
        return data;
    }

    // Get producer
    const producer = producers.find(x => x.$loki === producerUid);
    if (!producer) {
        data['error'] = 'producer-not-found';
        return data;
    }

    // Check for current task
    if (producer.currentTask) {
        data['error'] = 'producer-task-present';
        data['producer'] = producer.name;
        return data;
    }

    // Add producer task
    await addProducerSegmentTask(producer, segment);

    db.saveDatabase();

    // Get data to return
    data['segment'] = await getSegmentData({segment: segment, rosterSuperstars: rosterSuperstars, producers: producers});

    return data;
}

async function removeProducerFromSegment({segmentUid} = {}) {  // remove_producer_from_segment
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const staffMembers = await getCompanyStaff(userCompany);
    const producers = await getAvailableStaffMembersByRole(staffMembers, 'producer');

    // Get segment
    const segment = await Segments.get(segmentUid);
    if (!segment) {
        data['error'] = 'segment-not-found';
        return data;
    }

    // Get producer
    const producer = getSegmentProducer(segment, producers);
    if (!producer) {
        data['error'] = 'no-producer-assigned';
        return data;
    }

    // Remove producer task
    removeStaffTaskData(producer);

    db.saveDatabase();

    // Get data to return
    data['segment'] = await getSegmentData({segment: segment, rosterSuperstars: rosterSuperstars, producers: producers});

    return data;
}

async function playSegment({winnerName, uid, graphics} = {}) {
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainCompany = await getGameMainUserCompany(currentGame);
    const latestEvent = await getCompanyLatestEvent(userCompany);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const indieRoster = await getCompanyRosterByType(mainCompany, 'indie');
    const indieAvailableRoster = await getCompanyRosterByType(mainCompany, 'indieAvailable');

    // Get segment
    const eventSegments = await getEventSegments(latestEvent);
    const segment = eventSegments.find(x => x.$loki === uid);

    try {
        data = await processPlaySegment(segment, winnerName, eventSegments, latestEvent, userCompany, mainCompany,
            currentGame, mainRoster, indieRoster, indieAvailableRoster, graphics);

        // Check tutorial action
        if (userCompany.storyName === 'tutorial') {
            data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['play_second_event',
                'play_second_event_second_segment'])
        }

        db.saveDatabase();
    }
    catch (error) {
        data['error'] = true;
        await loadDb(db.filename);

        // Check if any empty teams present, return in error
        const segment = await Segments.get(uid);
        const tagTeams = await getSegmentTagTeams(segment);
        for (const tagTeam of tagTeams) {
            if (!(await getTagTeamSuperstars(tagTeam)).length) {
                data['error'] = 'team-members-not-found';
                data['teamName'] = tagTeam.name;
                break;
            }
        }

        if (data['error'] !== 'team-members-not-found') {
            captureError(error);
        }
    }
    return data;
}

async function processPlaySegment(segment, winnerName, eventSegments, event, company, mainCompany, game,
                                  mainRoster, indieRoster, indieAvailableRoster, graphics, rosterSuperstars = null,
                                  companyChampionships = null, staffMembers = null, segmentsAndMatches = null) {  // run_segment
    try {
        let data = {};
        const segmentParticipants = await getSegmentParticipants(segment);
        const segmentFeuds = await getSegmentFeuds(segment);
        const segmentItem = await getSegmentSegmentItem(segment);
        const month = game.monthCount;
        const year = game.year;
        if (!staffMembers) {
            staffMembers = await getCompanyStaff(company);
        }
        if (!companyChampionships) {
            companyChampionships = await getCompanyChampionships(company);
        }
        if (!rosterSuperstars) {
            rosterSuperstars = await getRosterSuperstars(mainRoster);
        }
        if (!segmentsAndMatches) {
            segmentsAndMatches = await getEventMatchesAndSegments(event);
        }

        // Check if weekly show
        const weeklyShow = event.weeklyShow || event.name === 'Weekly Show';

        // Check if main event
        segmentsAndMatches.sort((a, b) => a.order - b.order);
        const mainEvent = segment.$loki === segmentsAndMatches[0].$loki && segment.objectName === segmentsAndMatches[0].objectName;

        // Declare variables
        let purePositiveBoost = null;
        let pureNegativeBoost = null;
        let updateGraphics = null;

        // Declare arrays
        data['vacated'] = [];
        data['createdChampionships'] = [];
        data['fired'] = [];
        data['feudPotentials'] = [];
        data['feudHypeIncreased'] = [];
        data['feudsEnded'] = [];
        data['awarded'] = [];
        data['feudItemsLevelData'] = [];
        data['unlockedFeudItems'] = [];
        data['turnedHeel'] = [];
        data['turnedFace'] = [];
        data['turnedNeutral'] = [];
        data['feudsStarted'] = [];
        data['disbanded'] = [];
        data['debutedGimmicks'] = [];
        data['staffSkillIncreases'] = [];
        data['championshipPrestiges'] = [];
        data['unlockedChampionshipSegmentItems'] = [];
        data['unavailable'] = [];
        data['suspended'] = [];
        data['retirements'] = [];
        data['teamsCreated'] = [];
        data['managersAdded'] = [];
        data['managersRemoved'] = [];
        data['factionReputationsData'] = [];
        data['brandChanges'] = [];
        data['maskRemoved'] = [];

        // Get segment superstars
        let segmentSuperstars = [];
        for (const x of segmentParticipants) {
            let s = await getRosterMemberSuperstars(x);
            x.tempSuperstars = s;
            segmentSuperstars.push(...s);
        }

        // Set stating morale for matchSuperstars
        for (const x of segmentSuperstars) {
            x.startingMorale = x.morale;
            x.startingOverness = x.overness;
        }

        // Get winner
        let winnerParticipant = segmentParticipants.find(x => x.name === winnerName);

        // Get producer
        let producer;
        const producers = getAvailableStaffMembersByRole(staffMembers, 'producer');
        const assignedProducer = getSegmentProducer(segment, producers);
        // Get assigned producer if present, otherwise select random/highest level producer
        if (assignedProducer) {
            producer = assignedProducer;
        } else if (producers.length > 0) {
            if (segmentItem.requirement &&
                (segmentItem.requirement.includes('level-2-producer') || segmentItem.requirement.includes('level-3-producer'))) {
                producer = getHighestLevelStaffMemberByRole(producers, 'producer');
            } else {
                producer = getRandomStaffMemberByRole(producers, 'producer');
            }
        }

        // Set winner for no winner segment
        if (!winnerParticipant) {
            if (segment.consequenceAppliedTo) {
                winnerParticipant = segmentParticipants.find(x => x.name === segment.consequenceAppliedTo);
            } else {
                if (segmentItem.maxParticipants > 0 || segmentItem.consequence === 'draft-talent-to-brand') {
                    winnerParticipant = getRandomChoice(segmentParticipants);
                }
            }
        }

        // Get segment championships
        let segmentChampionship = null;
        if (segmentItem.consequence === 'award-title') {
            if (segment.consequenceData) {
                const championshipUid = segment.consequenceData['championshipUid'];
                if (championshipUid) {
                    segmentChampionship = await Championships.get(championshipUid);
                    if (segmentChampionship) {
                        segmentChampionship = companyChampionships.filter(x => checkAreChampionshipsEqual(x, segmentChampionship))
                    }
                }
            }
        } else {
            segmentChampionship = await getSegmentParticipantsChampionship(segmentParticipants);
        }

        // Convert segment championship(s) to list
        let segmentChampionships = [];
        if (segmentChampionship) {
            if (Array.isArray(segmentChampionship)) {
                segmentChampionships = segmentChampionship;
            } else {
                segmentChampionships = [segmentChampionship];
            }
        }

        // Get participants data
        data['participantsData'] = [];
        for (const x of [...segmentParticipants]) {
            const participantData = {};
            participantData['name'] = x.name;
            participantData['uid'] = x.$loki;
            participantData['pronoun'] = x.possessivePronoun;
            participantData['startingOverness'] = await getRosterMemberOverness(x);
            participantData['gimmickEffectivenessChange'] = 0;
            participantData['moraleChange'] = 0;
            participantData['hot'] = x.tempSuperstars.every(s => s.hot);
            participantData['stale'] = x.tempSuperstars.every(s => s.stale);
            participantData['managersData'] = await getParticipantManagersData(x, segment.managersUsed, rosterSuperstars);
            data['participantsData'].push(participantData);
        }

        // Remove gimmick change boost before segment runs
        for (const s of segmentSuperstars) {
            const superstarGimmick = await getSuperstarCurrentGimmick(s);
            if (superstarGimmick && superstarGimmick.nextGimmickBoost) {
                superstarGimmick.nextGimmickBoost = false;
            }
        }

        // Get managers present in segment
        const segmentManagers = [];
        const segmentFullTimeManagers = [];
        for (const s of segmentSuperstars) {
            const superstarManager = await getSuperstarManagerUsedForMatchOrSegment(s, segment.managersUsed, rosterSuperstars);
            if (superstarManager && !objectInArray(superstarManager, segmentManagers)) {
                segmentManagers.push(superstarManager);
                // Add manager to segment if full time
                if (superstarManager.fullTimeManager && !objectInArray(superstarManager, segmentFullTimeManagers)) {
                    segmentFullTimeManagers.push(superstarManager);
                }
            }
        }

        // Add managers to participant/superstars list with managers
        const participantsWithManagers = [...segmentParticipants];
        const segmentSuperstarsWithManagers = [...segmentSuperstars];
        participantsWithManagers.push(...segmentFullTimeManagers);
        segmentSuperstarsWithManagers.push(...segmentFullTimeManagers);

        // Get managed participant for manager segments
        let managedParticipant;
        let managedSuperstars = [];
        if (['boost-managed-talent', 'add-manager', 'remove-manager', 'remove-managed-talent'].includes(segmentItem.consequence)) {
            data['managerSegment'] = true;
            managedParticipant = segmentParticipants.find(x => x.objectName === 'tagTeam' || x.managerId);
            if (managedParticipant) {
                managedSuperstars = await getRosterMemberSuperstars(managedParticipant);
                if (segmentItem.consequence === 'boost-managed-talent') {
                    // Remove from participants so segment rating is only based on manager
                    participantsWithManagers.splice(participantsWithManagers.indexOf(managedParticipant), 1);
                    for (const y of managedSuperstars) {
                        segmentSuperstarsWithManagers.splice(segmentSuperstarsWithManagers.indexOf(y), 1);
                    }
                }
                // Set managed participant as winner
                winnerParticipant = managedParticipant;
            }
        }

        // Check if segment already held
        const segmentAlreadyHeld = await checkSegmentAlreadyHeld(segment, segmentItem, event, eventSegments, segmentFeuds);

        // Get boosts for silly/action segments in pure companies
        if (company.style === 'pure' && getRandomInt(0, 100) <= 40) {
            if (segmentItem.silly) {
                pureNegativeBoost = true;
            } else if (segmentItem.action > segmentItem.entertainment && segmentItem.action > 1) {
                purePositiveBoost = true;
            }
        }

        // Get rating
        let ratingData;
        let talentDebutRelationship = await getTalentDebutRelationship(segmentItem, segmentParticipants, company);
        if (segmentItem.productionSegment || !segmentParticipants.length) {
            // Use producer to get rating if production segment or no participants present (competitor buyout etc)
            ratingData = getProductionSegmentRating(producer, segmentAlreadyHeld, assignedProducer);
        } else {
            ratingData = await getSegmentRating(segmentItem, participantsWithManagers, purePositiveBoost, pureNegativeBoost,
                segmentSuperstarsWithManagers, segmentAlreadyHeld, talentDebutRelationship, assignedProducer, company.storyName);
        }
        const rating = ratingData['rating'];
        const effectiveness = ratingData['effectiveness'];
        data['ratingData'] = ratingData;
        segment.rating = rating;

        // Set participants
        segment.participants = segmentParticipants.map(x => x.name);

        // Run consequences
        let shockingTurn = false;
        let turnTooSoon = false;
        if (segmentItem.consequence) {
            const consequenceResults = await runSegmentConsequence(segmentItem, segment, segmentParticipants, company, mainCompany,
                game, month, year, indieRoster, indieAvailableRoster, winnerParticipant, graphics, segmentManagers);

            shockingTurn = consequenceResults['shockingTurn'];
            turnTooSoon = consequenceResults['turnTooSoon'];
            data['consequenceResults'] = consequenceResults;
            data['vacated'] = consequenceResults['vacated'];
            data['fired'] = consequenceResults['fired'];
            data['feudsEnded'] = consequenceResults['feudsEnded'];
            data['awarded'] = consequenceResults['awarded'];
            data['createdChampionships'] = consequenceResults['createdChampionships'];
            data['feudItemsLevelData'] = consequenceResults['feudItemsLevelData'];
            data['unlockedFeudItems'] = consequenceResults['unlockedFeudItems'];
            data['turnedHeel'] = consequenceResults['turnedHeel'];
            data['turnedFace'] = consequenceResults['turnedFace'];
            data['turnedNeutral'] = consequenceResults['turnedNeutral'];
            data['feudsStarted'] = consequenceResults['feudsStarted'];
            data['feudPotentials'] = consequenceResults['feudPotentials'];
            data['feudHypeIncreased'] = consequenceResults['feudHypeIncreased'];
            data['disbanded'] = consequenceResults['disbanded'];
            data['consequenceRunOn'] = consequenceResults['consequenceRunOn'];
            data['hypeBoostAdded'] = consequenceResults['hypeBoostAdded'];
            data['mainEventHype'] = consequenceResults['mainEventHype'];
            data['eventHype'] = consequenceResults['eventHype'];
            data['popularityBoostAdded'] = consequenceResults['popularityBoostAdded'];
            data['unavailable'] = consequenceResults['unavailable'];
            data['suspended'] = consequenceResults['suspended'];
            data['retirements'] = consequenceResults['retirements'];
            data['teamsCreated'] = consequenceResults['teamsCreated'];
            data['factionSegmentConsequence'] = consequenceResults['factionSegmentConsequence'];
            data['factionReputationsData'] = consequenceResults['factionReputationsData'];
            data['managersAdded'] = consequenceResults['managersAdded'];
            data['managersRemoved'] = consequenceResults['managersRemoved'];
            data['brandChanges'] = consequenceResults['brandChanges'];
            data['maskRemoved'] = consequenceResults['maskRemoved'];
            data['unifiedChampionships'] = consequenceResults['unifiedChampionships'];

            // Check whether to update graphics
            if (consequenceResults['graphics']) {
                updateGraphics = true;
                graphics = consequenceResults['graphics'];
            }
        } else {
            // Add consequenceRunOn to show name in results section
            if (segmentItem.requirement === 'buyout-offer-accepted') {
                const competitor = (await getActiveCompetitorsForCompany(company, game))
                    .find(c => c.operatingStatus.includes('Negotiating Buyout'));
                data['consequenceRunOn'] = competitor.name;
            }
        }

        // Special segment consequence
        if (segmentItem.special) {
            data['specialSegmentConsequence'] = await runSpecialSegmentConsequence(segmentItem, segment, segmentParticipants,
                company, mainCompany, staffMembers, game, month, year);

            // Add special segments to company logs
            let newLog = CompanyLog(month, year);
            newLog.text = `${segmentItem.name} with ${segmentParticipants[0].name}`;
            newLog.type = 'special-segment';
            await CompanyLogs.insert(newLog);
            await addCompanyCompanyLogs(company, [newLog]);

            if (company.userControlled && game.settings['no_special_items_cooldown']) {
                segmentItem.used = false;
            }
        }

        // Get hype, popularity and xp changes, hot
        const hotSegment = checkSegmentHot(segment, segmentParticipants, segmentSuperstars, segmentFeuds, shockingTurn,
            turnTooSoon, segmentItem.special);
        const [baseHypeChange, popularityChange, sillySuccess, sillyFailure] = getSegmentBoosts(rating, segmentItem, hotSegment);
        const trainer = getHighestLevelStaffMemberByRole(staffMembers, 'trainer');
        const trainerLevel = trainer ? trainer.level : 1;
        const xpGained = getSegmentXps(rating, segment.order, segmentItem.difficulty, trainerLevel);

        // Update segment item prestige
        let segmentItemLevelData = null;
        const unlockedSegmentItems = [];
        if (globalUser.paid && !segmentItem.special) {
            let levelIncrease = false;
            let addedPerk = null;

            // Add xp
            const increase = Math.floor(Math.pow(rating, 2));
            segmentItem.xp += increase;

            // Check level increase
            if (segmentItem.level < 3 && segmentItem.xp >= Math.pow(segmentItem.level, 2) * 75) {
                segmentItem.level += 1;
                levelIncrease = true;

                // Add perk if level increase
                addedPerk = addPerkToSegmentItem(segmentItem);
            }

            // Prepare data
            segmentItemLevelData = {
                'name': segmentItem.name,
                'xp': segmentItem.xp,
                'xpChange': increase,
                'level': segmentItem.level,
                'levelIncrease': levelIncrease,
                'addedPerk': addedPerk,
            };

            const unlocked = checkSegmentItemsToUnlock(segmentItem, (await getCompanySegmentItems(company)));
            unlockedSegmentItems.push(...unlocked);
        }

        // Process feuds
        let feudsData = [];
        let hotFeuds = [];
        for (const feud of segmentFeuds) {
            // Get participants and superstars
            let feudParticipants = await getFeudParticipants(feud);
            let feudSuperstars = (await Promise.all(feudParticipants.map(x => getRosterMemberSuperstars(x)))).flat();

            // Check hot
            let hotFeud = checkFeudHot(feud, segment.rating, feudSuperstars);
            let hotFeudHypeBoost = 0;
            if (hotFeud) {
                if (!hotSegment) {
                    hotFeudHypeBoost = getRandomInt(15, 20);
                }
                if (feudParticipants.map(x => x.name).includes(company.ownerName)) {
                    await unlockSpecialSegment(company, 'Anti-Company Rant', month, year);
                }
            }

            let started;
            const feudItem = await getFeudFeudItem(feud);
            if (!feud.started) {
                // Start feud
                started = false;
                feud.started = true;
                if (feud.startMonth === null) {
                    feud.startMonth = month;
                    feud.startYear = year;
                }
                // Remove any added blowoffs
                feud.runBlowoff = false;

                // Add hype
                let boosts = await getFeudCreationBoosts(feud, feudParticipants, month, year, company.style);
                feud.hype = feudItem.baseHype + boosts['hypeBoost'];

                // Get feud started data
                data['feudsStarted'].push({
                    'name': feud.name,
                    'participants': feudParticipants.map(x => x.name),
                    'boosts': boosts,
                    'baseHype': feudItem.baseHype
                });

                // Check talent request and update morale
                for (const feudParticipant of feudParticipants) {
                    let otherFeudParticipant = feudParticipants.find(x => x.$loki !== feudParticipant.$loki);
                    if (otherFeudParticipant) {
                        // Check feud_with_x talent request
                        let requestData = {'talentId': otherFeudParticipant.$loki};
                        await checkTalentRequestAction({
                            company: company, requestType: 'feud_with_x', talent: feudParticipant,
                            data: requestData
                        });

                        // Update morale for feud started
                        let popularityDifference = (await getRosterMemberPopularity(feudParticipant)) -
                            (await getRosterMemberPopularity(otherFeudParticipant));
                        let moraleChange = await getSuperstarMoraleChange({
                            changeType: 'feud_started',
                            popularityDifference: popularityDifference,
                            feudParticipants: [feudParticipant, otherFeudParticipant]
                        });
                        for (let s of (await getRosterMemberSuperstars(feudParticipant))) {
                            updateSuperstarMorale(s, moraleChange);
                        }
                    }
                }
            }

            // Get feud superstars present in match
            const feudSuperstarsPresentInMatch = feudSuperstars.filter(x => objectInArray(x, segmentSuperstars));

            // Get trait boost for feud hype change
            let feudHypeTraitBoost = 0;
            for (const feudSuperstar of feudSuperstarsPresentInMatch) {
                for (const trait of feudSuperstar.traits) {
                    const traitData = traitsData[trait];
                    if (traitData && traitData['feud_hype_change_boost']) {
                        feudHypeTraitBoost += traitData['feud_hype_change_boost'];
                    }
                }
            }
            feudHypeTraitBoost = limitValueBetweenRange(feudHypeTraitBoost, -6, 6);

            // Check staleness
            let stale = false;
            let staleWarning = false;
            let stalenessHypeDecrease = 0;
            let staleFeudOvernessDecrease = 0;
            const staleLength = await getMatchesForStaleFeud(feud, feudParticipants);

            // Decrease hype if stale
            if (feud.stale) {
                stalenessHypeDecrease = Math.round(feud.stalenessCounter * -1);
            }

            // Check for feud staleness
            if (feud.stalenessCounter >= staleLength && !feud.stale) {
                staleWarning = true;
                if (feud.stalenessCounter > staleLength) {
                    stale = true;
                    feud.stale = true;
                    feud.hot = false;
                    stalenessHypeDecrease = Math.round((feud.stalenessCounter ** 1.5) * -1);

                    // Decrease overness for superstars
                    staleFeudOvernessDecrease = Math.floor(feud.stalenessCounter * 2);
                    staleFeudOvernessDecrease = limitValueBetweenRange(staleFeudOvernessDecrease, staleFeudOvernessDecrease, 16);
                    staleFeudOvernessDecrease *= -1;
                    for (let s of feudSuperstars) {
                        updateOverness(s, staleFeudOvernessDecrease);
                    }
                }
            }

            // Add hype change to feud
            let feudHypeChange = baseHypeChange + hotFeudHypeBoost + feudHypeTraitBoost + stalenessHypeDecrease;
            feudHypeChange = Math.round(feudHypeChange);
            if (feudHypeChange) {
                feud.hype += feudHypeChange;
            }

            // Add to staleness counter
            feud.stalenessCounter += 0.25;

            // Get feud data
            const feudData = {
                name: feud.name,
                participants: feudParticipants.map(x => x.name),
                hype: feud.hype,
                baseHype: feud.hype - feudHypeChange,
                hypeChange: feudHypeChange,
                ended: feud.ended,
                stale: stale,
                staleWarning: staleWarning,
                rating: feud.rating,
                hot: hotFeud,
                overnessDecrease: staleFeudOvernessDecrease * -1
            };
            feudsData.push(feudData);

            if (hotFeud) {
                // Increase overness for superstars
                const overnessIncrease = getRandomInt(3, 5);
                for (let s of feudSuperstars) {
                    updateOverness(s, overnessIncrease);
                }
                feudData['overnessIncrease'] = overnessIncrease;

                // Update morale for hot feud
                for (const x of segmentSuperstars) {
                    const moraleChange = await getSuperstarMoraleChange({changeType: 'hot_feud'});
                    updateSuperstarMorale(x, moraleChange);
                }

                hotFeuds.push(feudData);
            }
        }
        data['feuds'] = feudsData;
        data['hotFeuds'] = hotFeuds;

        // Update popularity
        data['popularityChange'] = popularityChange;
        if (popularityChange && segmentParticipants.length > 0) {

            // Update popularity for all superstars if hot segment
            if (hotSegment) {
                for (const s of segmentSuperstars) {
                    data['popularityChange'] = updateSuperstarPopularity(s, popularityChange, false, false, true);
                }
            }
            // Otherwise update popularity and overness for winner
            else {
                const overnessChange = getSegmentOvernessChange(winnerParticipant, popularityChange);
                for (const s of winnerParticipant.tempSuperstars) {
                    let superstarOvernessChange = overnessChange;

                    // Get trait multiplier for overness change
                    for (const trait of s.traits) {
                        const traitData = traitsData[trait];
                        if (traitData && traitData['overness_increase_multiplier']) {
                            if (superstarOvernessChange > 0) {
                                superstarOvernessChange *= traitData['overness_increase_multiplier'];
                            }
                        }
                        if (traitData && traitData['overness_decrease_multiplier']) {
                            if (superstarOvernessChange < 0) {
                                superstarOvernessChange *= traitData['overness_decrease_multiplier'];
                            }
                        }
                    }

                    data['popularityChange'] = updateSuperstarPopularity(s, popularityChange, false, false, true);
                    updateOverness(s, superstarOvernessChange);
                }
            }

            // Rank checks
            for (const p of segmentParticipants) {
                for (const s of p.tempSuperstars) {
                    let superstarNewRank = getRankFromPopularity(s.popularity);
                    if (superstarNewRank !== s.highestRank) {
                        // Set highest rank
                        let ranks = {'Main Eventer': 4, 'Upper Midcarder': 3, 'Lower Midcarder': 2, 'Jabroni': 1};
                        if (ranks[superstarNewRank] || 1 > ranks[s.highestRank] || 1) {
                            s.highestRank = superstarNewRank;

                            // Check goals
                            if (company.userControlled) {
                                if (superstarNewRank === 'Main Eventer') {
                                    let objectiveCompleted = await changeProperty({
                                        name: 'main eventer', change: 1, company: company, superstarName: s.name
                                    });
                                    if (objectiveCompleted) {
                                        await processObjectiveCompleted(objectiveCompleted, company);
                                    }
                                    // Find trio
                                    let winnerTrio = (await getSuperstarTagTeams(s)).find(y => y.trio);
                                    if (winnerTrio) {
                                        // Check if all members are main eventers
                                        let winnerTrioSuperstars = await getTagTeamSuperstars(winnerTrio);
                                        if (winnerTrioSuperstars.every(y => getRankFromPopularity(y.popularity) === 'Main Eventer')) {
                                            let superstarNames = commaSeparate(winnerTrioSuperstars.map(z => z.name)
                                                .sort((a, b) => a.localeCompare(b)));
                                            let objectiveCompleted = await changeProperty({
                                                name: 'new trio',
                                                change: 1,
                                                company: company,
                                                superstarName: superstarNames
                                            });
                                            if (objectiveCompleted) {
                                                await processObjectiveCompleted(objectiveCompleted, company);
                                            }
                                        }
                                    }
                                } else if (superstarNewRank === 'Upper Midcarder') {
                                    let winnerTagTeam = (await getSuperstarTagTeams(s)).find(y => !y.temporary && !y.trio);
                                    if (winnerTagTeam) {
                                        let winnerTagTeamSuperstars = await getTagTeamSuperstars(winnerTagTeam);
                                        if (winnerTagTeamSuperstars.every(y => ['Main Eventer', 'Upper Midcarder']
                                            .includes(getRankFromPopularity(y.popularity)))) {
                                            let superstarNames = commaSeparate(winnerTagTeamSuperstars.map(z => z.name)
                                                .sort((a, b) => a.localeCompare(b)));
                                            let objectiveCompleted = await changeProperty({
                                                name: 'new tag team',
                                                change: 1,
                                                company: company,
                                                superstarName: superstarNames
                                            });
                                            if (objectiveCompleted) {
                                                await processObjectiveCompleted(objectiveCompleted, company);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // Check talent request
                    let requestData = {'reachedRank': superstarNewRank};
                    await checkTalentRequestAction({
                        company: company, requestType: 'go_to_next_rank', talent: s,
                        data: requestData
                    });
                }
            }
        }

        // Process charisma xp if not production segment
        data['charismaIncreases'] = [];
        if (!segmentItem.productionSegment) {
            for (let p of segmentParticipants) {
                if (!managedParticipant || (p.$loki !== managedParticipant.$loki)) {
                    await processSegmentParticipantCharismaXp(p, xpGained)
                }
            }
        }

        // Production segment checks
        if (segmentItem.productionSegment) {

            // Add action completed (Packages Produced)
            await checkFacilityUpgrade('Production', company);

            // Unlock special segment
            if (segmentItem.custom) {
                const segmentTexts = segmentItem.startTexts.concat(segmentItem.actionTexts, [segmentItem.name]);
                for (const text of segmentTexts) {
                    if (text.toLowerCase().includes('celebrity')) {
                        await unlockSpecialSegment(company, 'Celebrity Beatdown', month, year);
                    }
                }
            }
        }

        // Add xp to random producer (for production segment) or assigned producer
        if ((segmentItem.productionSegment && producer) || assignedProducer) {
            const ageMultiplier = getStaffAgeMultiplier(producer);
            const isAssignedProducer = assignedProducer != null;
            let producerXPGained = getSegmentProducerXp(rating, segment.order, segmentItem.difficulty, isAssignedProducer);
            producerXPGained = Math.round(producerXPGained * ageMultiplier);
            const producerLevelIncrease = await updateStaffMemberXp(producer, producerXPGained, company, game);
            if (producerLevelIncrease) {
                data['staffSkillIncreases'].push({
                    'name': producer.name, 'level': producer.level, 'role': producer.role
                });
            }
            data['producerName'] = producer.name;
            data['producerXpGained'] = producerXPGained;
        }

        // Debut/update gimmicks if not production segment or if New Gimmick Package
        data['gimmickEffectivenessLevelChanges'] = [];
        if (!segmentItem.productionSegment || segmentItem.requirement === 'new-gimmick-and-level-1-producer') {
            for (const s of segmentSuperstars) {
                // Debut new gimmick if set
                if (s.debutNewGimmick) {
                    let debutedGimmickData = await debutGimmick(s, company, producer, month, year);
                    data['debutedGimmicks'].push(debutedGimmickData);
                    // Add producer skill increase data
                    if (debutedGimmickData['staffSkillIncreases']) {
                        data['staffSkillIncreases'].push(debutedGimmickData['staffSkillIncreases'])
                    }
                }
                // Update existing gimmick if found
                else {
                    let segmentSuperstarParticipant;
                    for (const y of segmentParticipants) {
                        if (objectInArray(s, y.tempSuperstars)) {
                            segmentSuperstarParticipant = y;
                            break;
                        }
                    }
                    await updateSuperstarGimmickEffectiveness(s, segmentSuperstarParticipant);
                }
            }
        }

        // Mark ready to return as False
        for (let s of segmentSuperstarsWithManagers) {
            if (s.readyToReturn) {
                s.readyToReturn = false;
            }
        }

        // Increase overness for hot segment
        if (hotSegment) {
            // Get overness increase
            let overnessIncrease;
            if (segmentParticipants.length > 1) {
                overnessIncrease = Math.round(8 / segmentParticipants.length);
            } else {
                overnessIncrease = 4;
            }
            if (overnessIncrease < 1) {
                overnessIncrease = 1;
            }
            // Special segments gets superstar overness to 90+
            if (segmentItem.special) {
                if (segmentParticipants.some(x => x.overness < 80)) {
                    overnessIncrease = 90 - segmentParticipants[0].overness;
                } else {
                    overnessIncrease = 20;
                }
            }
            data['hotSegmentOvernessIncrease'] = overnessIncrease;

            for (let x of segmentSuperstars) {
                updateOverness(x, overnessIncrease);
            }

            // Unlock special segment
            if (segmentItem.silly) {
                await unlockSpecialSegment(company, 'Hosedown', month, year);
            }

            // Update morale for hot segment
            for (let x of segmentSuperstars) {
                let moraleChange = await getSuperstarMoraleChange({changeType: 'hot_segment'});
                updateSuperstarMorale(x, moraleChange);
            }
        }

        // Update morale for silly failure
        if (sillyFailure) {
            for (let x of segmentSuperstars) {
                let moraleChange = await getSuperstarMoraleChange({changeType: 'silly_failure'});
                updateSuperstarMorale(x, moraleChange);
            }
        }

        // Update morale for main event
        if (mainEvent) {
            for (let x of segmentSuperstars) {
                let moraleChange = await getSuperstarMoraleChange({changeType: 'main_event', weeklyShow: weeklyShow});
                updateSuperstarMorale(x, moraleChange);

                // Check main event request
                await checkTalentRequestAction({company: company, requestType: 'be_in_main_event', talent: x});
            }
        }

        // Check no weekly shows request
        if (weeklyShow) {
            for (let x of segmentSuperstars) {
                await checkTalentRequestAction({
                    company: company,
                    requestType: 'no_weekly_shows',
                    talent: x,
                    failRequest: true
                });
            }
        }

        // Check promo segment request
        if (['Slander Competitor', 'Lost My Smile', 'Heat Promo', 'Spirited Promo', 'Retirement Announcement', 'I Quit',
                'Best Wrestler Promo', 'New Heel Promo', 'New Babyface Promo', 'Retirement Gloat', 'I\'m The Face',
                'Losing Streak Promo', 'Build Honor', 'Villainize', 'Neutralize', 'Injury Gloat', 'Anti-Company Rant',
                'Ring Invasion', 'This Is My Life', 'Cryptic Threat', 'Backstage Interview', 'Indifferent Promo',
                'Debut Promo', 'Solo Feud Promo', 'Manager Promo'].includes(segmentItem.name) ||
            (segmentItem.custom && segmentItem.name.toLowerCase().includes('promo') && segmentItem.maxParticipants === 1)) {
            if (segmentParticipants.length > 0) {
                await checkTalentRequestAction({
                    company: company, requestType: 'solo_promo_segment',
                    talent: segmentParticipants[0]
                });
            }
        }

        // Check morale changes
        data['moraleChanges'] = [];
        for (let p of segmentParticipants) {
            // Add morale change to participant's data
            const participantData = data['participantsData'].find(x => x['uid'] === p.$loki);
            participantData['moraleChange'] = Math.round(p.tempSuperstars.reduce((n, x) => n + (x.morale - x.startingMorale), 0) /
                p.tempSuperstars.length * 10) / 10;

            // Check for morale level change for superstars
            for (const s of p.tempSuperstars) {
                let startingMoraleText = getMoraleText(s.startingMorale);
                let endingMoraleText = getMoraleText(s.morale);
                if (endingMoraleText !== startingMoraleText) {
                    data['moraleChanges'].push({
                        name: s.name, previousMorale: startingMoraleText,
                        currentMorale: endingMoraleText, morale: s.morale
                    });
                }

                // Delete starting morale attribute
                delete s.startingMorale;
            }
        }

        // Check hot and stale changes
        data['hotChanges'] = [];
        data['staleChanges'] = [];
        data['unlockedCharacters'] = [];
        data['overnessChanges'] = [];
        for (let p of segmentParticipants) {
            // Add overness change to participant's data
            const participantData = data['participantsData'].find(x => x['uid'] === p.$loki);
            participantData['overnessChange'] = Math.round(p.tempSuperstars.reduce((n, x) => n + (x.overness - x.startingOverness), 0) /
                p.tempSuperstars.length * 10) / 10;

            // Check for overness level change for superstars
            for (const s of p.tempSuperstars) {
                const startingOvernessText = getOvernessText(s.startingOverness);
                const endingOvernessText = getOvernessText(s.overness);
                if (endingOvernessText !== startingOvernessText) {
                    data['overnessChanges'].push({
                        name: s.name,
                        previousOverness: startingOvernessText,
                        currentOverness: endingOvernessText,
                        overness: s.overness,
                        increase: s.overness > s.startingOverness
                    });
                }
                const superstarOvernessChange = s.overness - s.startingOverness;

                // Check hot
                const hotCheck = checkObjectHot(s, superstarOvernessChange);
                if (hotCheck) {
                    data['hotChanges'].push({name: s.name, pronoun: s.possessivePronoun, status: hotCheck});

                    // Check for character unlock upon hot
                    if (globalUser.paid && hotCheck === 'hot') {
                        const superstarGimmick = await getSuperstarCurrentGimmick(s);
                        if (superstarGimmick) {
                            if (superstarGimmick.character) {
                                const unlockedCharacter = checkCharacterToUnlock(superstarGimmick.character);
                                if (unlockedCharacter) {
                                    data['unlockedCharacters'].push({
                                        name: unlockedCharacter,
                                        originalCharacter: superstarGimmick.character
                                    });
                                }
                            }
                        }
                    }

                    if (hotCheck === 'hot') {
                        // Add news
                        if (company) {
                            let newsItem = await generateNewsItem({
                                company: company, month: game.newsMonth, year: game.newsYear, superstar: s, newsType: 'over_superstar',
                            });
                            await addCompanyNewsItems(mainCompany, [newsItem]);
                        }

                        if (company.userControlled) {
                            // Check goal
                            let objectiveCompleted = await changeProperty({
                                name: 'get over', change: 1, company: company,
                                superstarName: s.name
                            });
                            if (objectiveCompleted) {
                                await processObjectiveCompleted(objectiveCompleted, company);
                            }

                            // Add TGI president's message
                            if (getRandomInt(0, 100) <= 25) {
                                let annualTournamentHeld = (await getCompanyTournaments(mainCompany))
                                    .find(y => y.annualTournament && y.status === 'ended');
                                if (annualTournamentHeld) {
                                    const newMessage = await createPresidentOverSuperstarMessage(s, game, month, year);
                                    await addCompanyMessages(company, [newMessage]);
                                }
                            }
                        }

                        // Update faction rep (overness change)
                        const superstarFactionsData = await processFactionXpChangeForSuperstar({
                            superstar: s,
                            overnessChange: 'hot'
                        });
                        data['factionReputationsData'].push(...superstarFactionsData);
                    }
                }

                // Check stale
                const staleCheck = checkObjectStale(s, superstarOvernessChange);
                if (staleCheck) {
                    data['staleChanges'].push({name: s.name, pronoun: s.possessivePronoun, status: staleCheck});

                    if (staleCheck === 'stale') {
                        let newsItem = await generateNewsItem({
                            company: company, month: game.newsMonth, year: game.newsYear, superstar: s, newsType: 'stale_superstar'
                        });
                        await addCompanyNewsItems(mainCompany, [newsItem]);

                        // Update faction rep (overness change)
                        const superstarFactionsData = await processFactionXpChangeForSuperstar({
                            superstar: s,
                            overnessChange: 'stale'
                        });
                        data['factionReputationsData'].push(...superstarFactionsData);
                    }
                }

                // Delete starting overness attribute
                delete s.startingOverness;
            }
        }

        // Change prestige for segment championship
        if (globalUser.paid) {
            for (let championship of segmentChampionships) {
                // Get prestige data
                let championshipXpData = await getChampionshipXpChange({
                    championship, company, month, year,
                    segment, weeklyShow, mainEvent
                });

                // Process prestige
                if (championshipXpData['totalXpChange']) {
                    let championshipPrestigeData = await processChampionshipXpChange(championship, championshipXpData['totalXpChange'],
                        companyChampionships);
                    if (championshipPrestigeData['xp']) {
                        championshipPrestigeData['xpDetails'] = championshipXpData;

                        // Add to data (if not already added)
                        if (!((data['championshipPrestiges'].map(y => y['championshipName']))
                            .includes(championshipPrestigeData['championshipName']))) {
                            data['championshipPrestiges'].push(championshipPrestigeData)
                        }

                        // Check for objective completed
                        if (championshipPrestigeData['prestigeIncrease']) {
                            if (company.userControlled) {
                                let objectiveCompleted = await changeProperty({
                                    name: 'championship prestige', change: 1,
                                    company: company, championship: championship
                                });
                                if (objectiveCompleted) {
                                    await processObjectiveCompleted(objectiveCompleted, company);
                                }
                            }
                            // If prestige increased over highest value, unlock prestige bonus segments
                            if (championshipPrestigeData['firstPrestigeIncrease']) {
                                data['unlockedChampionshipSegmentItems']
                                    .push(...(await checkChampionshipSegmentItemsToUnlock(championshipPrestigeData['prestige'],
                                        company)));
                            }
                        }
                    }
                }
            }
        }

        // Check to acquire traits
        if (hotSegment) {
            for (let segmentSuperstar of segmentSuperstars) {
                // Don't acquire for managed talent
                if (!objectInArray(segmentSuperstar, managedSuperstars)) {
                    await checkAcquireTrait(segmentSuperstar, 'Entertainer');
                }
            }
        }

        // Get event hype boosts
        if (company.userControlled && game.marketSize !== null) {
            const eventHypeBoostData = await getEventHypeBoostData(segment, segmentItem, talentDebutRelationship, hotSegment,
                company, game, segmentParticipants);
            if (eventHypeBoostData['hypeBoost']) {
                event.hype += eventHypeBoostData['hypeBoost'];
                data['eventHype'] = event.hype;
                data['eventHypeBoostData'] = eventHypeBoostData;
            }
        }

        // Add kayfabe points change
        for (let s of segmentSuperstars) {
            let kayfabePointsChange = 0;
            if (mainEvent) {
                kayfabePointsChange += await getKayfabePointsChange({changeType: `mainEvent`, weeklyShow: weeklyShow});
            }
            if (kayfabePointsChange) {
                updateSuperstarKayfabePoints(s, kayfabePointsChange);
            }
        }

        // Mark hidden as false
        if (segment.hidden) {
            segment.hidden = false;
        }

        // Get data to return
        data['rating'] = rating;
        data['effectiveness'] = effectiveness;
        data['segmentAlreadyHeld'] = segmentAlreadyHeld;
        data['purePositiveBoost'] = purePositiveBoost;
        data['pureNegativeBoost'] = pureNegativeBoost;
        data['sillySuccess'] = sillySuccess;
        data['sillyFailure'] = sillyFailure;
        data['segmentItemLevelData'] = segmentItemLevelData;
        data['unlockedSegmentItems'] = unlockedSegmentItems;
        data['winnerName'] = winnerParticipant ? winnerParticipant.name : null;
        data['hotSegment'] = hotSegment;
        data['specialSegment'] = segmentItem.special;
        if (updateGraphics) {
            data['graphics'] = graphics;
        }

        // Delete tempSuperstars attribute
        for (const x of segmentParticipants) {
            delete x.tempSuperstars;
        }

        async function processSegmentParticipantCharismaXp(p, xpToAdd) {
            const pSuperstars = p.tempSuperstars;
            let participantXpGained = 0;

            for (const s of pSuperstars) {
                // Check for skill xp multiplier trait
                let traitMultiplier = 1;
                for (const trait of s.traits) {
                    const traitData = traitsData[trait];
                    if (traitData && traitData['skill_xp_multiplier']) {
                        traitMultiplier = traitData['skill_xp_multiplier'];
                    }
                }

                // Get and add charisma xp
                const ageMultiplier = getTalentAgeMultiplier(s);
                const superstarXpGained = Math.round(xpToAdd * ageMultiplier * traitMultiplier);
                s.charismaXp += superstarXpGained;
                participantXpGained += superstarXpGained;

                // Add charisma xp, check level increase
                const increaseData = await updateSuperstarCharisma(s, company, staffMembers, month, year);
                if (increaseData) {
                    data['charismaIncreases'].push({'name': s.name, 'level': s.charisma});
                }
            }
            participantXpGained = Math.floor(participantXpGained / pSuperstars.length);

            // Add xp gained to participant's data
            const participantData = data['participantsData'].find(x => x['uid'] === p.$loki);
            if (participantData) {
                participantData['xpGained'] = participantXpGained;
            }
        }

        async function updateSuperstarGimmickEffectiveness(s, p) {
            // Find gimmick
            const superstarGimmick = await getSuperstarCurrentGimmick(s);
            if (superstarGimmick) {
                const isWinner = winnerParticipant && p.$loki === winnerParticipant.$loki && segmentItem.chooseWinner;

                // Get change
                const gimmickEffectivenessChange = getGimmickEffectivenessChange(s, rating, segment.order, weeklyShow,
                    isWinner, segmentItem.difficulty, false, s.hot);
                if (gimmickEffectivenessChange !== 0) {
                    const gimmickData = progressGimmick(superstarGimmick, gimmickEffectivenessChange, s);

                    // Add gimmick effectiveness level change if present
                    if (gimmickData['overnessEffectChange']) {
                        data['gimmickEffectivenessLevelChanges'].push(gimmickData);
                    }

                    // Add gimmick effectiveness change to participant's data
                    const participantData = data['participantsData'].find(x => x['uid'] === p.$loki);
                    participantData['gimmickEffectivenessChange'] += gimmickEffectivenessChange;

                    // Unlock special segment
                    if (superstarGimmick.character && superstarGimmick.character === 'Degenerate' &&
                        superstarGimmick.effectiveness >= 100) {
                        await unlockSpecialSegment(company, 'Love Making', month, year);
                    }
                }
            }

            return superstarGimmick;
        }

        function updateOverness(p, increase) {
            p.overness += increase;
            p.overness = limitValueBetweenRange(p.overness, 0, 100);
            return p.overness;
        }

        return data;
    }
    catch (err) {
        // Delete tempSuperstars attribute
        for (const x of (await getSegmentParticipants(segment))) {
            delete x.tempSuperstars;
        }
        throw err;
    }
}

async function getSegmentParticipantsChampionship(participants) {
    for (const p of participants) {
        for (const s of p.tempSuperstars) {
            for (const c of (await getSuperstarChampionships(s))) {
                if (!c.championshipContract && !c.matchContract) {
                    return c;
                }
            }
        }
    }
    return null;
}

async function checkSegmentAlreadyHeld(segment, segmentItem, event, eventSegments, segmentFeuds) {  // check_segment_already_held
    // Check event segments and feuds' segments
    const feudsSegments = (await Promise.all(segmentFeuds.map(x => getFeudSegments(x)))).flat();
    const segmentsToCheck = eventSegments.concat(feudsSegments);

    let segmentAlreadyHeld = false;
    for (const x of segmentsToCheck) {
        let si = await getSegmentSegmentItem(x);
        // Not repeatable and same segment item, not played and not this segment
        if (si.$loki === segmentItem.$loki && si.oneAtATime && x.$loki !== segment.$loki && x.rating) {
            segmentAlreadyHeld = true;
            break;
        }
    }

    // Check if event package already held
    if (segmentItem.consequence === 'boost-event-hype' && event.nextEventBoost) {
        segmentAlreadyHeld = true;
    }

    return segmentAlreadyHeld;
}

async function getTalentDebutRelationship(segmentItem, participants, company) {  // get_talent_debut_relationship
    if (['Debut', 'Debut Promo', 'Debut Attack'].includes(segmentItem.name)) {
        for (const p of participants) {
            for (const s of p.tempSuperstars) {
                const relationship = (await getSuperstarRelationships(s)).find(x => x.type === 'former_company' &&
                    x.companyId !== company.$loki);
                if (relationship && s.popularity >= 600) {
                    return relationship;
                }
            }
        }
    }
    return null;
}

async function getEventHypeBoostData(segment, segmentItem, talentDebutRelationship, hotSegment, company, game,
                                     participants) {  // get_event_hype_boost_data
    const data = {};

    if (talentDebutRelationship) {
        if ((await getRosterMemberRank(participants[0])) === 'Main Eventer') {
            data['hypeBoost'] = 25;
        } else {
            data['hypeBoost'] = 10;
        }
        data['debutBoost'] = true;
        data['companyName'] = company.name;
        const formerCompany = getRelationshipCompany(talentDebutRelationship);
        data['formerCompanyName'] = formerCompany.name;
    } else if (segmentItem.name === 'Slander Competitor' && (segment.rating >= 4 || segment.rating <= 3)) {
        // Get competitor
        let competitor;
        if (segment.consequenceData) {
            const competitorUid = segment.consequenceData['competitorUid'];
            if (competitorUid) {
                competitor = await Companies.get(competitorUid)
            }
        }
        if (!competitor) {
            // Compatibility with old saves
            const competitors = await getActiveCompetitorsForCompany(company, game);
            competitor = getArrayMaxByProperty(competitors, 'fans');
        }
        if (competitor) {
            data['competitorName'] = competitor.name;
        }

        if (segment.rating >= 4) {
            data['hypeBoost'] = 5;
            data['slanderBoost'] = true;
        } else if (segment.rating <= 3) {
            data['hypeBoost'] = -5;
            data['slanderPenalty'] = true;
        }
    } else if (hotSegment) {
        data['hypeBoost'] = 10;
        data['hotSegmentBoost'] = true;
    }

    return data;
}

function getProductionSegmentRating(producer, segmentAlreadyHeld, assignedProducer = null) {  // get_production_segment_rating
    const data = {};
    const producerLevel = producer ? producer.level : 1;
    const maxRating = 5;

    const effectiveness = Math.round(getProductionSegmentEffectiveness(producerLevel) * 100) / 100;
    let rating = effectiveness * maxRating;

    if (segmentAlreadyHeld) {
        rating *= 0.6;
    }

    // Add producer focus effect
    if (assignedProducer) {
        data['producerFocusEffect'] = getProducerFocusEffect(assignedProducer);
    }

    rating = myround(rating, 0.25);

    data['rating'] = rating;
    data['effectiveness'] = effectiveness;

    return data;
}

function getProductionSegmentEffectiveness(producerLevel) {  // get_production_segment_effectiveness
    let minValue, maxValue;

    if (producerLevel === 1) {
        minValue = 0.45;
        maxValue = 0.85;
    } else if (producerLevel === 2) {
        minValue = 0.6;
        maxValue = 0.9;
    } else {
        minValue = 0.8;
        maxValue = 1.05;
    }

    let effectiveness = getRandomUniform(minValue, maxValue);
    effectiveness = limitValueBetweenRange(effectiveness, 0.0, 1.0);

    const randomBoosts = [
        [-0.1, 10],
        [0, 80],
        [0.1, 10]
    ];
    effectiveness += weightedChoice(randomBoosts);
    effectiveness = limitValueBetweenRange(effectiveness, 0.0, 1.0);

    return decimalRound(effectiveness, 0.05);
}

async function getSegmentRating(segmentItem, participantsWithManagers, purePositiveBoost, pureNegativeBoost,
                          segmentSuperstarsWithManagers, segmentAlreadyHeld, talentDebutRelationship,
                          assignedProducer, storyName) {  // get_segment_rating
    const data = {};
    if (storyName === 'passion' && segmentItem.name === 'Welcome to POW') {
        data['rating'] = myround(getRandomUniform(4, 5.25), 0.25);
        data['effectiveness'] = 1.0;
        return data;
    }

    const averageCharisma = myround(await getSegmentParticipantsAverageCharisma(participantsWithManagers), 0.25);
    const maxRatings = {1: 3.75, 2: 4.25, 3: 5};
    const maxAttribute = Math.max(segmentItem.entertainment, segmentItem.action);
    const minAttribute = Math.min(segmentItem.entertainment, segmentItem.action);
    let maxRating = maxRatings[maxAttribute] || 3.5;
    if (minAttribute > 0) {
        const extraRating = minAttribute * 0.5;
        maxRating += extraRating;
        if (maxRating > 5) {
            maxRating = 5;
        }
    }

    // Get trait multiplier for silly segment rating
    let traitsBoost = 0;
    if (segmentItem.silly) {
        for (const superstar of segmentSuperstarsWithManagers) {
            for (const trait of superstar.traits) {
                const traitData = traitsData[trait];
                if (traitData && traitData['silly_segment_rating_boost']) {
                    traitsBoost += traitData['silly_segment_rating_boost'];
                }
            }
        }
        traitsBoost = limitValueBetweenRange(traitsBoost, -0.2, 0.2);
    }

    let effectiveness = getSegmentEffectiveness(segmentItem.difficulty, averageCharisma, segmentItem.silly, traitsBoost);
    let rating = effectiveness * maxRating;
    if (segmentAlreadyHeld) {
        rating *= 0.6;
    }
    if (purePositiveBoost) {
        rating *= 1.1;
    } else if (pureNegativeBoost) {
        rating *= 0.8;
    }

    // Stale penalty
    const stalePenalty = segmentSuperstarsWithManagers.filter(x => x.stale).length * (-1 / segmentSuperstarsWithManagers.length);
    rating += stalePenalty;

    // Faction reputation effect for faction segments
    if (segmentItem.factionSegment) {
        let participantSuperstar = (await getTagTeamSuperstars(participantsWithManagers[0]))[0];
        const faction = (await getSuperstarFactions(participantSuperstar)).find(y => !y.disbanded);
        if (faction) {
            // Negative effect for reputation under 5, positive effect for reputation over 5
            const reputationEffect = (faction.reputation - 5) / 2;
            rating += reputationEffect;
            rating = limitValueBetweenRange(rating, 0, 5);
        }
    }

    // Add producer focus effect
    if (assignedProducer) {
        data['producerFocusEffect'] = getProducerFocusEffect(assignedProducer);
    }

    rating = myround(rating, 0.25);

    if (rating < 0) {
        rating = 0;
    }

    if (segmentItem.special || talentDebutRelationship) {
        rating = 5;
        effectiveness = 1.0;
    }

    data['rating'] = rating;
    data['effectiveness'] = effectiveness;

    return data;
}

function getSegmentEffectiveness(difficulty, charisma, silly, traitsBoost) {  // get_segment_effectiveness
    let maxValue;

    if (charisma > 2) {
        maxValue = 1.1;
    } else if (charisma > 1) {
        maxValue = 0.8;
    } else {
        maxValue = 0.7;
    }

    // Set minimum value based on charisma (20% for 2 charisma, 40% for 3 charisma)
    const minValue = maxValue - 0.5;
    const randomMultiplier = getRandomUniform(minValue, maxValue);
    const difficultyFactor = 1.1 / (difficulty + 1);
    let effectiveness = Math.pow(charisma, 1.15) * difficultyFactor * randomMultiplier;
    effectiveness = limitValueBetweenRange(effectiveness, 0.0, 1.0);

    // Add random boost
    const randomBoosts = [
        [-0.1, 10],
        [0, 80],
        [0.1, 10]
    ];
    effectiveness += weightedChoice(randomBoosts);

    // Add traits boost
    effectiveness += traitsBoost;

    effectiveness = limitValueBetweenRange(effectiveness, 0.0, 1.0);

    return myround(effectiveness, 0.05);
}

function checkSegmentHot(segment, participants, superstars, feuds, shockingTurn = false, turnTooSoon = false, special = false) {  // check_segment_hot
    let chance = 0;

    // Special segment is always hot
    if (special) {
        return true;
    }

    // Minimum rating
    if (segment.rating < 4) {
        return false;
    }

    // No participants
    if (!participants.length) {
        return false;
    }

    // Segment rating factor
    if (segment.rating >= 4.75) {
        chance += 10;
    }

    // Feud hype factor
    const feudsHype = getHypeForFeuds(feuds, participants);
    chance += feudsHype / 2;

    // Hot/stale superstars factor
    let hotParticipantBonus = 0;
    for (const x of superstars) {
        if (x.hot) {
            hotParticipantBonus += 8 / superstars.length;
        } else if (x.stale) {
            hotParticipantBonus -= 8 / superstars.length;
        }
    }
    chance += hotParticipantBonus;

    // Shocking turns chance
    if (shockingTurn) {
        chance += 30;
    }
    if (turnTooSoon) {
        chance -= 30;
    }

    // Get trait multiplier for hot segment chance
    let traitBoost = 0;
    for (const superstar of superstars) {
        for (const trait of superstar.traits) {
            const traitData = traitsData[trait];
            if (traitData && traitData['hot_segment_chance_boost']) {
                traitBoost += traitData['hot_segment_chance_boost'];
            }
        }
    }
    traitBoost = limitValueBetweenRange(traitBoost, 0, 15);
    chance += traitBoost;

    // Max chance
    if (chance >= 50) {
        chance = 50;
    }

    if (getRandomInt(1, 100) <= chance) {
        segment.hot = true;
        return true;
    }

    return false;
}

function getSegmentXps(rating, order, difficulty, trainerLevel) {  // get_segment_xps
    const baseXps = {1: 2, 2: 3.5, 3: 5};
    let baseXp = baseXps[trainerLevel] || 5;

    if (order === 0) {
        baseXp += 2;
    }

    if (rating >= 4.5) {
        baseXp += 2;
    } else if (rating <= 2) {
        baseXp -= 2;
    }

    const difficultyXps = {1: 0, 2: 1, 3: 3};
    baseXp += difficultyXps[difficulty] || 0;

    return Math.floor(baseXp);
}

function getSegmentProducerXp(rating, order, difficulty, isAssignedProducer) {  // get_segment_producer_xp
    let baseXp = 2;
    if (isAssignedProducer) {
        baseXp += 3;
    }

    if (order === 0) {
        baseXp += 2;
    }

    if (rating >= 4) {
        baseXp += 1;
    } else if (rating <= 2) {
        baseXp -= 1;
    }

    const difficultyXps = {1: 0, 2: 2, 3: 4};
    baseXp += difficultyXps[difficulty] || 0;

    return Math.floor(baseXp);
}

function getSegmentBoosts(rating, segmentItem, hot = false) { // get_segment_boosts
    const baseHypes = {1: 3, 2: 8, 3: 15};
    const basePopularities = {1: 5, 2: 9, 3: 15};
    let ratingMultiplier = (rating - 3) * 0.5;
    let sillySuccess = false;
    let sillyFailure = false;

    // Add initial hype/popularity change
    let hypeChange = baseHypes[segmentItem.hypeBoost] || 0;
    let popularityChange = basePopularities[segmentItem.popularityBoost] || 0;

    if (rating >= 4.5) {
        ratingMultiplier += 0.25;
        if (segmentItem.silly) {
            sillySuccess = true;
            ratingMultiplier += 0.75;
        }
    } else if (rating <= 2) {
        ratingMultiplier -= 1.5;
        if (segmentItem.silly) {
            sillyFailure = true;
            ratingMultiplier -= 0.5;
        }
    }

    // Hot segment multiplier boost
    if (hot) {
        ratingMultiplier += 0.25;
    }

    // Add rating multiplier's hype/pop change
    hypeChange += Math.round(hypeChange * ratingMultiplier);
    popularityChange += Math.round(popularityChange * ratingMultiplier);

    // Hot segment boost
    if (hot) {
        hypeChange += getRandomInt(3, 5);
        popularityChange += getRandomInt(5, 8);
    }

    return [hypeChange, popularityChange, sillySuccess, sillyFailure];
}

async function getSegmentParticipantsAverageCharisma(participants) {  // get_average_charisma
    let totalCharisma = 0;
    for (const x of participants) {
        if (x.objectName === 'superstar') {
            totalCharisma += getSuperstarCharisma(x)
        }
        else {
            totalCharisma += await getTagTeamCharisma(x)
        }
    }
    return totalCharisma / participants.length;
}

async function getTagTeamCharisma(tagTeam) {  // get_team_charisma
    const superstars = await getRosterMemberSuperstars(tagTeam);

    // Get leader's charisma if faction tag team
    if (tagTeam.factionTagTeam) {
        let faction = (await getSuperstarFactions(superstars[0])).find(x => !x.disbanded);
        if (faction) {
            let factionLeaderSuperstar = await getFactionLeaderSuperstar(faction);
            let leaderSuperstar = superstars.find(x => factionLeaderSuperstar && x.$loki === factionLeaderSuperstar.$loki);
            if (leaderSuperstar) {
                return getSuperstarCharisma(leaderSuperstar);
            }
        }
    }

    // Get average charisma of team superstars
    let totalCharisma = 0;
    for (const s of superstars) {
        totalCharisma += getSuperstarCharisma(s)
    }
    return totalCharisma / superstars.length;
}

function getProducerFocusEffect(producer) {  // get_producer_focus_effect
    let producerFocusEffects;
    if (producer.level <= 1) {
        producerFocusEffects = [
            [-0.25, 15],
            [0, 40],
            [0.25, 45]
        ];
    } else if (producer.level === 2) {
        producerFocusEffects = [
            [-0.25, 10],
            [0, 30],
            [0.25, 40],
            [0.5, 20]
        ];
    } else if (producer.level >= 3) {
        producerFocusEffects = [
            [0, 20],
            [0.25, 50],
            [0.5, 30]
        ];
    }
    return weightedChoice(producerFocusEffects);
}

function checkSegmentItemsToUnlock(segmentItem, segmentItems) {  // check_segment_items_to_unlock
    // Check for segment item unlocks, returning unlocked
    const unlocked = [];
    const unlocksDict = {
        'Debut': 'Legend\'s Praise',
        'Title Disrespect': 'Title Destruction',
        'Anger Management': 'Exposing the Past',
        'Demand Title Shot': 'Lost My Smile',
        'Talk Show': 'You\'re Fired',
        'Heat Promo': 'Backstab',
        'Spirited Promo': 'Defying a Villain',
        'Fight': 'Delayed Vengeance',
        'Siblings Parody': 'Entrance Parody',
        'Backstage Attack': 'Police Arrest',
        'Legendary Beatdown': 'One Last Run',
        'Backstage Interview': 'This Is My Life',
        'Home Invasion': 'Spouse Attack',
        'Promo Battle': 'Catchphrase Showdown',
        'Masked Attacker': 'Face Reveal',
    };
    const toUnlock = unlocksDict[segmentItem.name];
    if (toUnlock) {
        const segmentItemToUnlock = segmentItems.find(x => x.name === toUnlock);
        if (segmentItemToUnlock && !segmentItemToUnlock.unlocked && segmentItem.level === 3) {
            segmentItemToUnlock.unlocked = true;
            unlocked.push(segmentItemToUnlock.name);
        }
    }
    return unlocked;
}

async function updateSuperstarCharisma(superstar, company, staffMembers, month, year) { // update_superstar_charisma
    const xps = {2: 300, 1: 100};
    let levelIncrease = false;

    if (superstar.charisma < 3 && superstar.charismaXp >= (xps[superstar.charisma] || 300)) {
        superstar.charisma += 1;
        levelIncrease = true;

        // Add level up message
        if (company.userControlled) {
            const trainer = getRandomStaffMemberByRole(staffMembers, 'trainer');
            const newMessage = await createSuperstarLevelUpMessage(trainer, superstar, 'charisma', month, year);
            await addCompanyMessages(company, [newMessage]);
        }
    }

    return levelIncrease;
}

function getSegmentOvernessChange(winner, popularityChange) {  // get_segment_overness_change
    let hot = winner.tempSuperstars.every(x => x.hot);
    let stale = winner.tempSuperstars.every(x => x.stale);

    let overnessIncrease;
    if (popularityChange > 0) {
        if (hot) {
            overnessIncrease = Math.floor(popularityChange / 8);
        } else if (stale) {
            overnessIncrease = Math.floor(popularityChange / 2);
        } else {
            overnessIncrease = Math.floor(popularityChange / 4);
        }
    } else {
        // Popularity change will be mostly positive for hot superstar, since it depends on charisma
        // so use lower divisor here
        if (hot) {
            overnessIncrease = Math.floor(popularityChange / 1);
        } else if (stale) {
            overnessIncrease = Math.floor(popularityChange / 1);
        } else {
            overnessIncrease = Math.floor(popularityChange / 2);
        }
    }

    if (overnessIncrease > 10) {
        overnessIncrease = 10;
    }
    return overnessIncrease;
}

function addPerkToSegmentItem(segmentItem, perk = null) {  // add_perk_to_segment_item
    // Get available perks
    let perks = [];
    if (segmentItem.entertainment < 3) {
        perks.push('entertainment');
    }
    if (segmentItem.action < 3) {
        perks.push('action');
    }
    if (segmentItem.popularityBoost < 3) {
        perks.push('popularity');
    }
    if (segmentItem.hypeBoost < 3) {
        perks.push('hype');
    }
    if (segmentItem.difficulty > 1) {
        perks.push('difficulty');
    }

    if (perk == null && perks.length > 0) {
        perk = getRandomChoice(perks)
    }

    // Add perk effect
    if (perk === 'entertainment') {
        segmentItem.entertainment += 1;
    }
    if (perk === 'action') {
        segmentItem.action += 1;
    }
    if (perk === 'difficulty') {
        segmentItem.difficulty -= 1;
    }
    if (perk === 'hype') {
        segmentItem.hypeBoost += 1;
    }
    if (perk === 'popularity') {
        segmentItem.popularityBoost += 1;
    }

    return perk;
}

async function runSpecialSegmentConsequence(segmentItem, segment, participants, company, mainCompany, staffMembers,
                                            game, month, year) {  // run_special_segment_consequence
    const data = {};
    const superstar = participants[0];
    const superstarRandom = new Math.seedrandom(superstar.meta.created);
    let newsItem;

    if (segmentItem.name === 'Car Explosion') {
        addKayfabeInjuryToSuperstar(superstar, getRandomInt(2, 4));
        data['unavailableSuperstar'] = superstar.name;

        // Check talent request
        await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});

        // Add news
        if (company.userControlled) {
            newsItem = await generateNewsItem({
                company: company, month, year, superstar: superstar, newsType: 'car_explosion', headline: true
            });
        }
    }

    if (segmentItem.name === 'Stunt Dive') {
        addKayfabeInjuryToSuperstar(superstar, 2);
        data['unavailableSuperstar'] = superstar.name;

        // Check talent request
        await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});

        // Add news
        if (company.userControlled) {
            newsItem = await generateNewsItem({
                company: company, month, year, superstar: superstar, newsType: 'stunt_dive', headline: true
            });
        }
    }

    if (segmentItem.name === 'Dummy Wrestling') {
        const mainRoster = await getCompanyRosterByType(company, 'main');
        const superstars = (await getRosterSuperstars(mainRoster)).filter(x => !objectInArray(x, participants));
        const availableSuperstars = superstars.filter(x => checkAvailability(x, true) && !x.unhappy);

        // Set unhappy superstars
        let unhappySuperstars = [];
        if (!game.settings['no_unhappiness']) {
            if (availableSuperstars.length > 0) {
                unhappySuperstars = getRandomSample(availableSuperstars, 2);
            } else {
                unhappySuperstars = getRandomSample(superstars, 2);
            }

            for (const s of unhappySuperstars) {
                await changeSuperstarMoraleToUnhappy(s, company);
            }

            data['unhappySuperstars'] = unhappySuperstars.map(x => x.name);
            data['unhappyReason'] = 'dummy wrestling';
        }

        if (company.userControlled) {
            // Add news
            newsItem = await generateNewsItem({
                company: company, month, year, superstar: superstar, newsType: 'dummy_wrestling', headline: true
            });

            // Add mark out message
            if (getRandomInt(0, 100) <= 50) {
                const markOutSuperstar = getRandomChoice(superstars.filter(x => !objectInArray(x, unhappySuperstars)));
                const newMessage = await createSuperstarMarkedOutMessage(markOutSuperstar, segmentItem.name, superstar,
                    month, year);
                await addCompanyMessages(company, [newMessage]);
            }
        }
    }

    if (segmentItem.name === 'Timely Rescue') {
        if (staffMembers.length > 0) {
            const availableStaffMembers = getAvailableStaffMembers(staffMembers);
            let staffMember;
            if (availableStaffMembers.length > 0) {
                staffMember = getRandomChoice(availableStaffMembers, superstarRandom())
            }
            else {
                staffMember = getRandomChoice(staffMembers, superstarRandom())
            }

            staffMember.unavailableMonths = 2;
            data['unavailableStaffMember'] = staffMember.name;

            if (company.userControlled) {
                newsItem = await generateNewsItem({
                    company: company, month, year, superstar: superstar, staffMember: staffMember,
                    staffMemberPronoun: getRosterMemberPronoun(staffMember),
                    staffMemberObjectivePronoun: getRosterMemberPronoun(staffMember, 'objective'),
                    newsType: 'timely_rescue', headline: true
                });
            }
        }
    }

    if (segmentItem.name === 'Helicopter Raid') {
        let segmentEvent = await getSegmentEvent(segment);
        superstar.suspensionMonths = segmentEvent.weeklyShow ? 1 : 2;
        data['suspendedSuperstar'] = superstar.name;

        await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});

        if (company.userControlled) {
            let competitors = await getActiveCompetitorsForCompany(company, game);
            if (competitors.length > 0) {
                let competitor = getRandomChoice(competitors, superstarRandom());
                newsItem = await generateNewsItem({
                    company: company, month, year, superstar: superstar, competitor: competitor,
                    newsType: 'helicopter_raid', headline: true
                });
            }
        }
    }

    if (segmentItem.name === 'Ring Invasion') {
        let segmentEvent = await getSegmentEvent(segment);
        superstar.suspensionMonths = segmentEvent.weeklyShow ? 1 : 2;
        data['suspendedSuperstar'] = superstar.name;

        // Check talent request
        await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});

        if (company.userControlled) {
            newsItem = await generateNewsItem({
                company: company, month, year, superstar: superstar, newsType: 'ring_invasion', headline: true
            });
        }
    }

    if (segmentItem.name === 'Love Making') {
        const penalty = myround(getRandomInt(100, 200), 20);
        company.points -= penalty;
        company.points = limitValueBetweenRange(company.points, 0, company.points);
        data['creativePointsPenalty'] = penalty;

        if (company.userControlled) {
            // Add news
            newsItem = await generateNewsItem({
                company: company, month, year, superstar: superstar, newsType: 'love_making', headline: true
            });

            // Add mark out message
            if (getRandomInt(0, 100) <= 50) {
                const mainRoster = await getCompanyRosterByType(company, 'main');
                const superstars = (await getRosterSuperstars(mainRoster)).filter(x => !objectInArray(x, participants));
                const markOutSuperstar = getRandomChoice(superstars);
                const newMessage = await createSuperstarMarkedOutMessage(markOutSuperstar, segmentItem.name, superstar,
                    month, year);
                await addCompanyMessages(company, [newMessage]);
            }
        }
    }

    if (segmentItem.name === 'Celebrity Beatdown') {
        const penalty = myround(getRandomInt(100, 200), 20);
        company.points -= penalty;
        company.points = limitValueBetweenRange(company.points, 0, company.points);
        data['creativePointsPenalty'] = penalty;

        if (company.userControlled) {
            const celebrity = getRandomChoice(specialSegmentCelebritiesData, superstarRandom())['name'];
            newsItem = await generateNewsItem({
                company: company, month, year, superstar: superstar, celebrity: celebrity,
                newsType: 'celebrity_beatdown', headline: true
            });

            if (getRandomInt(0, 100) <= 50) {
                const mainRoster = await getCompanyRosterByType(company, 'main');
                const superstars = (await getRosterSuperstars(mainRoster)).filter(x => !objectInArray(x, participants));
                const markOutSuperstar = getRandomChoice(superstars);
                const newMessage = await createSuperstarMarkedOutMessage(markOutSuperstar, segmentItem.name, superstar,
                    month, year);
                await addCompanyMessages(company, [newMessage]);
            }
        }
    }

    if (segmentItem.name === 'Hosedown') {
        const mainRoster = await getCompanyRosterByType(company, 'main');
        const superstars = (await getRosterSuperstars(mainRoster)).filter(x => !objectInArray(x, participants));
        const availableSuperstars = superstars.filter(x => checkAvailability(x, true) && !x.unhappy);

        // Set unhappy superstars
        let unhappySuperstars = [];
        if (!game.settings['no_unhappiness']) {
            if (availableSuperstars.length > 0) {
                unhappySuperstars = getRandomSample(availableSuperstars, 2);
            } else {
                unhappySuperstars = getRandomSample(superstars, 2);
            }

            for (const s of unhappySuperstars) {
                await changeSuperstarMoraleToUnhappy(s, company);
            }

            data['unhappySuperstars'] = unhappySuperstars.map(x => x.name);
            data['unhappyReason'] = 'hosedown';
        }

        if (company.userControlled) {
            // Add news
            newsItem = await generateNewsItem({
                company: company, month, year, superstar: superstar, newsType: 'hosedown', headline: true
            });

            // Add mark out message
            if (getRandomInt(0, 100) <= 50) {
                const markOutSuperstar = getRandomChoice(superstars.filter(x => !objectInArray(x, unhappySuperstars)));
                const newMessage = await createSuperstarMarkedOutMessage(markOutSuperstar, segmentItem.name, superstar,
                    month, year);
                await addCompanyMessages(company, [newMessage]);
            }
        }
    }

    if (segmentItem.name === 'Anti-Company Rant') {
        let segmentEvent = await getSegmentEvent(segment);
        superstar.suspensionMonths = segmentEvent.weeklyShow ? 1 : 2;
        data['suspendedSuperstar'] = superstar.name;

        // Check talent request
        await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});

        if (company.userControlled) {
            // Add news
            newsItem = await generateNewsItem({
                company: company, month, year, superstar: superstar, newsType: 'anti_company_rant', headline: true
            });
        }
    }

    // Add news item
    if (newsItem) {
        await addCompanyNewsItems(mainCompany, [newsItem]);
    }

    data['ownerName'] = company.ownerName || 'the Owner';

    return data;
}

async function runSegmentConsequence(segmentItem, segment, participants, company, mainCompany, game, month, year,
                                     indieRoster, indieAvailableRoster, winnerParticipant, graphics,
                                     segmentManagers) {  // run_segment_consequence
    const data = {};
    const vacated = [];
    const awarded = [];
    const fired = [];
    const feudsEnded = [];
    const feudItemsLevelData = [];
    const unlockedFeudItems = [];
    const turnedHeel = [];
    const turnedFace = [];
    const turnedNeutral = [];
    const feudsStarted = [];
    const feudPotentials = [];
    const feudHypeIncreased = [];
    const disbanded = [];
    const createdChampionships = [];
    const unavailable = [];
    const suspended = [];
    const retirements = [];
    const teamsCreated = [];
    const managersAdded = [];
    const managersRemoved = [];
    const factionReputationsData = [];
    const factionSegmentConsequence = {};
    const brandChanges = [];
    const maskRemoved = [];
    let shockingTurn = false;
    let turnTooSoon = false;
    let monthsAfterTurn = 0;
    let consequenceRunOn = null;
    const monthsPassed = (year * 12) + month;
    const rosters = await getCompanyRosters(company);
    const companyChampionships = await getCompanyChampionships(company);
    const segmentEvent = await getSegmentEvent(segment);
    const mainRoster = await getCompanyRosterByType(company, 'main', rosters);
    const staffMembers = await getCompanyStaff(company);
    const feudItems = await getCompanyFeudItems(company);
    const latestEvent = await getCompanyLatestEvent(company);
    let segmentSuperstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
    const prestigeRanks = {'S': 4, 'A': 3, 'B': 2, 'C': 1};

    // Check if singles/tag/trio participants
    let singles = false, tag = false;
    if (participants.length > 0) {
        if (participants[0].objectName === 'superstar') {
            singles = true;
        } else {
            tag = true;
        }
    }

    // Get who to apply consequence to
    let applyConsequenceTo ;
    if (segment.consequenceAppliedTo) {
        applyConsequenceTo = participants.find(x => x.name === segment.consequenceAppliedTo)
    } else {
        applyConsequenceTo = winnerParticipant;
    }

    if (['feud-blowoff', 'face-turn-and-blowoff', 'create-tag-team-and-blowoff'].includes(segmentItem.consequence)) {

        for (const s of participants) {

            // Check for existing feud
            let existingFeud;
            for (const f of (await getRosterMemberFeuds(s))) {
                if ((f.started && !f.ended) || (!f.started && f.directFeudEvent && !f.ended)) {
                    if ((await getFeudParticipants(f)).every(y => objectInArray(y, participants))) {
                        existingFeud = f;
                        break;
                    }
                }
            }

            if (existingFeud) {
                // End feud
                existingFeud.ended = true;
                if (existingFeud.started) {
                    existingFeud.rating = await getFeudRating(existingFeud);
                }
                existingFeud.endMonth = month;
                existingFeud.endYear = year;

                const d = {
                    'name': existingFeud.name,
                    'participants': (await getFeudParticipants(existingFeud)).map(x => x.name),
                    'rating': existingFeud.rating
                };
                if (!feudsEnded.includes(d)) {
                    feudsEnded.push(d);

                    // Change prestige
                    if (existingFeud.ended && existingFeud.started && globalUser.paid) {
                        const feudItem = await getFeudFeudItem(existingFeud);
                        let levelIncrease = false;
                        let hypeIncrease = 0;

                        // Add xp
                        let increase = 0;
                        if (existingFeud.rating !== null) {
                            increase = Math.floor(Math.pow(existingFeud.rating, 2));
                        }
                        feudItem.xp += increase;

                        if (feudItem.level < 3) {
                            // Check level increase
                            if (feudItem.xp >= Math.pow(feudItem.level, 2) * 40) {
                                // Increase base hype
                                hypeIncrease = feudItem.level * 5;
                                feudItem.baseHype += hypeIncrease;

                                feudItem.level += 1;
                                levelIncrease = true;
                            }
                        }

                        // Prepare data
                        const feudItemLevelData = {
                            'name': feudItem.name,
                            'xp': feudItem.xp,
                            'xpChange': increase,
                            'level': feudItem.level,
                            'levelIncrease': levelIncrease,
                            'hypeIncrease': hypeIncrease
                        };
                        feudItemsLevelData.push(feudItemLevelData);

                        const unlocked = checkFeudItemsToUnlock(feudItem, (await getCompanyFeudItems(company)));
                        unlockedFeudItems.push(...unlocked);
                    }
                }

                // Unlock special segment
                if (existingFeud.rating >= 4.5 && existingFeud.name.toLowerCase().includes('family')) {
                    await unlockSpecialSegment(company, 'Car Explosion', month, year);
                }
            }
        }

        // Add face turn
        if (segmentItem.consequence === 'face-turn-and-blowoff') {
            for (const s of applyConsequenceTo.tempSuperstars) {
                if (s.alignment !== 'face') {
                    await turnRosterMember(s, 'face', company);
                }
            }
            turnedFace.push({'name': applyConsequenceTo.name, 'shocking': shockingTurn});
        }
    }

    if (segmentItem.consequence === 'fire-superstar') {
        let superstars = participants[0].tempSuperstars;

        // Process superstars if not on trade
        superstars = superstars.filter(x => x.activeEffect !== 'traded');
        const overnessDecrease = getRandomInt(8, 12);

        for (const superstar of superstars) {
            // Move to indies
            if (game.settings['all_indies_available']) {
                await addRosterSuperstars(indieAvailableRoster, [superstar]);
            } else {
                await addRosterSuperstars(indieRoster, [superstar]);
            }

            // Lower overness
            superstar.overness -= overnessDecrease;

            fired.push({
                'name': superstar.name,
                'pronoun': superstar.possessivePronoun,
                'overnessDecrease': overnessDecrease
            });

            // Remove teams/managers/factions
            disbanded.push(...await removeSuperstarTagTeams(superstar));
            await removeSuperstarFactionRelationships(superstar, month, year);
            await removeSuperstarManagerRelationships(superstar);
            superstar.brandName = null;

            // Vacate championships
            vacated.push(...(await vacateChampionships({superstar, championships: companyChampionships, month, year})));

            // Delete all relationships, add former company relationship
            for (const relationship of (await getSuperstarRelationships(superstar))) {
                await Relationships.remove(relationship)
            }
            await addFormerCompanyRelationship(superstar, company);

            // Delete talent requests
            for (const talentRequest of (await getSuperstarTalentRequests(superstar))) {
                await TalentRequests.remove(talentRequest)
            }

            // Make superstar happy
            changeSuperstarMoraleToHappy(superstar);

            // Add news
            let newsItem = await generateNewsItem({
                company, month: game.newsMonth, year: game.newsYear, superstar, newsType: 'superstar_released_by_company'
            });
            await addCompanyNewsItems(mainCompany, [newsItem]);

            if (company.userControlled) {
                // Add message
                const newMessage = await createTalentReleasedMessage(superstar, staffMembers, month, year);
                await addCompanyMessages(company, [newMessage]);
            }

            if (company.storyName === 'passion') {
                await processPowSuperstarLeavesCompany(superstar, company);
            }
        }
    }

    if (segmentItem.consequence === 'vacate-title') {

        // Get championships to vacate
        const championshipsToVacate = [];
        if (segment.consequenceData) {
            const championshipUid = segment.consequenceData['championshipUid'];
            if (championshipUid) {
                const championship = await Championships.get(championshipUid);
                if (championship) {
                    championshipsToVacate.push(championship);
                }
            }
        }

        // Vacate championships
        for (const s of participants[0].tempSuperstars) {
            const vacatedChampionships = await vacateChampionships({
                superstar: s, championships: companyChampionships, month, year, company,
                championshipsToVacate: championshipsToVacate, checkTalentRequest: true
            });
            vacated.push(...vacatedChampionships);
        }
    }

    if (segmentItem.consequence === 'award-title') {

        // Get championship to award
        let championship;
        if (segment.consequenceData) {
            const championshipUid = segment.consequenceData['championshipUid'];
            if (championshipUid) {
                championship = await Championships.get(championshipUid);
            }
        }

        // Award championship(s)
        if (championship) {
            const championshipsSet = companyChampionships.filter(x => checkAreChampionshipsEqual(x, championship));
            for (let i = 0; i < championshipsSet.length; i++) {
                const s = participants[0].tempSuperstars[i];
                const c = championshipsSet[i];
                await addSuperstarChampionships(s, [c]);
                s.popularity += getChampionshipPopularityIncrease(c);
                c.vacated = false;

                // Add championship reign
                const newReign = ChampionshipReign(month, year);
                await ChampionshipReigns.insert(newReign);
                await addChampionshipChampionshipReigns(c, [newReign]);
                await addSuperstarChampionshipReigns(s, [newReign]);

                // Transfer match contract
                if (c.matchContract) {
                    const matchContract = await getChampionshipMatchContract(c);
                    if (matchContract) {
                        await addTalentMatchContracts(participants[0], [matchContract]);
                    }
                }
            }

            // Award titles
            awarded.push(getChampionshipMatchData(championshipsSet[0]));
        }
    }

    if (segmentItem.consequence === 'heel-turn' || segmentItem.consequence === 'face-turn') {
        if (applyConsequenceTo) {
            let participantAlignment = applyConsequenceTo.tempSuperstars.every(s => s.alignment);
            let alignmentMonths = applyConsequenceTo.tempSuperstars.reduce((total, s) => total + s.alignmentMonths, 0) /
                applyConsequenceTo.tempSuperstars.length;
            let popularity = await getRosterMemberPopularity(applyConsequenceTo);
            let newLog;
            let overnessChange = 0;

            // Check for shocking turn
            if (participantAlignment && alignmentMonths >= 12 && popularity >= 800 &&
                segmentItem.minParticipants > 1) { // No shocking turn for solo segment

                // Set shocking turn variables
                shockingTurn = true;
                monthsAfterTurn = alignmentMonths;

                // Holy shit moment award
                const pointsGained = 30;
                company.points += pointsGained;

                // Check goals
                if (company.userControlled) {
                    let objectiveCompleted = await changeProperty({name: 'holy shit moments', change: 1,
                        company: company});
                    if (objectiveCompleted) {
                        await processObjectiveCompleted(objectiveCompleted, company);
                    }
                }

                // Unlock powerup
                if (company.storyName !== 'mars') {
                    const powerups = await getCompanyPowerups(company);
                    if (powerups.length > 0) {
                        const powerupsToUnlock = getPowerupsToUnlock(powerups);
                        if (powerupsToUnlock.length > 0) {
                            const unlockedPowerup = awardPowerup(powerupsToUnlock, true, true);
                            if (unlockedPowerup && company.userControlled) {
                                const newMessage = await createPowerupMessage(unlockedPowerup, month, year);
                                await addCompanyMessages(company, [newMessage]);
                            }
                        }
                    }
                }

                // Add log
                newLog = CompanyLog(month, year);
                newLog.type = 'turn';
                newLog.eventName = segmentEvent.name;
                newLog.value = 6;
                newLog.realYear = company.realYear;
                await CompanyLogs.insert(newLog);
                await addCompanyCompanyLogs(company, [newLog]);

                // Increase overness
                overnessChange = 5;
                overnessChange += Math.floor(monthsAfterTurn / 6);
                if (overnessChange > 15) {
                    overnessChange = 15;
                }
                for (const s of applyConsequenceTo.tempSuperstars) {
                    s.overness += overnessChange;
                }
            }
            // Check for turn too soon
            else if (participantAlignment && alignmentMonths < 6 && monthsPassed > 6) {
                turnTooSoon = true;
                monthsAfterTurn = alignmentMonths;

                // Decrease overness
                overnessChange = 1;
                overnessChange += (6 - monthsAfterTurn) * 4;
                overnessChange = Math.floor(overnessChange * -1);
                for (const s of applyConsequenceTo.tempSuperstars) {
                    s.overness += overnessChange;
                }
            }

            if (segmentItem.consequence === 'heel-turn') {
                for (const s of applyConsequenceTo.tempSuperstars) {
                    if (s.alignment !== 'heel') {
                        await turnRosterMember(s, 'heel', company);
                    }
                }
                turnedHeel.push({
                    'name': applyConsequenceTo.name,
                    'shocking': shockingTurn,
                    'pronoun': applyConsequenceTo.possessivePronoun,
                    'overnessChange': overnessChange,
                    'tooSoon': turnTooSoon
                });
                if (shockingTurn) {
                    const turnedOn = participants.find(x => x.$loki !== applyConsequenceTo.$loki);
                    newLog.text = `${applyConsequenceTo.name} turned on ${turnedOn.name} in a shocking move!`;
                }
            }
            else if (segmentItem.consequence === 'face-turn') {
                for (const s of applyConsequenceTo.tempSuperstars) {
                    if (s.alignment !== 'face') {
                        await turnRosterMember(s, 'face', company);
                    }
                }
                turnedFace.push({
                    'name': applyConsequenceTo.name,
                    'shocking': shockingTurn,
                    'pronoun': applyConsequenceTo.possessivePronoun,
                    'overnessChange': overnessChange,
                    'tooSoon': turnTooSoon
                });
                if (shockingTurn) {
                    newLog.text = `${applyConsequenceTo.name} turned Face in a shocking move!`;
                }
            }

            // Disband tag team
            if (segmentItem.requirement === 'heel-team-superstars' || segmentItem.requirement === 'face-team-superstars') {
                // Get tag team
                let tagTeam;
                for (const t of (await getSuperstarTagTeams(applyConsequenceTo))) {
                    if (!t.temporary && checkAreObjArraysEqual((await getTagTeamSuperstars(t)), participants)) {
                        tagTeam = t;
                    }
                }
                if (tagTeam) {
                    // Vacate championships
                    const tagTeamSuperstars = await getTagTeamSuperstars(tagTeam);
                    const vacatedChampionships = await vacateChampionships({superstar: tagTeamSuperstars[0],
                        championships: companyChampionships, month, year, tagTeam: tagTeam});
                    vacated.push(...vacatedChampionships);

                    // Remove tag team
                    await removeTagTeam(tagTeam);

                    disbanded.push(tagTeam.name);

                    // Check talent request
                    for (const superstar of tagTeamSuperstars) {
                        let requestData = {'teamId': tagTeam.$loki};
                        await checkTalentRequestAction({company: company, requestType: 'disband_team', talent: superstar, data: requestData});
                    }
                }
            }

        }
    }

    if (segmentItem.consequence === 'neutral-turn') {
        for (const s of applyConsequenceTo.tempSuperstars) {
            if (s.alignment !== '') {
                await turnRosterMember(s, null, company);
            }
        }
        turnedNeutral.push({
            'name': applyConsequenceTo.name
        });
    }

    if (segmentItem.consequence === 'boost-event-hype') {
        const parentEvents = await getCompanyParentEvents(company);
        const nextEvent = await getUpcomingMonthlyEventForWeeklyEvent(latestEvent, parentEvents, company);
        consequenceRunOn = nextEvent.name;

        // Add hype boost to next event
        const eventHypeBoost = getSegmentEventHypeBoost(segment.rating, segmentItem.hypeBoost);
        segmentEvent.nextEventBoost += eventHypeBoost;
        data['hypeBoostAdded'] = eventHypeBoost;
        segment.participants = [nextEvent.name];
    }

    if (segmentItem.consequence === 'boost-main-event-hype') {
        const matchesAndSegments = await getEventMatchesAndSegments(segmentEvent);
        if (matchesAndSegments.length > 0) {
            const sortedSegmentAndMatches = matchesAndSegments.sort((a, b) => a.order - b.order);
            const mainEvent = sortedSegmentAndMatches[0];
            consequenceRunOn = await getMatchOrSegmentName(mainEvent);

            // Add hype boost to main event
            const hypeBoost = getMainEventHypeBoost(segment.rating, segmentItem.hypeBoost);
            mainEvent.hype += hypeBoost;

            // Add hype to event
            segmentEvent.hype += Math.round(hypeBoost / matchesAndSegments.length);

            data['hypeBoostAdded'] = hypeBoost;
            data['mainEventHype'] = mainEvent.hype;
            data['eventHype'] = segmentEvent.hype;
            segment.participants = [consequenceRunOn];
        } else {
            consequenceRunOn = 'Main Event';
            segment.participants = ['Main Event'];
        }
    }

    if (segmentItem.consequence === 'boost-popularity') {
        // Get best match/segment of last event, except production segments
        let companyEvents = (await getCompanyEvents(company)).reverse();
        let previousEvent = companyEvents[1];
        let segmentsAndMatches = await getEventMatches(previousEvent);
        for (const x of (await getEventSegments(previousEvent))) {
            if (!(await getSegmentSegmentItem(x))?.productionSegment) {
                segmentsAndMatches.push(x)
            }
        }

        if (segmentsAndMatches.length > 0) {

            // Get match or segment
            let matchOrSegment;
            if (segment.consequenceData) {
                let matchOrSegmentUid = segment.consequenceData['matchOrSegmentUid'];
                let matchOrSegmentType = segment.consequenceData['matchOrSegmentType'];
                if (matchOrSegmentUid) {
                    matchOrSegment = segmentsAndMatches.find(y => y.$loki === matchOrSegmentUid &&
                        y.objectName === matchOrSegmentType);
                }
            }
            if (!matchOrSegment) {
                // Compatibility with old saves
                matchOrSegment = (segmentsAndMatches.sort((a, b) => b.rating - a.rating))[0];
            }

            // Get name and set participants
            consequenceRunOn = await getMatchOrSegmentName(matchOrSegment);
            segment['participants'] = [consequenceRunOn];

            // Boost pop for participants
            let popularityBoost = getSegmentPopularityBoost(segment.rating, segmentItem.popularityBoost);
            let matchOrSegmentParticipants;
            if (matchOrSegment.objectName === 'segment') {
                matchOrSegmentParticipants = await getSegmentParticipants(matchOrSegment)
            }
            else {
                matchOrSegmentParticipants = await getMatchParticipants(matchOrSegment)
            }
            for (const p of matchOrSegmentParticipants) {
                for (let s of (await getRosterMemberSuperstars(p))) {
                    popularityBoost = updateSuperstarPopularity(s, popularityBoost, false, false, true);
                }
            }
            data['popularityBoostAdded'] = popularityBoost;
        }
        else {
            consequenceRunOn = 'Segment on Last Show';
            segment['participants'] = [consequenceRunOn];
        }
    }

    if (segmentItem.consequence === 'vacate-title-and-create-match-contract') {
        let championship;
        for (const s of segmentSuperstars) {
            let championships = (await getSuperstarChampionships(s)).filter(c => prestigeRanks[c.prestige] >= 2);
            if (singles) {
                championships = championships.filter(x => !x.tagTeam && !x.trio)
            }
            else {
                if (participants[0].trio) {
                    championships = championships.filter(x => x.trio || x.tagTeam);
                }
                else {
                    championships = championships.filter(x => x.tagTeam);
                }
            }
            if (championships.length > 0) {
                championship = championships[0];
                break;
            }
        }
        if (championship) {
            let matchContractAwarded = await runOptionCAction(championship, companyChampionships, company, month, year);
            if (matchContractAwarded) {
                vacated.push(getChampionshipMatchData(championship));
                awarded.push(getChampionshipMatchData(matchContractAwarded[0]));
            }
        }
    }

    if (segmentItem.consequence === 'change-title-design') {
        let championship;
        for (const s of segmentSuperstars) {
            let championships = (await getSuperstarChampionships(s)).filter(c => prestigeRanks[c.prestige] >= 3);
            if (singles) {
                championships = championships.filter(x => !x.tagTeam && !x.trio)
            }
            else {
                if (participants[0].trio) {
                    championships = championships.filter(x => x.trio || x.tagTeam);
                }
                else {
                    championships = championships.filter(x => x.tagTeam);
                }
            }
            if (championships.length > 0) {
                championship = championships[0];
                break;
            }
        }
        if (championship) {
            await runCustomizeChampionshipAction(championship, companyChampionships);

            let requestData = {'championshipId': championship.$loki};
            await checkTalentRequestAction({company: company, requestType: 'customize_championship', talent: participants[0],
                data: requestData});
        }
    }

    if (segmentItem.consequence === 'split-title') {
        let championship;
        for (const s of segmentSuperstars) {
            let championships = (await getSuperstarChampionships(s)).filter(c => prestigeRanks[c.prestige] >= 4);
            if (singles) {
                championships = championships.filter(x => !x.tagTeam && !x.trio)
            }
            else {
                if (participants[0].trio) {
                    championships = championships.filter(x => x.trio || x.tagTeam);
                }
                else {
                    championships = championships.filter(x => x.tagTeam);
                }
            }
            if (championships.length > 0) {
                championship = championships[0];
                break;
            }
        }
        if (championship) {
            let championshipName = null;
            if (segment.consequenceData) {
                championshipName = segment.consequenceData['objectName'];
            }
            const newChampionships = await runSplitChampionshipAction(championship, companyChampionships, company, championshipName);
            if (newChampionships) {
                createdChampionships.push(getChampionshipMatchData(newChampionships[0]));
            }
        }
    }

    if (segmentItem.consequence === 'suspend') {
        for (const superstar of segmentSuperstars) {
            superstar.suspensionMonths = segmentEvent.weeklyShow ? 1 : 2;
            suspended.push({'name': superstar.name, 'months': 1});

            // Check talent request
            await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});
        }
    }

    if (segmentItem.consequence === 'retire') {
        for (const superstar of segmentSuperstars) {
            if (superstar.activeEffect !== 'traded') {
                const retirementData = await retireSuperstar(superstar, mainRoster, companyChampionships, month, year,
                    company);
                retirements.push(retirementData);
                vacated.push(...retirementData['vacated']);
                disbanded.push(...retirementData['tagTeams']);
            }
        }
    }

    if (segmentItem.consequence === 'make-unavailable') {
        // Get months unavailable for
        let monthsUnavailable = null;
        if (segment.consequenceData) {
            if (segment.consequenceData['monthsUnavailable']) {
                monthsUnavailable = parseInt(segment.consequenceData['monthsUnavailable']);
            }
        }
        if (!monthsUnavailable) {
            monthsUnavailable = getRandomInt(3, 5);
        }

        for (const superstar of segmentSuperstars) {
            addKayfabeInjuryToSuperstar(superstar, monthsUnavailable);
            unavailable.push({'name': superstar.name});

            // Check talent request
            await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});
        }
    }

    if (segmentItem.consequence === 'loser-unavailable') {
        const loser = participants.find(p => p.$loki !== winnerParticipant.$loki);

        // Get months unavailable for
        let monthsUnavailable = null;
        if (segment.consequenceData) {
            if (segment.consequenceData['monthsUnavailable']) {
                monthsUnavailable = parseInt(segment.consequenceData['monthsUnavailable']);
            }
        }
        if (!monthsUnavailable) {
            monthsUnavailable = getRandomInt(3, 5);
        }

        for (const superstar of loser.tempSuperstars) {
            addKayfabeInjuryToSuperstar(superstar, monthsUnavailable);
            unavailable.push({'name': superstar.name});

            // Check talent request
            await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});
        }

        // Add to company logs
        let newLog = CompanyLog(month, year);
        newLog.type = 'injury';
        newLog.text = `${winnerParticipant.name} injured ${loser.name}`;
        newLog.value = 0;
        await CompanyLogs.insert(newLog);
        await addCompanyCompanyLogs(company, [newLog]);
    }

    if (segmentItem.consequence === 'create-tag-team-and-blowoff' || segmentItem.consequence === 'create-team') {
        // Create team and add to roster
        const tagTeam = await generateTagTeam(participants);
        if (segment.consequenceData) {
            const teamName = segment.consequenceData['objectName'];
            if (teamName) {
                tagTeam.name = teamName;
            }
        }
        await addRosterTagTeams(mainRoster, [tagTeam]);
        if (participants.length === 3) {
            tagTeam.trio = true;
        }

        teamsCreated.push({'name': tagTeam.name, 'superstars': commaSeparate(participants.map(x => x.name))});

        // Add log
        const newLog = CompanyLog(month, company.realYear);
        CompanyLogs.insert(newLog);
        newLog.text = `${tagTeam.name}`;
        newLog.type = 'new-tag-team';
        newLog.realYear = year;
        await addCompanyCompanyLogs(company, [newLog]);

        // Check talent request
        for (const participant of participants) {
            for (const teamMember of participants.filter(x => x !== participant)) {
                let requestData = {'talentId': teamMember.$loki};
                await checkTalentRequestAction({company: company, requestType: 'team_with_x', talent: participant,
                    data: requestData});
            }
        }
    }

    if (segmentItem.consequence === 'create-trio-of-heels') {
        // Create trio of heels and add to roster
        const trioMembers = participants.filter((y) => y.alignment === 'heel');
        if (trioMembers.length === 3) {
            const trio = await generateTrio(trioMembers);
            if (segment.consequenceData) {
                const teamName = segment.consequenceData['objectName'];
                if (teamName) {
                    trio.name = teamName;
                }
            }
            await addRosterTagTeams(mainRoster, [trio]);
            teamsCreated.push({'name': trio.name, 'superstars': commaSeparate(trioMembers.map(x => x.name))});

            // Add log
            const newLog = CompanyLog(month, company.realYear);
            CompanyLogs.insert(newLog);
            newLog.text = `${trio.name}`;
            newLog.type = 'new-tag-team';
            newLog.realYear = year;
            await addCompanyCompanyLogs(company, [newLog]);

            // Check talent request
            for (const participant of trioMembers) {
                for (const teamMember of trioMembers.filter(x => x !== participant)) {
                    let requestData = {'talentId': teamMember.$loki};
                    await checkTalentRequestAction({company: company, requestType: 'team_with_x', talent: participant,
                        data: requestData});
                }
            }
        }
    }

    if (segmentItem.consequence === 'remove-tag-team-and-create-tag-team') {
        // Get tag team
        let participantInTeam;
        let participantTagTeam;
        for (const p of participants) {
            let pt = (await getSuperstarTagTeams(p)).find(x => !x.temporary && !x.trio);
            if (pt) {
                participantInTeam = p;
                participantTagTeam = pt;
                break;
            }
        }
        if (participantInTeam) {
            // Vacate championships
            const teamSuperstars = await getTagTeamSuperstars(participantTagTeam);
            const vacatedChampionships = await vacateChampionships({superstar: teamSuperstars[0],
                championships: companyChampionships, month, year, tagTeam: participantTagTeam});
            vacated.push(...vacatedChampionships);

            // Remove tag team
            await removeTagTeam(participantTagTeam);

            disbanded.push(participantTagTeam.name);

            // Check talent request
            for (const superstar of teamSuperstars) {
                let requestData = {'teamId': participantTagTeam.$loki};
                await checkTalentRequestAction({company: company, requestType: 'disband_team', talent: superstar,
                    data: requestData});
            }
        }

        // Create new tag team and add to roster
        const tagTeam = await generateTagTeam(participants);
        if (segment.consequenceData) {
            const teamName = segment.consequenceData['objectName'];
            if (teamName) {
                tagTeam.name = teamName;
            }
        }
        await addRosterTagTeams(mainRoster, [tagTeam]);
        teamsCreated.push({'name': tagTeam.name, 'superstars': commaSeparate(participants.map(x => x.name))});

        // Add log
        const newLog = CompanyLog(month, company.realYear);
        CompanyLogs.insert(newLog);
        newLog.text = `${tagTeam.name}`;
        newLog.type = 'new-tag-team';
        newLog.realYear = year;
        await addCompanyCompanyLogs(company, [newLog]);

        // Check talent request
        for (const participant of participants) {
            const teamMember = participants.find(x => x !== participant);
            if (teamMember) {
                let requestData = {'talentId': teamMember.$loki};
                await checkTalentRequestAction({company: company, requestType: 'team_with_x', talent: participant,
                    data: requestData});
            }
        }
    }

    if (segmentItem.consequence === 'create-retirement-feud') {
        // Find existing feuds
        const feuds = [];
        for (const s of participants) {
            // Check for existing feud
            let existingFeud;
            for (const f of (await getRosterMemberFeuds(s))) {
                if ((f.started && !f.ended) || (!f.started && f.directFeudEvent && !f.ended)) {
                    if ((await getFeudParticipants(f)).every(y => objectInArray(y, participants))) {
                        existingFeud = f;
                        break;
                    }
                }
            }
            if (existingFeud) {
                feuds.push(existingFeud);
            }
        }

        // Create feud if no feuds present
        if (!feuds.length) {
            let feudItem = feudItems.find(x => x.name === 'Retire Me');
            if (!feudItem) {
                const availableFeudItems = feudItems.filter(x => x.unlocked && !x.requirement && !x.consequence);
                feudItem = getRandomChoice(availableFeudItems);
            }
            let feudParticipants = participants.slice(0, 2);
            const newFeud = Feud();
            await Feuds.insert(newFeud);
            newFeud.name = feudItem.name;
            newFeud.hype = feudItem.baseHype;
            const boosts = await getFeudCreationBoosts(newFeud, feudParticipants, month, year, company.style);
            const addedHype = boosts['hypeBoost'];
            newFeud.hype += addedHype;
            newFeud.started = true;
            newFeud.startMonth = month;
            newFeud.startYear = year;
            await addFeudItemFeuds(feudItem, [newFeud]);
            await addRosterFeuds(mainRoster, [newFeud]);
            await addSegmentFeuds(segment, [newFeud]);

            // Add feud to participants
            if (singles) {
                await addFeudSuperstars(newFeud, feudParticipants)
            }
            else if (tag) {
                await addFeudTagTeams(newFeud, feudParticipants)
            }
            newFeud.participants = feudParticipants.map(x => x.name);

            feudsStarted.push({
                'name': newFeud.name,
                'participants': newFeud.participants,
                'boosts': boosts,
                'baseHype': feudItem.baseHype
            });

            for (const feudParticipant of feudParticipants) {
                const otherFeudParticipant = feudParticipants.find((x) => x.$loki !== feudParticipant.$loki);
                // Check talent request
                if (otherFeudParticipant) {
                    let requestData = {'talentId': otherFeudParticipant.$loki};
                    await checkTalentRequestAction({company: company, requestType: 'feud_with_x', talent: feudParticipant,
                        data: requestData});
                }
            }
        }
    }

    if (segmentItem.consequence === 'create-random-feud') {
        // Add random superstar to feud participants
        let feudParticipants = [...participants];
        let availableChoices = [];
        if (singles) {
            availableChoices = (await getRosterSuperstars(mainRoster)).filter(x => !objectInArray(x, feudParticipants) &&
                checkSuperstarBrandAvailability(latestEvent, x));
        } else {
            if (participants[0].factionTagTeam) {
                // Choose factions to feud with faction
                let tagTeamSuperstar = (await getTagTeamSuperstars(participants[0]))[0];
                let participantFaction = (await getSuperstarFactions(tagTeamSuperstar)).find(y => !y.disbanded);
                feudParticipants = [participantFaction];
                for (const f of (await getRosterFactions(mainRoster))) {
                    let fs = await getFactionSuperstars(f);
                    if (!f.disbanded && !objectInArray(f, feudParticipants) &&
                        fs.every(s => checkSuperstarBrandAvailability(latestEvent, s))) {
                        availableChoices.push(f)
                    }
                }
            } else {
                for (const t of (await getRosterTagTeams(mainRoster))) {
                    let ts = await getTagTeamSuperstars(t);
                    if (!t.temporary && !objectInArray(t, feudParticipants) &&
                        ts.every(s => checkSuperstarBrandAvailability(latestEvent, s))) {
                        availableChoices.push(t)
                    }
                }
            }
        }

        if (availableChoices.length > 0) {
            let randomSuperstar = getRandomChoice(availableChoices);
            feudParticipants.push(randomSuperstar);

            // Find existing feuds
            let feuds = [];
            for (let s of feudParticipants) {
                // Check for existing feud
                let existingFeud;
                for (const f of (await getRosterMemberFeuds(s))) {
                    if ((f.started && !f.ended) || (!f.started && f.directFeudEvent && !f.ended)) {
                        if ((await getFeudParticipants(f)).every(y => objectInArray(y, participants))) {
                            existingFeud = f;
                            break;
                        }
                    }
                }
                if (existingFeud) {
                    feuds.push(existingFeud);
                }
            }

            // Create feud if no feuds present
            if (!feuds.length) {
                let feudItem = feudItems.find(x => x.name === 'Grudge');
                if (!feudItem) {
                    let companyFeudItems = feudItems.find(x => x.unlocked && !x.requirement && !x.consequence);
                    feudItem = getRandomChoice(companyFeudItems);
                }
                let newFeud = Feud();
                await Feuds.insert(newFeud);
                if (getRandomInt(0, 100) <= 50) {
                    newFeud.name = feudItem.name;
                } else {
                    newFeud.name = generateRandomFeudItemName();
                }
                newFeud.hype = feudItem.baseHype;
                let boosts = await getFeudCreationBoosts(newFeud, feudParticipants, month, year, company.style);
                let addedHype = boosts.hypeBoost;
                newFeud.hype += addedHype;
                newFeud.started = true;
                newFeud.startMonth = month;
                newFeud.startYear = year;
                await addFeudItemFeuds(feudItem, [newFeud]);
                await addRosterFeuds(mainRoster, [newFeud]);
                await addSegmentFeuds(segment, [newFeud]);

                // Add feud to participants
                if (singles) {
                    await addFeudSuperstars(newFeud, feudParticipants)
                }
                else if (tag) {
                    if (participants[0].factionTagTeam) {
                        await addFeudFactions(newFeud, feudParticipants)
                    }
                    else {
                        await addFeudTagTeams(newFeud, feudParticipants)
                    }
                }
                newFeud.participants = feudParticipants.map(x => x.name);

                feudsStarted.push({
                    'name': newFeud.name,
                    'participants': newFeud.participants,
                    'boosts': boosts,
                    'baseHype': feudItem.baseHype
                });

                for (let feudParticipant of feudParticipants) {
                    const otherFeudParticipant = feudParticipants.find((x) => x.$loki !== feudParticipant.$loki);
                    // Check talent request
                    if (otherFeudParticipant) {
                        let requestData = {'talentId': otherFeudParticipant.$loki};
                        await checkTalentRequestAction({company: company, requestType: 'feud_with_x', talent: feudParticipant,
                            data: requestData});
                    }
                }
            }
        }
    }

    if (['remove-faction-members', 'add-faction-members', 'add-faction-leader', 'change-faction-leader',
        'kick-out-faction-leader-and-change-leader', 'leave-faction-and-join-other-faction', 'merge-factions',
        'split-faction', 'create-faction'].includes(segmentItem.consequence)) {

        // Get segment factions
        const rosterFactions = await getRosterFactions(mainRoster);
        const factions = [];
        for (const y of segment.consequenceData['factionUids']) {
            const faction = rosterFactions.find(x => x.$loki === y);
            if (faction) {
                factions.push(faction);
            }
        }

        // Check faction inputs for errors
        const mainRosterSuperstars = await getRosterSuperstars(mainRoster);
        const factionSegmentCheck = await checkFactionSegmentConsequence(factions, segmentItem,
            segment.consequenceData, mainRosterSuperstars, mainRoster, latestEvent, companyChampionships);

        if ((factions.length > 0 || segmentItem.consequence === 'create-faction') && !factionSegmentCheck.error) {

            let updateFactionGraphic = false;
            let factionToMerge;
            let factionToJoin;

            // Get consequence superstars
            let segmentConsequenceSuperstars = [];
            for (const y of segment.consequenceData['superstarUids']) {
                const segmentConsequenceSuperstar = mainRosterSuperstars.find(x => x.$loki === y);
                if (segmentConsequenceSuperstar) {
                    segmentConsequenceSuperstars.push(segmentConsequenceSuperstar);
                }
            }

            // Remove duplicates
            segmentConsequenceSuperstars = getUniqueObjects(segmentConsequenceSuperstars);

            // Run consequence
            if (segmentItem.consequence === 'remove-faction-members') {
                // Update faction rep (members)
                const factionData = await processFactionXpChangeForFaction({faction: factions[0],
                    removedMembers: segmentConsequenceSuperstars});
                if (factionData) {
                    factionReputationsData.push(factionData);
                }

                await removeFactionSuperstars(factions[0], segmentConsequenceSuperstars);
                factionSegmentConsequence['removedFactionMembers'] = segmentConsequenceSuperstars.map(x => x.name);

                // Affect popularity of removed members
                const popularityChange = Math.floor(((factions[0].reputation + 1) / 1.72) ** 2) * -1;
                for (const s of segmentConsequenceSuperstars) {
                    s.popularity += popularityChange;
                }
                factionSegmentConsequence['popularityChange'] = popularityChange;

                // Check leave faction request
                for (const s of segmentConsequenceSuperstars) {
                    let requestData = {'factionId': factions[0].$loki};
                    await checkTalentRequestAction({company: company, requestType: 'leave_faction', talent: s,
                        data: requestData});
                }
            }
            else if (segmentItem.consequence === 'add-faction-members') {
                // Update faction rep (members)
                const factionData = await processFactionXpChangeForFaction({faction: factions[0],
                    addedMembers: segmentConsequenceSuperstars});
                if (factionData) {
                    factionReputationsData.push(factionData);
                }

                addFactionSuperstars(factions[0], segmentConsequenceSuperstars);
                factionSegmentConsequence['addedFactionMembers'] = segmentConsequenceSuperstars.map(x => x.name);
                updateFactionGraphic = true;

                // Affect popularity of added members
                const popularityChange = Math.floor(((factions[0].reputation + 1) / 1.72) ** 2);
                for (const s of segmentConsequenceSuperstars) {
                    s.popularity += popularityChange;
                }
                factionSegmentConsequence['popularityChange'] = popularityChange;

                // Check join faction request
                for (const s of segmentConsequenceSuperstars) {
                    let requestData = {'factionId': factions[0].$loki};
                    await checkTalentRequestAction({company: company, requestType: 'join_faction', talent: s,
                        data: requestData});
                }
            }
            else if (['add-faction-leader', 'change-faction-leader'].includes(segmentItem.consequence)) {
                // Add leader to faction if not present in it
                if (!objectInArray(segmentConsequenceSuperstars[0], (await getFactionSuperstars(factions[0])))) {
                    addFactionSuperstars(factions[0], [segmentConsequenceSuperstars[0]]);
                    factionSegmentConsequence['addedFactionMembers'] = [segmentConsequenceSuperstars[0].name];
                    updateFactionGraphic = true;

                    // Check join faction request
                    let requestData = {'factionId': factions[0].$loki};
                    await checkTalentRequestAction({company: company, requestType: 'join_faction',
                        talent: segmentConsequenceSuperstars[0], data: requestData});
                }

                // Set new leader
                setFactionLeaderSuperstar(factions[0], segmentConsequenceSuperstars[0]);
                factionSegmentConsequence['setFactionLeader'] = segmentConsequenceSuperstars[0].name;

                // Update faction rep (members) if leader is new member
                if (factionSegmentConsequence['addedFactionMembers']) {
                    const factionData = await processFactionXpChangeForFaction({
                        faction: factions[0],
                        addedMembers: [segmentConsequenceSuperstars[0]]
                    });
                    if (factionData) {
                        factionReputationsData.push(factionData);
                    }
                }
            }
            else if (segmentItem.consequence === 'kick-out-faction-leader-and-change-leader') {
                // Remove faction leader from faction
                const factionLeader = await getFactionLeaderSuperstar(factions[0]);
                if (factionLeader) {
                    // Update faction rep (members)
                    const factionData = await processFactionXpChangeForFaction({
                        faction: factions[0],
                        removedMembers: [factionLeader]
                    });
                    if (factionData) {
                        factionReputationsData.push(factionData);
                    }

                    await removeFactionSuperstars(factions[0], [factionLeader]);
                    factionSegmentConsequence['removedFactionMembers'] = [factionLeader.name];

                    // Check leave faction request
                    let requestData = {'factionId': factions[0].$loki};
                    await checkTalentRequestAction({company: company, requestType: 'leave_faction', talent: factionLeader,
                        data: requestData});
                }

                // Set new leader
                await setFactionLeaderSuperstar(factions[0], segmentConsequenceSuperstars[0]);
                factionSegmentConsequence['setFactionLeader'] = segmentConsequenceSuperstars[0].name;

                // Add feud potential
                const feudItem = feudItems.find(x => x.unlocked && x.requirement === 'usurped');
                if (feudItem && factionLeader) {
                    const newFeud = Feud();
                    await Feuds.insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    await addFeudItemFeuds(feudItem, [newFeud]);
                    await addRosterFeuds(mainRoster, [newFeud]);
                    const feudSuperstars = [factionLeader, segmentConsequenceSuperstars[0]];
                    await addFeudSuperstars(newFeud, feudSuperstars);
                    newFeud.participants = feudSuperstars.map(x => x.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = month;
                    newFeud.startYear = year;
                    feudPotentials.push({'name': newFeud.name, 'participants': feudSuperstars.map(x => x.name)});
                }
            }
            else if (segmentItem.consequence === 'leave-faction-and-join-other-faction') {
                factionToJoin = rosterFactions.find(x => x.$loki === segment.consequenceData['factionConsequenceUids'][0]);

                // Update faction rep (members)
                let factionData = await processFactionXpChangeForFaction({
                    faction: factions[0],
                    removedMembers: segmentConsequenceSuperstars
                });
                if (factionData) {
                    factionReputationsData.push(factionData);
                }
                factionData = await processFactionXpChangeForFaction({
                    faction: factionToJoin,
                    addedMembers: segmentConsequenceSuperstars
                });
                if (factionData) {
                    factionReputationsData.push(factionData);
                }

                // Move superstars
                await removeFactionSuperstars(factions[0], segmentConsequenceSuperstars);
                addFactionSuperstars(factionToJoin, segmentConsequenceSuperstars);
                factionSegmentConsequence['movedFactionMembers'] = segmentConsequenceSuperstars.map(x => x.name);
                factionSegmentConsequence['consequenceFaction'] = factionToJoin.name;
                updateFactionGraphic = true;

                // Check faction requests
                for (const s of segmentConsequenceSuperstars) {
                    let requestData = {'factionId': factions[0].$loki};
                    await checkTalentRequestAction({company: company, requestType: 'leave_faction', talent: s,
                        data: requestData});
                    requestData = {'factionId': factionToJoin.$loki};
                    await checkTalentRequestAction({company: company, requestType: 'join_faction', talent: s,
                        data: requestData});
                }

                // Add feud potential
                const feudItem = feudItems.find(x => x.unlocked && x.requirement === 'switching-sides');
                if (feudItem) {
                    const newFeud = Feud();
                    await Feuds.insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    await addFeudItemFeuds(feudItem, [newFeud]);
                    await addRosterFeuds(mainRoster, [newFeud]);
                    let leaderSuperstar = await getFactionLeaderSuperstar(factions[0]);
                    let factionSuperstars = await getFactionSuperstars(factions[0]);
                    const feudSuperstars = [leaderSuperstar || getRandomChoice(factionSuperstars),
                        getRandomChoice(segmentConsequenceSuperstars)
                    ];
                    await addFeudSuperstars(newFeud, feudSuperstars);
                    newFeud.participants = feudSuperstars.map(x => x.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = game.monthCount;
                    newFeud.startYear = game.year;
                    feudPotentials.push({'name': newFeud.name, 'participants': feudSuperstars.map(x => x.name)});
                }
            }
            else if (segmentItem.consequence === 'merge-factions') {
                factionToMerge = rosterFactions.find(x => x.$loki === segment.consequenceData['factionConsequenceUids'][0]);
                let factionSuperstars = await getFactionSuperstars(factionToMerge);

                // Update faction rep (members)
                const factionData = await processFactionXpChangeForFaction({
                    faction: factions[0],
                    addedMembers: factionSuperstars
                });
                if (factionData) {
                    factionReputationsData.push(factionData);
                }

                // Disband faction to merge, move members to main faction, rename it
                factionToMerge.disbanded = true;
                addFactionSuperstars(factions[0], factionSuperstars);
                factions[0].name = segment.consequenceData['createdFactionName'];
                factionSegmentConsequence['mergedFactions'] = [factions[0].name, factionToMerge.name];
                factionSegmentConsequence['createdFactionName'] = segment.consequenceData['createdFactionName'];
                updateFactionGraphic = true;
            }
            else if (segmentItem.consequence === 'split-faction') {

                // Update faction rep (members)
                const factionData = await processFactionXpChangeForFaction({
                    faction: factions[0],
                    removedMembers: segmentConsequenceSuperstars
                });
                if (factionData) {
                    factionReputationsData.push(factionData);
                }

                // Remove superstars from faction
                await removeFactionSuperstars(factions[0], segmentConsequenceSuperstars);

                // Create new faction and add to roster
                const {reputation, xp} = getFactionCreationReputationAndXp(segmentConsequenceSuperstars);
                const newFaction = await createFaction(segment.consequenceData['createdFactionName'],
                    segmentConsequenceSuperstars, reputation, xp);
                await addRosterFactions(mainRoster, [newFaction]);

                // Add company log
                const newLog = CompanyLog(game.monthCount, company.realYear);
                CompanyLogs.insert(newLog);
                newLog.text = `${newFaction.name}`;
                newLog.type = 'new-faction';
                newLog.realYear = game.year;
                await addCompanyCompanyLogs(company, [newLog]);

                factionSegmentConsequence['newFactionMembers'] = segmentConsequenceSuperstars.map(x => x.name);
                factionSegmentConsequence['createdFactionName'] = segment.consequenceData['createdFactionName'];

                // Add feud potential
                const feudItem = feudItems.find(x => x.unlocked && x.requirement === 'internal-division');
                if (feudItem) {
                    const newFeud = Feud();
                    await Feuds.insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    await addFeudItemFeuds(feudItem, [newFeud]);
                    await addRosterFeuds(mainRoster, [newFeud]);
                    const feudFactions = [factions[0], newFaction];
                    await addFeudFactions(newFeud, feudFactions);
                    newFeud.participants = feudFactions.map(x => x.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = game.monthCount;
                    newFeud.startYear = game.year;
                    feudPotentials.push({'name': newFeud.name, 'participants': feudFactions.map(x => x.name)});
                }

                // Check leave faction request
                for (const s of segmentConsequenceSuperstars) {
                    let requestData = {'factionId': factions[0].$loki};
                    await checkTalentRequestAction({company: company, requestType: 'leave_faction', talent: s,
                        data: requestData});
                }

            }
            else if (segmentItem.consequence === 'create-faction') {

                // Get faction leader if selected
                let leaderSuperstar;
                if (segment.consequenceData['leaderUid']) {
                    leaderSuperstar = segmentConsequenceSuperstars.find(y => y.$loki === segment.consequenceData['leaderUid']);
                }

                // Create new faction and add to roster
                const {reputation, xp} = getFactionCreationReputationAndXp(segmentConsequenceSuperstars);
                const newFaction = await createFaction(segment.consequenceData['createdFactionName'],
                    segmentConsequenceSuperstars, reputation, xp, leaderSuperstar);
                await addRosterFactions(mainRoster, [newFaction]);

                // Add company log
                const newLog = CompanyLog(game.monthCount, company.realYear);
                newLog.text = `${newFaction.name}`;
                newLog.type = 'new-faction';
                newLog.realYear = game.year;
                await addCompanyCompanyLogs(company, [newLog]);

                factionSegmentConsequence['createdFactionMembers'] = segmentConsequenceSuperstars.map(x => x.name);
                factionSegmentConsequence['createdFactionName'] = segment.consequenceData['createdFactionName'];

                // Check start faction request
                for (const s of segmentConsequenceSuperstars) {
                    await checkTalentRequestAction({company: company, requestType: 'start_faction', talent: s});
                }
            }

            if (factions.length > 0) {
                factionSegmentConsequence['faction'] = factions[0].name;
            }

            // Update graphics
            if (graphics && updateFactionGraphic) {
                if (segmentItem.consequence !== 'leave-faction-and-join-other-faction') {
                    for (const x of segmentConsequenceSuperstars) {
                        if (!objectInArray(x, segmentManagers)) {
                            const superstarGraphic = getGraphicForSuperstar(x);
                            graphics.push(superstarGraphic);
                        }
                    }
                }
                if (segmentItem.consequence === 'merge-factions') {
                    for (const x of (await getFactionSuperstars(factionToMerge))) {
                        const superstarGraphic = getGraphicForSuperstar(x);
                        graphics.push(superstarGraphic);
                    }
                }
                if (segmentItem.consequence === 'leave-faction-and-join-other-faction') {
                    for (const x of (await getFactionSuperstars(factionToJoin))) {
                        const superstarGraphic = getGraphicForSuperstar(x);
                        graphics.push(superstarGraphic);
                    }
                }
                data['graphics'] = graphics;
            }
        }
    }

    if (['disband-faction', 'remove-faction-leadership'].includes(segmentItem.consequence)) {
        let teamSuperstars = await getTagTeamSuperstars(participants[0]);
        if (teamSuperstars.length > 0) {
            let faction = (await getSuperstarFactions(teamSuperstars[0])).find(x => !x.disbanded);
            if (faction) {
                if (segmentItem.consequence === 'remove-faction-leadership') {
                    let leaderSuperstar = await getFactionLeaderSuperstar(faction);
                    if (leaderSuperstar) {
                        await removeFactionLeader(faction, leaderSuperstar);
                        factionSegmentConsequence['removedFactionLeader'] = leaderSuperstar.name;
                    }
                }
                else if (segmentItem.consequence === 'disband-faction') {
                    await disbandFaction(faction, month, year);
                    factionSegmentConsequence['disbandedFaction'] = faction.name;
                }
                factionSegmentConsequence['faction'] = faction.name;
            }
        }
    }

    if (['remove-manager', 'remove-managed-talent'].includes(segmentItem.consequence)) {
        let managedParticipant = participants[participants.length - 1];
        let managerParticipant = participants.find(x => x !== managedParticipant);
        if (managedParticipant && managerParticipant) {
            await removeSuperstarsFromManager(managerParticipant, managedParticipant.tempSuperstars);
            managersRemoved.push({
                'managerName': managerParticipant.name,
                'removedSuperstarsNames': managedParticipant.tempSuperstars.map(x => x.name)
            });
        }
    }

    if (segmentItem.consequence === 'add-manager') {
        let managedParticipant = participants[participants.length - 1];
        let managerParticipant = participants.find(x => x !== managedParticipant);
        if (managedParticipant && managerParticipant) {
            // Check if manager not present, not managing full time manager, check maximum superstars for manager
            let superstarsToManage = await getRosterMemberSuperstars(managedParticipant);
            let addManagerCheck = true;
            for (let s of superstarsToManage) {
                if (s.managerId) {
                    addManagerCheck = false;
                }
                if (s.fullTimeManager) {
                    addManagerCheck = false;
                }
            }
            let managedSuperstars = [...await getSuperstarManagedSuperstars(managerParticipant)];
            if (superstarsToManage.length + managedSuperstars.length > 15) {
                addManagerCheck = false;
            }
            // Add superstars to manager if checks passed
            if (addManagerCheck) {
                await addSuperstarsToManager(managerParticipant, superstarsToManage);
                managersAdded.push({
                    'managerName': managerParticipant.name,
                    'managedSuperstarsNames': superstarsToManage.map(x => x.name)
                });
                for (let superstarToManage of superstarsToManage) {
                    await checkTalentRequestAction({company: company, requestType: 'be_managed', talent: superstarToManage});
                    let requestData = {'talentId': superstarToManage.$loki};
                    await checkTalentRequestAction({company: company, requestType: 'manage_x', talent: managerParticipant,
                        data: requestData});
                }
            }
        }
    }

    if (segmentItem.consequence === 'draft-talent-to-brand') {
        let brandUid = segment.consequenceData['brandUid'];
        let rosterBrands = await getRosterBrands(mainRoster);
        let brand = rosterBrands.find(x => x.$loki === brandUid);
        if (brand && participants.length > 0) {
            for (let s of participants[0].tempSuperstars) {
                draftSuperstarToBrand(s, brand.name, companyChampionships);
                brandChanges.push({'name': s.name, 'brandName': brand.name});
                let requestData = {'brandId': brand.$loki};
                await checkTalentRequestAction({company: company, requestType: 'change_brand', talent: s, data: requestData});
            }
        }
    }

    if (segmentItem.consequence === 'disband-team') {
        // Get tag team
        let tagTeam;
        for (const t of (await getSuperstarTagTeams(participants[0]))) {
            if (!t.temporary && checkAreObjArraysEqual((await getTagTeamSuperstars(t)), participants)) {
                tagTeam = t;
            }
        }
        if (tagTeam) {
            // Vacate championships
            const tagTeamSuperstars = await getTagTeamSuperstars(tagTeam);
            const vacatedChampionships = await vacateChampionships({superstar: tagTeamSuperstars[0],
                championships: companyChampionships, month, year, tagTeam: tagTeam});
            vacated.push(...vacatedChampionships);

            // Remove tag team
            await removeTagTeam(tagTeam);

            disbanded.push(tagTeam.name);

            // Check talent request
            for (const superstar of tagTeamSuperstars) {
                let requestData = {'teamId': tagTeam.$loki};
                await checkTalentRequestAction({company: company, requestType: 'disband_team', talent: superstar, data: requestData});
            }
        }
    }

    if (segmentItem.consequence === 'unify-titles') {
        let participantChampionships = (await Promise.all(participants[0].tempSuperstars.map(x => getSuperstarChampionships(x)))).flat();
        if (participants[0].objectName === 'superstar') {
            participantChampionships = participantChampionships.filter(x => !x.trio && !x.tagTeam);
        } else {
            if (participants[0].trio) {
                participantChampionships = participantChampionships.filter(x => x.trio || x.tagTeam);
            }
            else {
                participantChampionships = participantChampionships.filter(x => x.tagTeam);
            }
            participantChampionships = getUniqueChampionships(participantChampionships);
        }
        if (participantChampionships.length > 1) {
            let championshipName = null;
            if (segment.consequenceData) {
                championshipName = segment.consequenceData['objectName'];
            }
            data['unifiedChampionships'] = await unifyChampionships(participantChampionships, company,
                companyChampionships, game, championshipName);
        }
    }

    if (segmentItem.consequence === 'remove-mask') {
        for (const s of segmentSuperstars) {

            // Remove mask graphic
            if (s.graphic) {
                s.graphic = removeSuperstarGraphicMask(s.graphic);
            }

            maskRemoved.push({'name': s.name, 'possessivePronoun': s.possessivePronoun});

            // Next gimmick boost chance
            const addedNextGimmickBoost = await addNextGimmickBoost(s, 75);
            if (addedNextGimmickBoost && company.userControlled) {
                const talentManager = getRandomStaffMemberByRole(staffMembers, 'talent_manager');
                const newMessage = await createGimmickChangeBoostMessage(s, 'Unmasking', month, year, talentManager);
                await addCompanyMessages(company, [newMessage]);
            }

            // Update graphics
            if (graphics) {
                graphics = updateMatchOrSegmentGraphics(graphics, s);
                data['graphics'] = graphics;
            }

            // Check talent request
            await checkTalentRequestAction({company: company, requestType: 'change_appearance', talent: s});
        }
    }

    // Add feud potentials
    let requirementName = null;
    if (segmentItem.requirement === 'face-team-superstars') {
        requirementName = 'backstab';
    } else if (segmentItem.requirement === 'face-vs-face' && segmentItem.consequence === 'heel-turn') {
        requirementName = 'vicious-beatdown';
    } else if (segmentItem.requirement === 'face-vs-face-past-feud' && segmentItem.consequence === 'heel-turn') {
        requirementName = 'delayed-vengeance';
    } else if (segmentItem.requirement === 'heel-team-superstars') {
        requirementName = 'defying-a-villain';
    } else if (segmentItem.consequence === 'remove-managed-talent' && singles) {
        requirementName = 'client-betrayal';
    } else if (segmentItem.requirement === 'retiring' && segmentItem.consequence === 'heel-turn') {
        requirementName = 'retirement-fakeout';
    }
    if (requirementName) {
        const feudItem = feudItems.find(x => x.unlocked && x.requirement === requirementName);

        // Check for existing feud
        let existingFeud;
        for (const y of participants) {
            for (const f of (await getRosterMemberFeuds(y))) {
                if ((f.started && !f.ended) || (!f.started && f.directFeudEvent && !f.ended)) {
                    if ((await getFeudParticipants(f)).every(y => objectInArray(y, participants))) {
                        existingFeud = f;
                        break;
                    }
                }
            }
        }

        if (!existingFeud) {
            let feudParticipants = participants.slice(0, 2);
            const newFeud = Feud();
            await Feuds.insert(newFeud);
            newFeud.name = feudItem.name;
            newFeud.hype = feudItem.baseHype;
            const boosts = await getFeudCreationBoosts(newFeud, feudParticipants, month, year, company.style);
            const addedHype = boosts['hypeBoost'];
            newFeud.hype += addedHype;
            let turnHype = 0;
            if (shockingTurn) {
                turnHype = Math.floor((monthsAfterTurn / 12) * 10);
                if (turnHype > 50) {
                    turnHype = 50;
                }
                newFeud.hype += turnHype;
            }
            newFeud.participants = feudParticipants.map(s => s.name);
            newFeud.directFeudEvent = requirementName;
            newFeud.started = true;
            newFeud.startMonth = month;
            newFeud.startYear = year;
            await addFeudItemFeuds(feudItem, [newFeud]);
            await addRosterFeuds(mainRoster, [newFeud]);
            await addSegmentFeuds(segment, [newFeud]);
            if (singles) {
                await addFeudSuperstars(newFeud, feudParticipants)
            }
            else if (tag) {
                await addFeudTagTeams(newFeud, feudParticipants)
            }

            feudsStarted.push({
                'name': newFeud.name,
                'participants': feudParticipants.map(x => x.name),
                'boosts': boosts,
                'baseHype': feudItem.baseHype,
                'shocking': shockingTurn,
                'turnHype': turnHype
            });

            // Check talent request
            for (const feudParticipant of feudParticipants) {
                const otherFeudParticipant = feudParticipants.find(x => x.$loki !== feudParticipant.$loki);
                if (otherFeudParticipant) {
                    let requestData = {'talentId': otherFeudParticipant.$loki};
                    await checkTalentRequestAction({company: company, requestType: 'feud_with_x', talent: feudParticipant,
                        data: requestData});
                }
            }
        }
        // Add hype to existing feud
        else {
            const hypeIncrease = feudItem.baseHype;
            existingFeud.hype += hypeIncrease;
            feudHypeIncreased.push({
                'name': existingFeud.name,
                'participants': participants.map(x => x.name),
                'hypeIncrease': hypeIncrease,
                'newFeud': feudItem.name
            });
        }
    }

    // Add next gimmick boost for shocking turn
    if (shockingTurn && applyConsequenceTo) {
        for (const s of applyConsequenceTo.tempSuperstars) {
            const addedNextGimmickBoost = await addNextGimmickBoost(s, 100);
            if (addedNextGimmickBoost && company.userControlled) {
                const talentManager = getRandomStaffMemberByRole(staffMembers, 'talent_manager');
                const newMessage = await createGimmickChangeBoostMessage(s, 'Shocking Turn', month, year,
                    talentManager);
                await addCompanyMessages(company, [newMessage]);
            }
        }
    }

    data['vacated'] = vacated;
    data['fired'] = fired;
    data['feudsEnded'] = feudsEnded;
    data['awarded'] = awarded;
    data['feudItemsLevelData'] = feudItemsLevelData;
    data['unlockedFeudItems'] = unlockedFeudItems;
    data['turnedHeel'] = turnedHeel;
    data['turnedFace'] = turnedFace;
    data['turnedNeutral'] = turnedNeutral;
    data['feudsStarted'] = feudsStarted;
    data['feudPotentials'] = feudPotentials;
    data['feudHypeIncreased'] = feudHypeIncreased;
    data['disbanded'] = disbanded;
    data['shockingTurn'] = shockingTurn;
    data['turnTooSoon'] = turnTooSoon;
    data['consequenceRunOn'] = consequenceRunOn;
    data['createdChampionships'] = createdChampionships;
    data['unavailable'] = unavailable;
    data['suspended'] = suspended;
    data['retirements'] = retirements;
    data['teamsCreated'] = teamsCreated;
    data['factionSegmentConsequence'] = factionSegmentConsequence;
    data['factionReputationsData'] = factionReputationsData;
    data['managersAdded'] = managersAdded;
    data['managersRemoved'] = managersRemoved;
    data['brandChanges'] = brandChanges;
    data['maskRemoved'] = maskRemoved;

    return data;
}

function getSegmentEventHypeBoost(rating, hypeBoost) {  // get_segment_event_hype_boost
    const baseHypes = {1: 2, 2: 4, 3: 6};
    let hypeChange = baseHypes[hypeBoost] || 0;
    let ratingMultiplier = ((rating - 3) * 0.5);
    if (rating >= 4.5) {
        ratingMultiplier += 0.25;
    } else if (rating < 2) {
        ratingMultiplier -= 0.75;
    }
    hypeChange += Math.round(hypeChange * ratingMultiplier);
    return hypeChange;
}

function getMainEventHypeBoost(rating, hypeBoost) { // get_main_event_hype_boost
    const baseHypes = {1: 4, 2: 8, 3: 12};
    let hypeChange = baseHypes[hypeBoost] || 0;
    let ratingMultiplier = ((rating - 3) * 0.5);
    if (rating >= 4.5) {
        ratingMultiplier += 0.25;
    } else if (rating < 2) {
        ratingMultiplier -= 0.75;
    }
    hypeChange += Math.round(hypeChange * ratingMultiplier);
    return hypeChange;
}

function getSegmentPopularityBoost(rating, popularityBoost) { // get_segment_popularity_boost
    const baseHypes = {1: 3, 2: 6, 3: 10};
    let hypeChange = baseHypes[popularityBoost] || 0;
    let ratingMultiplier = ((rating - 3) * 0.5);
    if (rating >= 4.5) {
        ratingMultiplier += 0.25;
    } else if (rating < 2) {
        ratingMultiplier -= 0.75;
    }
    hypeChange += Math.round(hypeChange * ratingMultiplier);
    return hypeChange;
}

function checkProducerSegmentItemsToUnlock(producer, allSegmentItems) {  // check_producer_segment_items_to_unlock
    // Check for segment item unlocks, unlocking them
    const unlocksDict = {
        2: ['Debut Package', 'Return Package', 'Champion Package'],
        3: ['Career Package', 'Day in the Life']
    };

    for (const [level, items] of Object.entries(unlocksDict)) {
        if (producer.level >= level) {
            for (const itemName of items) {
                const itemToUnlock = allSegmentItems.find(x => x.name === itemName);
                if (itemToUnlock && !itemToUnlock.unlocked) {
                    itemToUnlock.unlocked = true;
                }
            }
        }
    }
    return true;
}

async function introduceSpecialSegmentsView() {  // introduce_special_segments_view
    let data = {};
    let currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const user = loadUser();

    if (!currentGame.settings['unlock_all_items']) {
        if (currentGame.monthCount === 4 && currentGame.year === 0 && userCompany.storyName !== 'mars') {
            data['specialSegmentIntroduced'] = await introduceSpecialSegments(userCompany, currentGame, user);
        }
    }

    // Get data to return
    const unreadMessages = await getCompanyUnreadMessages(userCompany);
    data['unreadMessages'] = unreadMessages.length;

    db.saveDatabase();

    return data;
}

async function introduceSpecialSegments(company, game, user) {  // introduce_special_segments
    let stuntDive = (await getCompanySegmentItems(company)).find(x => x.special === true && x.name === 'Stunt Dive');

    if (stuntDive && !stuntDive.unlocked && globalUser.paid) {
        // Unlock stunt dive
        await unlockSpecialSegment(company, stuntDive.name, game.monthCount, game.year, false)
        // Unlock user segments, if any
        let userSegmentsToUnlock = (await getCompanySegmentItems(company))
            .filter(x => user.unlockedSegments.includes(x.name) && x.$loki !== stuntDive.$loki);
        for (let segmentToUnlock of userSegmentsToUnlock) {
            segmentToUnlock.unlocked = true;
        }

        // Add introduce special segments message
        if (company.userControlled) {
            let newMessage = await createIntroduceSpecialSegmentsMessage(stuntDive, company, userSegmentsToUnlock.length);
            await addCompanyMessages(company, [newMessage]);
        }

        return true;
    }
    return false;
}

export {getSegmentItemData, getSpecialSegmentHistoryData, getSpecialSegmentsData, getSegmentData, getSegmentHistoryData,
    getAvailableSegmentItems, createCustomProductionPackage, checkSegmentItemRequirement,
    getSegmentInputsData, getSegmentName, bookSegment, deleteCompanySegment, addProducerToSegment, playSegment,
    removeProducerFromSegment, deleteSegment, getSegmentConsequenceAppliedTo, getHypeForFeuds, getHypeForParticipants,
    updateSuperstarCharisma, checkProducerSegmentItemsToUnlock, introduceSpecialSegmentsView, processPlaySegment,
    getHypeForSegment, introduceSpecialSegments}